! function(e) {
	function t(r) {
		if (n[r]) return n[r].exports;
		var o = n[r] = {
			i: r,
			l: !1,
			exports: {}
		};
		return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports
	}
	var n = {};
	t.m = e, t.c = n, t.d = function(e, n, r) {
		t.o(e, n) || Object.defineProperty(e, n, {
			enumerable: !0,
			get: r
		})
	}, t.r = function(e) {
		"undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(
			e, Symbol.toStringTag, {
				value: "Module"
			}), Object.defineProperty(e, "__esModule", {
			value: !0
		})
	}, t.t = function(e, n) {
		if (1 & n && (e = t(e)), 8 & n) return e;
		if (4 & n && "object" == typeof e && e && e.__esModule) return e;
		var r = Object.create(null);
		if (t.r(r), Object.defineProperty(r, "default", {
				enumerable: !0,
				value: e
			}), 2 & n && "string" != typeof e)
			for (var o in e) t.d(r, o, function(t) {
				return e[t]
			}.bind(null, o));
		return r
	}, t.n = function(e) {
		var n = e && e.__esModule ? function() {
			return e.default
		} : function() {
			return e
		};
		return t.d(n, "a", n), n
	}, t.o = function(e, t) {
		return Object.prototype.hasOwnProperty.call(e, t)
	}, t.p = Shopify.cdn, t(t.s = 4)
}([function(e) {
		function t(e) {
			$.ajax({
				url: "/cart",
				success: function(t) {
					if (e) {
						var n = $(t).find(".widget-cart-container .widget__container").html(),
							r = $(t).find(".cart-global-total small");
						$(".js-widget-cart .widget__container").html(n), $(
							".js-btn-cart small").html(r), $(".js-widget-cart").addClass(
							"expanded")
					} else {
						var o = $($(t).find(".js-section-cart").html()),
							i = $(t).find(".cart-global-total small");
						$(".js-section-cart").html(o), $(".js-btn-cart small").html(i)
					}
				}
			})
		}
		e.exports = {
			addToCart: function(e, n) {
				"selectasize" === $(".custom-select").val() && 767 >= $(window).width() ?
					alert("Please select a size") : $.ajax({
						url: "/cart/add.js",
						method: "POST",
						dataType: "json",
						data: e.serialize(),
						success: function() {
							t(n)
						},
						error: function(e) {
							alert(e.responseJSON.description)
						}
					})
			},
			updateCart: function(e, n, r) {
				if (void 0 === r) {
					$.ajax({
						url: "/cart/update.js",
						dataType: "json",
						data: e.serialize(),
						success: function() {
							n ? t(n) : t()
						},
						error: function(e) {
							alert(e.responseJSON.description)
						}
					})
				} else {
					var update = `updates[${r}]=0`
					$.post("/cart/update.js", update).done((function() {
						n ? t(n) : t()
					})).fail((function(e) {
						n ? t(n) : t()
						return console.log(e)
					}))
				}
			},
			ajaxCart: t
		}
	}, function(e, t, n) {
		function r(e) {
			return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ?
				function(e) {
					return typeof e
				} : function(e) {
					return e && "function" == typeof Symbol && e.constructor === Symbol && e !==
						Symbol.prototype ? "symbol" : typeof e
				})(e)
		}
		/*!
		 * JavaScript Cookie v2.2.1
		 * https://github.com/js-cookie/js-cookie
		 *
		 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
		 * Released under the MIT license
		 */
		var o, i;
		! function(a) {
			var s;
			if (void 0 !== (i = "function" == typeof(o = a) ? o.call(t, n, t, e) : o) &&
				(e.exports = i), s = !0, "object" === r(t) && (e.exports = a(), s = !0), !
				s) {
				var c = window.Cookies,
					l = window.Cookies = a();
				l.noConflict = function() {
					return window.Cookies = c, l
				}
			}
		}((function() {
			function e() {
				for (var e = 0, t = {}; e < arguments.length; e++) {
					var n = arguments[e];
					for (var r in n) t[r] = n[r]
				}
				return t
			}

			function t(e) {
				return e.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent)
			}
			return function n(r) {
				function o() {}

				function i(t, n, i) {
					if ("undefined" != typeof document) {
						"number" == typeof(i = e({
							path: "/"
						}, o.defaults, i)).expires && (i.expires = new Date(1 * new Date +
								864e5 * i.expires)), i.expires = i.expires ? i.expires.toUTCString() :
							"";
						try {
							var a = JSON.stringify(n);
							/^[\{\[]/.test(a) && (n = a)
						} catch (t) {}
						n = r.write ? r.write(n, t) : encodeURIComponent(n + "").replace(
							/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
							decodeURIComponent), t = encodeURIComponent(t + "").replace(
							/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g,
							escape);
						var s = "";
						for (var c in i) i[c] && (s += "; " + c, !0 !== i[c]) && (s += "=" +
							i[c].split(";")[0]);
						return document.cookie = t + "=" + n + s
					}
				}

				function a(e, n) {
					if ("undefined" != typeof document) {
						for (var o = {}, i = document.cookie ? document.cookie.split("; ") : [],
								a = 0; a < i.length; a++) {
							var s = i[a].split("="),
								c = s.slice(1).join("=");
							n || '"' !== c.charAt(0) || (c = c.slice(1, -1));
							try {
								var l = t(s[0]);
								if (c = (r.read || r)(c, l) || t(c), n) try {
									c = JSON.parse(c)
								} catch (e) {}
								if (o[l] = c, e === l) break
							} catch (e) {}
						}
						return e ? o[e] : o
					}
				}
				return o.set = i, o.get = function(e) {
					return a(e, !1)
				}, o.getJSON = function(e) {
					return a(e, !0)
				}, o.remove = function(t, n) {
					i(t, "", e(n, {
						expires: -1
					}))
				}, o.defaults = {}, o.withConverter = n, o
			}((function() {}))
		}))
	}, function(e) {
		e.exports = {
			productItemHover: function(e, t) {
				var n = e.prev().data("index"),
					r = e.closest(".js-product-item").find(".product-item__image figure").eq(
						n);
				t ? r.addClass("hovered").parent().addClass("hovered") : r.removeClass(
					"hovered").parent().removeClass("hovered")
			}
		}
	}, function(e, t, n) {
		/*! Magnific Popup - v1.1.0 - 2016-02-20
		 * http://dimsemenov.com/plugins/magnific-popup/
		 * Copyright (c) 2016 Dmitry Semenov; */
		var r, o, i;
		o = [n(7)], r = function(e) {
			var t, n, r, o, i, a, s = "Close",
				c = "BeforeClose",
				l = "MarkupParse",
				u = "Open",
				d = "Change",
				f = "mfp",
				p = ".mfp",
				h = "mfp-ready",
				m = "mfp-removing",
				g = "mfp-prevent-close",
				v = function() {},
				y = !!window.jQuery,
				b = e(window),
				x = function(e, n) {
					t.ev.on(f + e + p, n)
				},
				w = function(t, n, r, o) {
					var i = document.createElement("div");
					return i.className = "mfp-" + t, r && (i.innerHTML = r), o ? n && n.appendChild(
						i) : (i = e(i), n && i.appendTo(n)), i
				},
				C = function(n, r) {
					t.ev.triggerHandler(f + n, r), t.st.callbacks && (n = n.charAt(0).toLowerCase() +
						n.slice(1), t.st.callbacks[n] && t.st.callbacks[n].apply(t, e.isArray(
							r) ? r : [r]))
				},
				T = function(n) {
					return n === a && t.currTemplate.closeBtn || (t.currTemplate.closeBtn =
							e(t.st.closeMarkup.replace("%title%", t.st.tClose)), a = n), t.currTemplate
						.closeBtn
				},
				k = function() {
					e.magnificPopup.instance || ((t = new v).init(), e.magnificPopup.instance =
						t)
				};
			v.prototype = {
				constructor: v,
				init: function() {
					var n = navigator.appVersion;
					t.isLowIE = t.isIE8 = document.all && !document.addEventListener, t.isAndroid =
						/android/gi.test(n), t.isIOS = /iphone|ipad|ipod/gi.test(n), t.supportsTransition =
						function() {
							var e = document.createElement("p").style,
								t = ["ms", "O", "Moz", "Webkit"];
							if (void 0 !== e.transition) return !0;
							for (; t.length;)
								if (t.pop() + "Transition" in e) return !0;
							return !1
						}(), t.probablyMobile = t.isAndroid || t.isIOS ||
						/(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i
						.test(navigator.userAgent), r = e(document), t.popupsCache = {}
				},
				open: function(n) {
					var o;
					if (!1 === n.isObj) {
						t.items = n.items.toArray(), t.index = 0;
						var a, s = n.items;
						for (o = 0; o < s.length; o++)
							if ((a = s[o]).parsed && (a = a.el[0]), a === n.el[0]) {
								t.index = o;
								break
							}
					} else t.items = e.isArray(n.items) ? n.items : [n.items], t.index = n
						.index || 0;
					if (!t.isOpen) {
						t.types = [], i = "", t.ev = n.mainEl && n.mainEl.length ? n.mainEl.eq(
								0) : r, n.key ? (!t.popupsCache[n.key] && (t.popupsCache[n.key] = {}),
								t.currTemplate = t.popupsCache[n.key]) : t.currTemplate = {}, t.st =
							e.extend(!0, {}, e.magnificPopup.defaults, n), t.fixedContentPos =
							"auto" === t.st.fixedContentPos ? !t.probablyMobile : t.st.fixedContentPos,
							t.st.modal && (t.st.closeOnContentClick = !1, t.st.closeOnBgClick = !
								1, t.st.showCloseBtn = !1, t.st.enableEscapeKey = !1), t.bgOverlay ||
							(t.bgOverlay = w("bg").on("click" + p, (function() {
								t.close()
							})), t.wrap = w("wrap").attr("tabindex", -1).on("click" + p, (
								function(e) {
									t._checkIfClose(e.target) && t.close()
								})), t.container = w("container", t.wrap)), t.contentContainer = w(
								"content"), t.st.preloader && (t.preloader = w("preloader", t.container,
								t.st.tLoading));
						var c = e.magnificPopup.modules;
						for (o = 0; o < c.length; o++) {
							var d = c[o];
							d = d.charAt(0).toUpperCase() + d.slice(1), t["init" + d].call(t)
						}
						C("BeforeOpen"), t.st.showCloseBtn && (t.st.closeBtnInside ? (x(l, (
								function(e, t, n, r) {
									n.close_replaceWith = T(r.type)
								})), i += " mfp-close-btn-in") : t.wrap.append(T())), t.st.alignTop &&
							(i += " mfp-align-top"), t.fixedContentPos ? t.wrap.css({
								overflow: t.st.overflowY,
								overflowX: "hidden",
								overflowY: t.st.overflowY
							}) : t.wrap.css({
								top: b.scrollTop(),
								position: "absolute"
							}), !1 !== t.st.fixedBgPos && ("auto" !== t.st.fixedBgPos || t.fixedContentPos) ||
							t.bgOverlay.css({
								height: r.height(),
								position: "absolute"
							}), t.st.enableEscapeKey && r.on("keyup" + p, (function(e) {
								27 === e.keyCode && t.close()
							})), b.on("resize" + p, (function() {
								t.updateSize()
							})), t.st.closeOnContentClick || (i += " mfp-auto-cursor"), i && t.wrap
							.addClass(i);
						var f = t.wH = b.height(),
							m = {};
						if (t.fixedContentPos && t._hasScrollBar(f)) {
							var g = t._getScrollbarSize();
							g && (m.marginRight = g)
						}
						t.fixedContentPos && (t.isIE7 ? e("body, html").css("overflow",
							"hidden") : m.overflow = "hidden");
						var v = t.st.mainClass;
						return t.isIE7 && (v += " mfp-ie7"), v && t._addClassToMFP(v), t.updateItemHTML(),
							C("BuildControls"), e("html").css(m), t.bgOverlay.add(t.wrap).prependTo(
								t.st.prependTo || e(document.body)), t._lastFocusedEl = document.activeElement,
							setTimeout((function() {
								t.content ? (t._addClassToMFP(h), t._setFocus()) : t.bgOverlay.addClass(
									h), r.on("focusin" + p, t._onFocusIn)
							}), 16), t.isOpen = !0, t.updateSize(f), C(u), n
					}
					t.updateItemHTML()
				},
				close: function() {
					t.isOpen && (C(c), t.isOpen = !1, t.st.removalDelay && !t.isLowIE && t
						.supportsTransition ? (t._addClassToMFP(m), setTimeout((function() {
							t._close()
						}), t.st.removalDelay)) : t._close())
				},
				_close: function() {
					C(s);
					var n = m + " " + h + " ";
					if (t.bgOverlay.detach(), t.wrap.detach(), t.container.empty(), t.st.mainClass &&
						(n += t.st.mainClass + " "), t._removeClassFromMFP(n), t.fixedContentPos
					) {
						var o = {
							marginRight: ""
						};
						t.isIE7 ? e("body, html").css("overflow", "") : o.overflow = "", e(
							"html").css(o)
					}
					r.off("keyup.mfp focusin" + p), t.ev.off(p), t.wrap.attr("class",
							"mfp-wrap").removeAttr("style"), t.bgOverlay.attr("class", "mfp-bg"),
						t.container.attr("class", "mfp-container"), t.st.showCloseBtn && (!t.st
							.closeBtnInside || !0 === t.currTemplate[t.currItem.type]) && t.currTemplate
						.closeBtn && t.currTemplate.closeBtn.detach(), t.st.autoFocusLast &&
						t._lastFocusedEl && e(t._lastFocusedEl).focus(), t.currItem = null, t
						.content = null, t.currTemplate = null, t.prevHeight = 0, C(
							"AfterClose")
				},
				updateSize: function(e) {
					if (t.isIOS) {
						var n = document.documentElement.clientWidth / window.innerWidth,
							r = window.innerHeight * n;
						t.wrap.css("height", r), t.wH = r
					} else t.wH = e || b.height();
					t.fixedContentPos || t.wrap.css("height", t.wH), C("Resize")
				},
				updateItemHTML: function() {
					var n = t.items[t.index];
					t.contentContainer.detach(), t.content && t.content.detach(), n.parsed ||
						(n = t.parseEl(t.index));
					var r = n.type;
					if (C("BeforeChange", [t.currItem ? t.currItem.type : "", r]), t.currItem =
						n, !t.currTemplate[r]) {
						var i = !!t.st[r] && t.st[r].markup;
						C("FirstMarkupParse", i), t.currTemplate[r] = !i || e(i)
					}
					o && o !== n.type && t.container.removeClass("mfp-" + o + "-holder");
					var a = t["get" + r.charAt(0).toUpperCase() + r.slice(1)](n, t.currTemplate[
						r]);
					t.appendContent(a, r), n.preloaded = !0, C(d, n), o = n.type, t.container
						.prepend(t.contentContainer), C("AfterChange")
				},
				appendContent: function(e, n) {
					t.content = e, e ? t.st.showCloseBtn && t.st.closeBtnInside && !0 ===
						t.currTemplate[n] ? !t.content.find(".mfp-close").length && t.content
						.append(T()) : t.content = e : t.content = "", C("BeforeAppend"), t.container
						.addClass("mfp-" + n + "-holder"), t.contentContainer.append(t.content)
				},
				parseEl: function(n) {
					var r, o = t.items[n];
					if (o.tagName ? o = {
							el: e(o)
						} : (r = o.type, o = {
							data: o,
							src: o.src
						}), o.el) {
						for (var i = t.types, a = 0; a < i.length; a++)
							if (o.el.hasClass("mfp-" + i[a])) {
								r = i[a];
								break
							}
						o.src = o.el.attr("data-mfp-src"), o.src || (o.src = o.el.attr("href"))
					}
					return o.type = r || t.st.type || "inline", o.index = n, o.parsed = !0,
						t.items[n] = o, C("ElementParse", o), t.items[n]
				},
				addGroup: function(e, n) {
					var r = function(r) {
						r.mfpEl = this, t._openClick(r, e, n)
					};
					n || (n = {});
					var o = "click.magnificPopup";
					n.mainEl = e, n.items ? (n.isObj = !0, e.off(o).on(o, r)) : (n.isObj = !
						1, n.delegate ? e.off(o).on(o, n.delegate, r) : (n.items = e, e.off(
							o).on(o, r)))
				},
				_openClick: function(n, r, o) {
					if ((void 0 === o.midClick ? e.magnificPopup.defaults.midClick : o.midClick) ||
						!(2 === n.which || n.ctrlKey || n.metaKey || n.altKey || n.shiftKey)) {
						var i = void 0 === o.disableOn ? e.magnificPopup.defaults.disableOn :
							o.disableOn;
						if (i)
							if (e.isFunction(i)) {
								if (!i.call(t)) return !0
							} else if (b.width() < i) return !0;
						n.type && (n.preventDefault(), t.isOpen && n.stopPropagation()), o.el =
							e(n.mfpEl), o.delegate && (o.items = r.find(o.delegate)), t.open(o)
					}
				},
				updateStatus: function(e, r) {
					if (t.preloader) {
						n !== e && t.container.removeClass("mfp-s-" + n), r || "loading" !==
							e || (r = t.st.tLoading);
						var o = {
							status: e,
							text: r
						};
						C("UpdateStatus", o), e = o.status, r = o.text, t.preloader.html(r),
							t.preloader.find("a").on("click", (function(e) {
								e.stopImmediatePropagation()
							})), t.container.addClass("mfp-s-" + e), n = e
					}
				},
				_checkIfClose: function(n) {
					if (!e(n).hasClass(g)) {
						var r = t.st.closeOnContentClick,
							o = t.st.closeOnBgClick;
						if (r && o) return !0;
						if (!t.content || e(n).hasClass("mfp-close") || t.preloader && n ===
							t.preloader[0]) return !0;
						if (n === t.content[0] || e.contains(t.content[0], n)) {
							if (r) return !0
						} else if (o && e.contains(document, n)) return !0;
						return !1
					}
				},
				_addClassToMFP: function(e) {
					t.bgOverlay.addClass(e), t.wrap.addClass(e)
				},
				_removeClassFromMFP: function(e) {
					this.bgOverlay.removeClass(e), t.wrap.removeClass(e)
				},
				_hasScrollBar: function(e) {
					return (t.isIE7 ? r.height() : document.body.scrollHeight) > (e || b.height())
				},
				_setFocus: function() {
					(t.st.focus ? t.content.find(t.st.focus).eq(0) : t.wrap).focus()
				},
				_onFocusIn: function(n) {
					if (n.target !== t.wrap[0] && !e.contains(t.wrap[0], n.target)) return
						t._setFocus(), !1
				},
				_parseMarkup: function(t, n, r) {
					var o;
					r.data && (n = e.extend(r.data, n)), C(l, [t, n, r]), e.each(n, (
						function(n, r) {
							if (void 0 === r || !1 === r) return !0;
							if (1 < (o = n.split("_")).length) {
								var i = t.find(p + "-" + o[0]);
								if (0 < i.length) {
									var a = o[1];
									"replaceWith" === a ? i[0] !== r[0] && i.replaceWith(r) : "img" ===
										a ? i.is("img") ? i.attr("src", r) : i.replaceWith(e("<img>").attr(
											"src", r).attr("class", i.attr("class"))) : i.attr(o[1], r)
								}
							} else t.find(p + "-" + n).html(r)
						}))
				},
				_getScrollbarSize: function() {
					if (void 0 === t.scrollbarSize) {
						var e = document.createElement("div");
						e.style.cssText =
							"width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;",
							document.body.appendChild(e), t.scrollbarSize = e.offsetWidth - e.clientWidth,
							document.body.removeChild(e)
					}
					return t.scrollbarSize
				}
			}, e.magnificPopup = {
				instance: null,
				proto: v.prototype,
				modules: [],
				open: function(t, n) {
					return k(), (t = t ? e.extend(!0, {}, t) : {}).isObj = !0, t.index = n ||
						0, this.instance.open(t)
				},
				close: function() {
					return e.magnificPopup.instance && e.magnificPopup.instance.close()
				},
				registerModule: function(t, n) {
					n.options && (e.magnificPopup.defaults[t] = n.options), e.extend(this.proto,
						n.proto), this.modules.push(t)
				},
				defaults: {
					disableOn: 0,
					key: null,
					midClick: !1,
					mainClass: "",
					preloader: !0,
					focus: "",
					closeOnContentClick: !1,
					closeOnBgClick: !0,
					closeBtnInside: !0,
					showCloseBtn: !0,
					enableEscapeKey: !0,
					modal: !1,
					alignTop: !1,
					removalDelay: 0,
					prependTo: null,
					fixedContentPos: "auto",
					fixedBgPos: "auto",
					overflowY: "auto",
					closeMarkup: '<button title="%title%" type="button" class="mfp-close">&#215;</button>',
					tClose: "Close (Esc)",
					tLoading: "Loading...",
					autoFocusLast: !0
				}
			}, e.fn.magnificPopup = function(n) {
				k();
				var r = e(this);
				if ("string" != typeof n) n = e.extend(!0, {}, n), y ? r.data(
					"magnificPopup", n) : r[0].magnificPopup = n, t.addGroup(r, n);
				else if ("open" === n) {
					var o, i = y ? r.data("magnificPopup") : r[0].magnificPopup,
						a = parseInt(arguments[1], 10) || 0;
					i.items ? o = i.items[a] : (o = r, i.delegate && (o = o.find(i.delegate)),
						o = o.eq(a)), t._openClick({
						mfpEl: o
					}, r, i)
				} else t.isOpen && t[n].apply(t, Array.prototype.slice.call(arguments, 1));
				return r
			};
			var _, S, j, $ = "inline",
				E = function() {
					j && (S.after(j.addClass(_)).detach(), j = null)
				};
			e.magnificPopup.registerModule($, {
				options: {
					hiddenClass: "hide",
					markup: "",
					tNotFound: "Content not found"
				},
				proto: {
					initInline: function() {
						t.types.push($), x(s + "." + $, (function() {
							E()
						}))
					},
					getInline: function(n, r) {
						if (E(), n.src) {
							var o = t.st.inline,
								i = e(n.src);
							if (i.length) {
								var a = i[0].parentNode;
								a && a.tagName && (!S && (_ = o.hiddenClass, S = w(_), _ = "mfp-" +
									_), j = i.after(S).detach().removeClass(_)), t.updateStatus(
									"ready")
							} else t.updateStatus("error", o.tNotFound), i = e("<div>");
							return n.inlineElement = i, i
						}
						return t.updateStatus("ready"), t._parseMarkup(r, {}, n), r
					}
				}
			});
			var A, D = "ajax",
				N = function() {
					A && e(document.body).removeClass(A)
				},
				L = function() {
					N(), t.req && t.req.abort()
				};
			e.magnificPopup.registerModule(D, {
				options: {
					settings: null,
					cursor: "mfp-ajax-cur",
					tError: '<a href="%url%">The content</a> could not be loaded.'
				},
				proto: {
					initAjax: function() {
						t.types.push(D), A = t.st.ajax.cursor, x(s + "." + D, L), x(
							"BeforeChange." + D, L)
					},
					getAjax: function(n) {
						A && e(document.body).addClass(A), t.updateStatus("loading");
						var r = e.extend({
							url: n.src,
							success: function(r, o, i) {
								var a = {
									data: r,
									xhr: i
								};
								C("ParseAjax", a), t.appendContent(e(a.data), D), n.finished = !
									0, N(), t._setFocus(), setTimeout((function() {
										t.wrap.addClass(h)
									}), 16), t.updateStatus("ready"), C("AjaxContentAdded")
							},
							error: function() {
								N(), n.finished = n.loadError = !0, t.updateStatus("error", t.st
									.ajax.tError.replace("%url%", n.src))
							}
						}, t.st.ajax.settings);
						return t.req = e.ajax(r), ""
					}
				}
			});
			var I, O, P = function(n) {
				if (n.data && void 0 !== n.data.title) return n.data.title;
				var r = t.st.image.titleSrc;
				if (r) {
					if (e.isFunction(r)) return r.call(t, n);
					if (n.el) return n.el.attr(r) || ""
				}
				return ""
			};
			e.magnificPopup.registerModule("image", {
				options: {
					markup: '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
					cursor: "mfp-zoom-out-cur",
					titleSrc: "title",
					verticalFit: !0,
					tError: '<a href="%url%">The image</a> could not be loaded.'
				},
				proto: {
					initImage: function() {
						var n = t.st.image,
							r = ".image";
						t.types.push("image"), x(u + r, (function() {
							"image" === t.currItem.type && n.cursor && e(document.body).addClass(
								n.cursor)
						})), x(s + r, (function() {
							n.cursor && e(document.body).removeClass(n.cursor), b.off(
								"resize" + p)
						})), x("Resize" + r, t.resizeImage), t.isLowIE && x("AfterChange",
							t.resizeImage)
					},
					resizeImage: function() {
						var e = t.currItem;
						if (e && e.img && t.st.image.verticalFit) {
							var n = 0;
							t.isLowIE && (n = parseInt(e.img.css("padding-top"), 10) + parseInt(
								e.img.css("padding-bottom"), 10)), e.img.css("max-height", t.wH -
								n)
						}
					},
					_onImageHasSize: function(e) {
						e.img && (e.hasSize = !0, I && clearInterval(I), e.isCheckingImgSize = !
							1, C("ImageHasSize", e), e.imgHidden && (t.content && t.content.removeClass(
								"mfp-loading"), e.imgHidden = !1))
					},
					findImageSize: function(e) {
						var n = 0,
							r = e.img[0];
						! function o(i) {
							I && clearInterval(I), I = setInterval((function() {
								return 0 < r.naturalWidth ? void t._onImageHasSize(e) : (200 <
									n && clearInterval(I), void(3 == ++n ? o(10) : 40 == n ? o(50) :
										100 == n && o(500)))
							}), i)
						}(1)
					},
					getImage: function(n, r) {
						var o = 0,
							i = function() {
								n && (n.img.off(".mfploader"), n === t.currItem && (t._onImageHasSize(
										n), t.updateStatus("error", a.tError.replace("%url%", n.src))),
									n.hasSize = !0, n.loaded = !0, n.loadError = !0)
							},
							a = t.st.image,
							s = r.find(".mfp-img");
						if (s.length) {
							var c = document.createElement("img");
							c.className = "mfp-img", n.el && n.el.find("img").length && (c.alt =
									n.el.find("img").attr("alt")), n.img = e(c).on("load.mfploader", (
									function e() {
										n && (n.img[0].complete ? (n.img.off(".mfploader"), n === t.currItem &&
												(t._onImageHasSize(n), t.updateStatus("ready")), n.hasSize = !
												0, n.loaded = !0, C("ImageLoadComplete")) : 200 > ++o ?
											setTimeout(e, 100) : i())
									})).on("error.mfploader", i), c.src = n.src, s.is("img") && (n.img =
									n.img.clone()), 0 < (c = n.img[0]).naturalWidth ? n.hasSize = !0 :
								!c.width && (n.hasSize = !1)
						}
						return t._parseMarkup(r, {
							title: P(n),
							img_replaceWith: n.img
						}, n), t.resizeImage(), n.hasSize ? (I && clearInterval(I), n.loadError ?
							(r.addClass("mfp-loading"), t.updateStatus("error", a.tError.replace(
								"%url%", n.src))) : (r.removeClass("mfp-loading"), t.updateStatus(
								"ready")), r) : (t.updateStatus("loading"), n.loading = !0, n.hasSize ||
							(n.imgHidden = !0, r.addClass("mfp-loading"), t.findImageSize(n)),
							r)
					}
				}
			}), e.magnificPopup.registerModule("zoom", {
				options: {
					enabled: !1,
					easing: "ease-in-out",
					duration: 300,
					opener: function(e) {
						return e.is("img") ? e : e.find("img")
					}
				},
				proto: {
					initZoom: function() {
						var e, n = t.st.zoom,
							r = ".zoom";
						if (n.enabled && t.supportsTransition) {
							var o, i, a = n.duration,
								l = function(e) {
									var t = e.clone().removeAttr("style").removeAttr("class").addClass(
											"mfp-animated-image"),
										r = "all " + n.duration / 1e3 + "s " + n.easing,
										o = {
											position: "fixed",
											zIndex: 9999,
											left: 0,
											top: 0,
											"-webkit-backface-visibility": "hidden"
										},
										i = "transition";
									return o["-webkit-" + i] = o["-moz-" + i] = o["-o-" + i] = o[i] =
										r, t.css(o), t
								},
								u = function() {
									t.content.css("visibility", "visible")
								};
							x("BuildControls" + r, (function() {
								if (t._allowZoom()) {
									if (clearTimeout(o), t.content.css("visibility", "hidden"), !(
											e = t._getItemToZoom())) return void u();
									(i = l(e)).css(t._getOffset()), t.wrap.append(i), o =
										setTimeout((function() {
											i.css(t._getOffset(!0)), o = setTimeout((function() {
												u(), setTimeout((function() {
													i.remove(), e = i = null, C("ZoomAnimationEnded")
												}), 16)
											}), a)
										}), 16)
								}
							})), x(c + r, (function() {
								if (t._allowZoom()) {
									if (clearTimeout(o), t.st.removalDelay = a, !e) {
										if (!(e = t._getItemToZoom())) return;
										i = l(e)
									}
									i.css(t._getOffset(!0)), t.wrap.append(i), t.content.css(
										"visibility", "hidden"), setTimeout((function() {
										i.css(t._getOffset())
									}), 16)
								}
							})), x(s + r, (function() {
								t._allowZoom() && (u(), i && i.remove(), e = null)
							}))
						}
					},
					_allowZoom: function() {
						return "image" === t.currItem.type
					},
					_getItemToZoom: function() {
						return !!t.currItem.hasSize && t.currItem.img
					},
					_getOffset: function(n) {
						var r = n ? t.currItem.img : t.st.zoom.opener(t.currItem.el || t.currItem),
							o = r.offset(),
							i = parseInt(r.css("padding-top"), 10),
							a = parseInt(r.css("padding-bottom"), 10);
						o.top -= e(window).scrollTop() - i;
						var s = {
							width: r.width(),
							height: (y ? r.innerHeight() : r[0].offsetHeight) - a - i
						};
						return void 0 === O && (O = void 0 !== document.createElement("p").style
								.MozTransform), O ? s["-moz-transform"] = s.transform =
							"translate(" + o.left + "px," + o.top + "px)" : (s.left = o.left, s
								.top = o.top), s
					}
				}
			});
			var q = "iframe",
				H = function(e) {
					if (t.currTemplate[q]) {
						var n = t.currTemplate[q].find("iframe");
						n.length && (!e && (n[0].src = "//about:blank"), t.isIE8 && n.css(
							"display", e ? "block" : "none"))
					}
				};
			e.magnificPopup.registerModule(q, {
				options: {
					markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
					srcAction: "iframe_src",
					patterns: {
						youtube: {
							index: "youtube.com",
							id: "v=",
							src: "//www.youtube.com/embed/%id%?autoplay=1"
						},
						vimeo: {
							index: "vimeo.com/",
							id: "/",
							src: "//player.vimeo.com/video/%id%?autoplay=1"
						},
						gmaps: {
							index: "//maps.google.",
							src: "%id%&output=embed"
						}
					}
				},
				proto: {
					initIframe: function() {
						t.types.push(q), x("BeforeChange", (function(e, t, n) {
							t !== n && (t === q ? H() : n === q && H(!0))
						})), x(s + "." + q, (function() {
							H()
						}))
					},
					getIframe: function(n, r) {
						var o = n.src,
							i = t.st.iframe;
						e.each(i.patterns, (function() {
							if (-1 < o.indexOf(this.index)) return this.id && (o = "string" ==
								typeof this.id ? o.substr(o.lastIndexOf(this.id) + this.id.length,
									o.length) : this.id.call(this, o)), o = this.src.replace(
								"%id%", o), !1
						}));
						var a = {};
						return i.srcAction && (a[i.srcAction] = o), t._parseMarkup(r, a, n),
							t.updateStatus("ready"), r
					}
				}
			});
			var M = function(e) {
					var n = t.items.length;
					return e > n - 1 ? e - n : 0 > e ? n + e : e
				},
				z = function(e, t, n) {
					return e.replace(/%curr%/gi, t + 1).replace(/%total%/gi, n)
				};
			e.magnificPopup.registerModule("gallery", {
				options: {
					enabled: !1,
					arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
					preload: [0, 2],
					navigateByImgClick: !0,
					arrows: !0,
					tPrev: "Previous (Left arrow key)",
					tNext: "Next (Right arrow key)",
					tCounter: "%curr% of %total%"
				},
				proto: {
					initGallery: function() {
						var n = t.st.gallery,
							o = ".mfp-gallery";
						return t.direction = !0, !(!n || !n.enabled) && (i += " mfp-gallery",
							x(u + o, (function() {
								n.navigateByImgClick && t.wrap.on("click" + o, ".mfp-img", (
									function() {
										if (1 < t.items.length) return t.next(), !1
									})), r.on("keydown" + o, (function(e) {
									37 === e.keyCode ? t.prev() : 39 === e.keyCode && t.next()
								}))
							})), x("UpdateStatus" + o, (function(e, n) {
								n.text && (n.text = z(n.text, t.currItem.index, t.items.length))
							})), x(l + o, (function(e, r, o, i) {
								var a = t.items.length;
								o.counter = 1 < a ? z(n.tCounter, i.index, a) : ""
							})), x("BuildControls" + o, (function() {
								if (1 < t.items.length && n.arrows && !t.arrowLeft) {
									var r = n.arrowMarkup,
										o = t.arrowLeft = e(r.replace(/%title%/gi, n.tPrev).replace(
											/%dir%/gi, "left")).addClass(g),
										i = t.arrowRight = e(r.replace(/%title%/gi, n.tNext).replace(
											/%dir%/gi, "right")).addClass(g);
									o.click((function() {
										t.prev()
									})), i.click((function() {
										t.next()
									})), t.container.append(o.add(i))
								}
							})), x(d + o, (function() {
								t._preloadTimeout && clearTimeout(t._preloadTimeout), t._preloadTimeout =
									setTimeout((function() {
										t.preloadNearbyImages(), t._preloadTimeout = null
									}), 16)
							})), void x(s + o, (function() {
								r.off(o), t.wrap.off("click" + o), t.arrowRight = t.arrowLeft =
									null
							})))
					},
					next: function() {
						t.direction = !0, t.index = M(t.index + 1), t.updateItemHTML()
					},
					prev: function() {
						t.direction = !1, t.index = M(t.index - 1), t.updateItemHTML()
					},
					goTo: function(e) {
						t.direction = e >= t.index, t.index = e, t.updateItemHTML()
					},
					preloadNearbyImages: function() {
						var e, n = Math.min,
							r = t.st.gallery.preload,
							o = n(r[0], t.items.length),
							i = n(r[1], t.items.length);
						for (e = 1; e <= (t.direction ? i : o); e++) t._preloadItem(t.index +
							e);
						for (e = 1; e <= (t.direction ? o : i); e++) t._preloadItem(t.index -
							e)
					},
					_preloadItem: function(n) {
						if (n = M(n), !t.items[n].preloaded) {
							var r = t.items[n];
							r.parsed || (r = t.parseEl(n)), C("LazyLoad", r), "image" === r.type &&
								(r.img = e('<img class="mfp-img" />').on("load.mfploader", (
									function() {
										r.hasSize = !0
									})).on("error.mfploader", (function() {
									r.hasSize = !0, r.loadError = !0, C("LazyLoadError", r)
								})).attr("src", r.src)), r.preloaded = !0
						}
					}
				}
			});
			var B = "retina";
			e.magnificPopup.registerModule(B, {
				options: {
					replaceSrc: function(e) {
						return e.src.replace(/\.\w+$/, (function(e) {
							return "@2x" + e
						}))
					},
					ratio: 1
				},
				proto: {
					initRetina: function() {
						if (1 < window.devicePixelRatio) {
							var e = t.st.retina,
								n = e.ratio;
							1 < (n = isNaN(n) ? n() : n) && (x("ImageHasSize." + B, (function(e,
								t) {
								t.img.css({
									"max-width": t.img[0].naturalWidth / n,
									width: "100%"
								})
							})), x("ElementParse." + B, (function(t, r) {
								r.src = e.replaceSrc(r, n)
							})))
						}
					}
				}
			}), k()
		}, void 0 === (i = "function" == typeof r ? r.apply(t, o) : r) || (e.exports =
			i)
	}, function(e, t, n) {
		n(22), e.exports = n(21)
	}, function() {
		$(document).ready((function() {
			$(".forgotten-pass, .loginfrom-link").on("click", (function(e) {
					e.preventDefault();
					var t = $(this),
						n = t.attr("href").replace("#", "");
					$(".".concat(n)).show(), t.closest("form").parent().hide()
				})), $(".addresses__actions .btn--new, .form--address-new .btn--cancel")
				.on("click", (function(e) {
					e.preventDefault();
					var t = $(this).attr("href").replace("#", "");
					$(".".concat(t)).toggle()
				})), $("#sortBy").on("change", (function() {
					Shopify.queryParams = {};
					var e = $(this).val();
					location.search && location.search.substr(1).split("&").map((
						function(e) {
							var t = e.split("=");
							Shopify.queryParams[decodeURIComponent(t[0])] =
								decodeURIComponent(t[1])
						}));
					Shopify.queryParams.sort_by = e, location.search = jQuery.param(
						Shopify.queryParams)
				})), $(".product-single__variants").on("change", (function() {
					var e = $(this).find("option:selected").data("price");
					$(".product__price").html(e)
				})), $(".js-select-address select").each((function() {
					var e = $(this),
						t = e.attr("id"),
						n = e.closest("form").find(".js-select-province select"),
						r = n.attr("id"),
						o = n.closest(".js-select-parent").attr("id");
					new Shopify.CountryProvinceSelector(t, r, {
						hideElement: o
					});
					e.on("selectric-change", (function() {
						//console.log('Step2');
						var e = $(this).find("option:selected").data("provinces"),
							t = "";
						e.length ? (e.map((function(e) {
							t += '<option value="'.concat(e[0], '">').concat(e[0],
								"</option>")
						})), n.closest(".js-select-parent").show()) : (t =
							'<option value=""></option>', n.closest(".js-select-parent").hide()
						), n.html(t), n.selectric("refresh")
					}))
				}))
		}))
	}, function() {
		var e = $(window),
			t = $(".main"),
			n = $(".header"),
			r = $(".header .header__bar"),
			o = $(".header .header__breadcrumbs"),
			i = $(".nav .mega-menu"),
			a = $(".wrapper");
		e.on("scroll load resize", (function() {
			var s = r.outerHeight() || 0;
			/* UNIT3 2026-10: SP(<=767px)はトップでもヘッダー高(バナー込み)をmainの上余白に入れる。PCトップは従来どおり余白0 */
			var isSp = window.matchMedia("(max-width: 767px)").matches;
			var hh = n.find(".header__content").outerHeight() + s;
				n.data("index") ? (isSp ? t[0].style.setProperty("padding-top", hh + "px", "important") : t.css("padding-top", "")) : t.css("padding-top", hh),
				o.length && i.length && $(".nav .mega-menu").css("margin-top", -1 *
					o.outerHeight()), 0 < e.scrollTop() ? (n.addClass("fixed"), r.css(
					"margin-top", "-".concat(s, "px")), a.addClass(

				"wrapper--header-fixed")) : (n.removeClass("fixed"), r.css(
				"margin-top", 0), a.removeClass("wrapper--header-fixed"))
		})), n.on("mouseenter mouseleave"), $(".nav .has-dropdown").on(
			"mouseenter mouseleave", (function(e) {
				var t = $(this);
				"mouseenter" === e.type ? (n.addClass("grey"), t.addClass("black")) : (n
					.removeClass("grey"), t.removeClass("black"))
			}))
	}, function(e, t, n) {
		(function(e) {
			function n(e) {
				return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ?
					function(e) {
						return typeof e
					} : function(e) {
						return e && "function" == typeof Symbol && e.constructor === Symbol &&
							e !== Symbol.prototype ? "symbol" : typeof e
					})(e)
			}
			/*!
			 * jQuery JavaScript Library v3.5.1
			 * https://jquery.com/
			 *
			 * Includes Sizzle.js
			 * https://sizzlejs.com/
			 *
			 * Copyright JS Foundation and other contributors
			 * Released under the MIT license
			 * https://jquery.org/license
			 *
			 * Date: 2020-05-04T22:49Z
			 */
			var r;
			! function(t, r) {
				"use strict";
				"object" === n(e) && "object" === n(e.exports) ? e.exports = t.document ?
					r(t, !0) : function(e) {
						if (!e.document) throw new Error(
							"jQuery requires a window with a document");
						return r(e)
					} : r(t)
			}("undefined" == typeof window ? this : window, (function(o, i) {
				"use strict";

				function a(e, t, n) {
					var r, o, i = (n = n || be).createElement("script");
					if (i.text = e, t)
						for (r in xe)(o = t[r] || t.getAttribute && t.getAttribute(r)) && i.setAttribute(
							r, o);
					n.head.appendChild(i).parentNode.removeChild(i)
				}

				function s(e) {
					return null == e ? e + "" : "object" === n(e) || "function" == typeof e ?
						de[fe.call(e)] || "object" : n(e)
				}

				function c(e) {
					var t = !!e && "length" in e && e.length,
						n = s(e);
					return !(ve(e) || ye(e)) && ("array" === n || 0 === t || "number" ==
						typeof t && 0 < t && t - 1 in e)
				}

				function l(e, t) {
					return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase()
				}

				function u(e, t, n) {
					return ve(t) ? we.grep(e, (function(e, r) {
						return !!t.call(e, r, e) !== n
					})) : t.nodeType ? we.grep(e, (function(e) {
						return e === t !== n
					})) : "string" == typeof t ? we.filter(t, e, n) : we.grep(e, (
						function(e) {
							return -1 < ue.call(t, e) !== n
						}))
				}

				function d(e, t) {
					for (;
						(e = e[t]) && 1 !== e.nodeType;);
					return e
				}

				function f(e) {
					return e
				}

				function p(e) {
					throw e
				}

				function h(e, t, n, r) {
					var o;
					try {
						e && ve(o = e.promise) ? o.call(e).done(t).fail(n) : e && ve(o = e.then) ?
							o.call(e, t, n) : t.apply(void 0, [e].slice(r))
					} catch (e) {
						n.apply(void 0, [e])
					}
				}

				function m() {
					be.removeEventListener("DOMContentLoaded", m), o.removeEventListener(
						"load", m), we.ready()
				}

				function g(e, t) {
					return t.toUpperCase()
				}

				function v(e) {
					return e.replace(Oe, "ms-").replace(Pe, g)
				}

				function y() {
					this.expando = we.expando + y.uid++
				}

				function b(e, t, n) {
					var r;
					if (void 0 === n && 1 === e.nodeType)
						if (r = "data-" + t.replace(Be, "-$&").toLowerCase(), "string" ==
							typeof(n = e.getAttribute(r))) {
							try {
								n = function(e) {
									return "true" === e || "false" !== e && ("null" === e ? null : e ===
										+e + "" ? +e : ze.test(e) ? JSON.parse(e) : e)
								}(n)
							} catch (t) {}
							Me.set(e, t, n)
						} else n = void 0;
					return n
				}

				function x(e, t, n, r) {
					var o, i, a = 20,
						s = r ? function() {
							return r.cur()
						} : function() {
							return we.css(e, t, "")
						},
						c = s(),
						l = n && n[3] || (we.cssNumber[t] ? "" : "px"),
						u = e.nodeType && (we.cssNumber[t] || "px" !== l && +c) && Re.exec(we
							.css(e, t));
					if (u && u[3] !== l) {
						for (c /= 2, l = l || u[3], u = +c || 1; a--;) we.style(e, t, u + l),
							0 >= (1 - i) * (1 - (i = s() / c || .5)) && (a = 0), u /= i;
						u *= 2, we.style(e, t, u + l), n = n || []
					}
					return n && (u = +u || +c || 0, o = n[1] ? u + (n[1] + 1) * n[2] : +n[
						2], r && (r.unit = l, r.start = u, r.end = o)), o
				}

				function w(e) {
					var t, n = e.ownerDocument,
						r = e.nodeName,
						o = Ye[r];
					return o || (t = n.body.appendChild(n.createElement(r)), o = we.css(t,
						"display"), t.parentNode.removeChild(t), "none" === o && (o =
						"block"), Ye[r] = o, o)
				}

				function C(e, t) {
					for (var n, r, o = [], i = 0, a = e.length; i < a; i++)(r = e[i]).style &&
						(n = r.style.display, t ? ("none" === n && (o[i] = He.get(r,
								"display") || null, !o[i] && (r.style.display = "")), "" === r.style
							.display && Ve(r) && (o[i] = w(r))) : "none" !== n && (o[i] =
							"none", He.set(r, "display", n)));
					for (i = 0; i < a; i++) null != o[i] && (e[i].style.display = o[i]);
					return e
				}

				function T(e, t) {
					var n;
					return n = void 0 === e.getElementsByTagName ? void 0 === e.querySelectorAll ? [] :
						e.querySelectorAll(t || "*") : e.getElementsByTagName(t || "*"), void 0 ===
						t || t && l(e, t) ? we.merge([e], n) : n
				}

				function k(e, t) {
					for (var n = 0, r = e.length; n < r; n++) He.set(e[n], "globalEval", !
						t || He.get(t[n], "globalEval"))
				}

				function _(e, t, n, r, o) {
					for (var i, a, c, l, u, d, f = t.createDocumentFragment(), p = [], h =
							0, m = e.length; h < m; h++)
						if ((i = e[h]) || 0 === i)
							if ("object" === s(i)) we.merge(p, i.nodeType ? [i] : i);
							else if (et.test(i)) {
						for (a = a || f.appendChild(t.createElement("div")), c = (Je.exec(i) || [
								"", ""
							])[1].toLowerCase(), l = Qe[c] || Qe._default, a.innerHTML = l[1] +
							we.htmlPrefilter(i) + l[2], d = l[0]; d--;) a = a.lastChild;
						we.merge(p, a.childNodes), (a = f.firstChild).textContent = ""
					} else p.push(t.createTextNode(i));
					for (f.textContent = "", h = 0; i = p[h++];)
						if (r && -1 < we.inArray(i, r)) o && o.push(i);
						else if (u = Xe(i), a = T(f.appendChild(i), "script"), u && k(a), n)
						for (d = 0; i = a[d++];) Ze.test(i.type || "") && n.push(i);
					return f
				}

				function S() {
					return !0
				}

				function j() {
					return !1
				}

				function $(e, t) {
					return e === function() {
						try {
							return be.activeElement
						} catch (e) {}
					}() == ("focus" === t)
				}

				function E(e, t, r, o, i, a) {
					var s, c;
					if ("object" === n(t)) {
						for (c in "string" != typeof r && (o = o || r, r = void 0), t) E(e, c,
							r, o, t[c], a);
						return e
					}
					if (null == o && null == i ? (i = r, o = r = void 0) : null == i && (
							"string" == typeof r ? (i = o, o = void 0) : (i = o, o = r, r = void 0)
						), !1 === i) i = j;
					else if (!i) return e;
					return 1 === a && (s = i, (i = function(e) {
						return we().off(e), s.apply(this, arguments)
					}).guid = s.guid || (s.guid = we.guid++)), e.each((function() {
						we.event.add(this, t, i, o, r)
					}))
				}

				function A(e, t, n) {
					return n ? (He.set(e, t, !1), void we.event.add(e, t, {
						namespace: !1,
						handler: function(e) {
							var r, o, i = He.get(this, t);
							if (1 & e.isTrigger && this[t]) {
								if (i.length)(we.event.special[t] || {}).delegateType && e.stopPropagation();
								else if (i = se.call(arguments), He.set(this, t, i), r = n(this,
										t), this[t](), i !== (o = He.get(this, t)) || r ? He.set(this,
										t, !1) : o = {}, i !== o) return e.stopImmediatePropagation(),
									e.preventDefault(), o.value
							} else i.length && (He.set(this, t, {
								value: we.event.trigger(we.extend(i[0], we.Event.prototype),
									i.slice(1), this)
							}), e.stopImmediatePropagation())
						}
					})) : void(void 0 === He.get(e, t) && we.event.add(e, t, S))
				}

				function D(e, t) {
					return l(e, "table") && l(11 === t.nodeType ? t.firstChild : t, "tr") &&
						we(e).children("tbody")[0] || e
				}

				function N(e) {
					return e.type = (null !== e.getAttribute("type")) + "/" + e.type, e
				}

				function L(e) {
					return "true/" === (e.type || "").slice(0, 5) ? e.type = e.type.slice(
						5) : e.removeAttribute("type"), e
				}

				function I(e, t) {
					var n, r, o, i, a, s;
					if (1 === t.nodeType) {
						if (He.hasData(e) && (s = He.get(e).events))
							for (o in He.remove(t, "handle events"), s)
								for (n = 0, r = s[o].length; n < r; n++) we.event.add(t, o, s[o][n]);
						Me.hasData(e) && (i = Me.access(e), a = we.extend({}, i), Me.set(t, a))
					}
				}

				function O(e, t) {
					var n = t.nodeName.toLowerCase();
					"input" === n && Ke.test(e.type) ? t.checked = e.checked : ("input" ===
						n || "textarea" === n) && (t.defaultValue = e.defaultValue)
				}

				function P(e, t, n, r) {
					t = ce(t);
					var o, i, s, c, l, u, d = 0,
						f = e.length,
						p = t[0],
						h = ve(p);
					if (h || 1 < f && "string" == typeof p && !ge.checkClone && it.test(p))
						return e.each((function(o) {
							var i = e.eq(o);
							h && (t[0] = p.call(this, o, i.html())), P(i, t, n, r)
						}));
					if (f && (i = (o = _(t, e[0].ownerDocument, !1, e, r)).firstChild, 1 ===
							o.childNodes.length && (o = i), i || r)) {
						for (c = (s = we.map(T(o, "script"), N)).length; d < f; d++) l = o, d !=
							f - 1 && (l = we.clone(l, !0, !0), c && we.merge(s, T(l, "script"))),
							n.call(e[d], l, d);
						if (c)
							for (u = s[s.length - 1].ownerDocument, we.map(s, L), d = 0; d < c; d++)
								l = s[d], Ze.test(l.type || "") && !He.access(l, "globalEval") &&
								we.contains(u, l) && (l.src && "module" !== (l.type || "").toLowerCase() ?
									we._evalUrl && !l.noModule && we._evalUrl(l.src, {
										nonce: l.nonce || l.getAttribute("nonce")
									}, u) : a(l.textContent.replace(at, ""), l, u))
					}
					return e
				}

				function q(e, t, n) {
					for (var r, o = t ? we.filter(t, e) : e, i = 0; null != (r = o[i]); i++)
						n || 1 !== r.nodeType || we.cleanData(T(r)), r.parentNode && (n && Xe(
							r) && k(T(r, "script")), r.parentNode.removeChild(r));
					return e
				}

				function H(e, t, n) {
					var r, o, i, a, s = e.style;
					return (n = n || ct(e)) && ("" === (a = n.getPropertyValue(t) || n[t]) &&
						!Xe(e) && (a = we.style(e, t)), !ge.pixelBoxStyles() && st.test(a) &&
						ut.test(t) && (r = s.width, o = s.minWidth, i = s.maxWidth, s.minWidth =
							s.maxWidth = s.width = a, a = n.width, s.width = r, s.minWidth = o,
							s.maxWidth = i)), void 0 === a ? a : a + ""
				}

				function M(e, t) {
					return {
						get: function() {
							return e() ? void delete this.get : (this.get = t).apply(this,
								arguments)
						}
					}
				}

				function z(e) {
					var t = we.cssProps[e] || pt[e];
					return t || (e in ft ? e : pt[e] = function(e) {
						for (var t = e[0].toUpperCase() + e.slice(1), n = dt.length; n--;)
							if ((e = dt[n] + t) in ft) return e
					}(e) || e)
				}

				function B(e, t, n) {
					var r = Re.exec(t);
					return r ? oe(0, r[2] - (n || 0)) + (r[3] || "px") : t
				}

				function F(e, t, n, r, o, i) {
					var a = "width" === t ? 1 : 0,
						s = 0,
						c = 0;
					if (n === (r ? "border" : "content")) return 0;
					for (; 4 > a; a += 2) "margin" === n && (c += we.css(e, n + We[a], !0,
						o)), r ? ("content" === n && (c -= we.css(e, "padding" + We[a], !0,
						o)), "margin" !== n && (c -= we.css(e, "border" + We[a] + "Width", !
						0, o))) : (c += we.css(e, "padding" + We[a], !0, o), "padding" === n ?
						s += we.css(e, "border" + We[a] + "Width", !0, o) : c += we.css(e,
							"border" + We[a] + "Width", !0, o));
					return !r && 0 <= i && (c += oe(0, re(e["offset" + t[0].toUpperCase() +
						t.slice(1)] - i - c - s - .5)) || 0), c
				}

				function R(e, t, n) {
					var r = ct(e),
						o = (!ge.boxSizingReliable() || n) && "border-box" === we.css(e,
							"boxSizing", !1, r),
						i = o,
						a = H(e, t, r),
						s = "offset" + t[0].toUpperCase() + t.slice(1);
					if (st.test(a)) {
						if (!n) return a;
						a = "auto"
					}
					return (!ge.boxSizingReliable() && o || !ge.reliableTrDimensions() &&
						l(e, "tr") || "auto" === a || !parseFloat(a) && "inline" === we.css(
							e, "display", !1, r)) && e.getClientRects().length && (o =
						"border-box" === we.css(e, "boxSizing", !1, r), (i = s in e) && (a =
							e[s])), (a = parseFloat(a) || 0) + F(e, t, n || (o ? "border" :
						"content"), i, r, a) + "px"
				}

				function W(e, t, n, r, o) {
					return new W.prototype.init(e, t, n, r, o)
				}

				function U() {
					bt && (!1 === be.hidden && o.requestAnimationFrame ? o.requestAnimationFrame(
						U) : o.setTimeout(U, we.fx.interval), we.fx.tick())
				}

				function X() {
					return o.setTimeout((function() {
						yt = void 0
					})), yt = Date.now()
				}

				function G(e, t) {
					var n, r = 0,
						o = {
							height: e
						};
					for (t = t ? 1 : 0; 4 > r; r += 2 - t) o["margin" + (n = We[r])] = o[
						"padding" + n] = e;
					return t && (o.opacity = o.width = e), o
				}

				function V(e, t, n) {
					for (var r, o = (Y.tweeners[t] || []).concat(Y.tweeners["*"]), i = 0,
							a = o.length; i < a; i++)
						if (r = o[i].call(n, t, e)) return r
				}

				function Y(e, t, n) {
					var r, o, i = 0,
						a = Y.prefilters.length,
						s = we.Deferred().always((function() {
							delete c.elem
						})),
						c = function() {
							if (o) return !1;
							for (var t = yt || X(), n = oe(0, l.startTime + l.duration - t), r =
									1 - (n / l.duration || 0), i = 0, a = l.tweens.length; i < a; i++)
								l.tweens[i].run(r);
							return s.notifyWith(e, [l, r, n]), 1 > r && a ? n : (a || s.notifyWith(
								e, [l, 1, 0]), s.resolveWith(e, [l]), !1)
						},
						l = s.promise({
							elem: e,
							props: we.extend({}, t),
							opts: we.extend(!0, {
								specialEasing: {},
								easing: we.easing._default
							}, n),
							originalProperties: t,
							originalOptions: n,
							startTime: yt || X(),
							duration: n.duration,
							tweens: [],
							createTween: function(t, n) {
								var r = we.Tween(e, l.opts, t, n, l.opts.specialEasing[t] || l.opts
									.easing);
								return l.tweens.push(r), r
							},
							stop: function(t) {
								var n = 0,
									r = t ? l.tweens.length : 0;
								if (o) return this;
								for (o = !0; n < r; n++) l.tweens[n].run(1);
								return t ? (s.notifyWith(e, [l, 1, 0]), s.resolveWith(e, [l, t])) :
									s.rejectWith(e, [l, t]), this
							}
						}),
						u = l.props;
					for (function(e, t) {
							var n, r, o, i, a;
							for (n in e)
								if (o = t[r = v(n)], i = e[n], Array.isArray(i) && (o = i[1], i = e[
										n] = i[0]), n != r && (e[r] = i, delete e[n]), (a = we.cssHooks[r]) &&
									"expand" in a)
									for (n in i = a.expand(i), delete e[r], i) n in e || (e[n] = i[n],
										t[n] = o);
								else t[r] = o
						}(u, l.opts.specialEasing); i < a; i++)
						if (r = Y.prefilters[i].call(l, e, u, l.opts)) return ve(r.stop) && (
							we._queueHooks(l.elem, l.opts.queue).stop = r.stop.bind(r)), r;
					return we.map(u, V, l), ve(l.opts.start) && l.opts.start.call(e, l), l
						.progress(l.opts.progress).done(l.opts.done, l.opts.complete).fail(l.opts
							.fail).always(l.opts.always), we.fx.timer(we.extend(c, {
							elem: e,
							anim: l,
							queue: l.opts.queue
						})), l
				}

				function K(e) {
					return (e.match(De) || []).join(" ")
				}

				function J(e) {
					return e.getAttribute && e.getAttribute("class") || ""
				}

				function Z(e) {
					return Array.isArray(e) ? e : "string" == typeof e && e.match(De) || []
				}

				function Q(e, t, r, o) {
					if (Array.isArray(t)) we.each(t, (function(t, i) {
						r || Nt.test(e) ? o(e, i) : Q(e + "[" + ("object" === n(i) && null !=
							i ? t : "") + "]", i, r, o)
					}));
					else if (r || "object" !== s(t)) o(e, t);
					else
						for (var i in t) Q(e + "[" + i + "]", t[i], r, o)
				}

				function ee(e) {
					return function(t, n) {
						"string" != typeof t && (n = t, t = "*");
						var r, o = 0,
							i = t.toLowerCase().match(De) || [];
						if (ve(n))
							for (; r = i[o++];) "+" === r[0] ? (r = r.slice(1) || "*", (e[r] =
								e[r] || []).unshift(n)) : (e[r] = e[r] || []).push(n)
					}
				}

				function te(e, t, n, r) {
					function o(s) {
						var c;
						return i[s] = !0, we.each(e[s] || [], (function(e, s) {
							var l = s(t, n, r);
							return "string" != typeof l || a || i[l] ? a ? !(c = l) : void 0 :
								(t.dataTypes.unshift(l), o(l), !1)
						})), c
					}
					var i = {},
						a = e === Rt;
					return o(t.dataTypes[0]) || !i["*"] && o("*")
				}

				function ne(e, t) {
					var n, r, o = we.ajaxSettings.flatOptions || {};
					for (n in t) void 0 !== t[n] && ((o[n] ? e : r || (r = {}))[n] = t[n]);
					return r && we.extend(!0, e, r), e
				}
				var re = Math.ceil,
					oe = Math.max,
					ie = [],
					ae = Object.getPrototypeOf,
					se = ie.slice,
					ce = ie.flat ? function(e) {
						return ie.flat.call(e)
					} : function(e) {
						return ie.concat.apply([], e)
					},
					le = ie.push,
					ue = ie.indexOf,
					de = {},
					fe = de.toString,
					pe = de.hasOwnProperty,
					he = pe.toString,
					me = he.call(Object),
					ge = {},
					ve = function(e) {
						return "function" == typeof e && "number" != typeof e.nodeType
					},
					ye = function(e) {
						return null != e && e === e.window
					},
					be = o.document,
					xe = {
						type: !0,
						src: !0,
						nonce: !0,
						noModule: !0
					},
					we = function e(t, n) {
						return new e.fn.init(t, n)
					};
				we.fn = we.prototype = {
					jquery: "3.5.1",
					constructor: we,
					length: 0,
					toArray: function() {
						return se.call(this)
					},
					get: function(e) {
						return null == e ? se.call(this) : 0 > e ? this[e + this.length] :
							this[e]
					},
					pushStack: function(e) {
						var t = we.merge(this.constructor(), e);
						return t.prevObject = this, t
					},
					each: function(e) {
						return we.each(this, e)
					},
					map: function(e) {
						return this.pushStack(we.map(this, (function(t, n) {
							return e.call(t, n, t)
						})))
					},
					slice: function() {
						return this.pushStack(se.apply(this, arguments))
					},
					first: function() {
						return this.eq(0)
					},
					last: function() {
						return this.eq(-1)
					},
					even: function() {
						return this.pushStack(we.grep(this, (function(e, t) {
							return (t + 1) % 2
						})))
					},
					odd: function() {
						return this.pushStack(we.grep(this, (function(e, t) {
							return t % 2
						})))
					},
					eq: function(e) {
						var t = this.length,
							n = +e + (0 > e ? t : 0);
						return this.pushStack(0 <= n && n < t ? [this[n]] : [])
					},
					end: function() {
						return this.prevObject || this.constructor()
					},
					push: le,
					sort: ie.sort,
					splice: ie.splice
				}, we.extend = we.fn.extend = function() {
					var e, t, r, o, i, a, s = arguments[0] || {},
						c = 1,
						l = arguments.length,
						u = !1;
					for ("boolean" == typeof s && (u = s, s = arguments[c] || {}, c++),
						"object" === n(s) || ve(s) || (s = {}), c === l && (s = this, c--); c <
						l; c++)
						if (null != (e = arguments[c]))
							for (t in e) o = e[t], "__proto__" !== t && s !== o && (u && o && (
								we.isPlainObject(o) || (i = Array.isArray(o))) ? (r = s[t], a =
								i && !Array.isArray(r) ? [] : i || we.isPlainObject(r) ? r : {},
								i = !1, s[t] = we.extend(u, a, o)) : void 0 !== o && (s[t] = o));
					return s
				}, we.extend({
					expando: "jQuery" + ("3.5.1" + Math.random()).replace(/\D/g, ""),
					isReady: !0,
					error: function(e) {
						throw new Error(e)
					},
					noop: function() {},
					isPlainObject: function(e) {
						var t, n;
						return !(!e || "[object Object]" !== fe.call(e) || (t = ae(e), t &&
							(n = pe.call(t, "constructor") && t.constructor, "function" !=
								typeof n || he.call(n) !== me)))
					},
					isEmptyObject: function(e) {
						for (var t in e) return !1;
						return !0
					},
					globalEval: function(e, t, n) {
						a(e, {
							nonce: t && t.nonce
						}, n)
					},
					each: function(e, t) {
						var n, r = 0;
						if (c(e))
							for (n = e.length; r < n && !1 !== t.call(e[r], r, e[r]); r++);
						else
							for (r in e)
								if (!1 === t.call(e[r], r, e[r])) break; return e
					},
					makeArray: function(e, t) {
						var n = t || [];
						return null != e && (c(Object(e)) ? we.merge(n, "string" == typeof e ? [
							e
						] : e) : le.call(n, e)), n
					},
					inArray: function(e, t, n) {
						return null == t ? -1 : ue.call(t, e, n)
					},
					merge: function(e, t) {
						for (var n = +t.length, r = 0, o = e.length; r < n; r++) e[o++] =
							t[r];
						return e.length = o, e
					},
					grep: function(e, t, n) {
						for (var r = [], o = 0, i = e.length; o < i; o++) !t(e[o], o) !==
							!n && r.push(e[o]);
						return r
					},
					map: function(e, t, n) {
						var r, o, i = 0,
							a = [];
						if (c(e))
							for (r = e.length; i < r; i++) null != (o = t(e[i], i, n)) && a.push(
								o);
						else
							for (i in e) null != (o = t(e[i], i, n)) && a.push(o);
						return ce(a)
					},
					guid: 1,
					support: ge
				}), "function" == typeof Symbol && (we.fn[Symbol.iterator] = ie[Symbol
					.iterator]), we.each(["Boolean", "Number", "String", "Function",
					"Array", "Date", "RegExp", "Object", "Error", "Symbol"
				], (function(e, t) {
					de["[object " + t + "]"] = t.toLowerCase()
				}));
				var Ce =
					/*!
					 * Sizzle CSS Selector Engine v2.3.5
					 * https://sizzlejs.com/
					 *
					 * Copyright JS Foundation and other contributors
					 * Released under the MIT license
					 * https://js.foundation/
					 *
					 * Date: 2020-03-14
					 */
					function(e) {
						function t(e, t, n, r) {
							var o, i, a, s, c, l, u, f = t && t.ownerDocument,
								h = t ? t.nodeType : 9;
							if (n = n || [], "string" != typeof e || !e || 1 !== h && 9 !== h &&
								11 !== h) return n;
							if (!r && (N(t), t = t || L, O)) {
								if (11 !== h && (c = ve.exec(e)))
									if (o = c[1]) {
										if (9 === h) {
											if (!(a = t.getElementById(o))) return n;
											if (a.id === o) return n.push(a), n
										} else if (f && (a = f.getElementById(o)) && M(t, a) && a.id ===
											o) return n.push(a), n
									} else {
										if (c[2]) return Q.apply(n, t.getElementsByTagName(e)), n;
										if ((o = c[3]) && C.getElementsByClassName && t.getElementsByClassName)
											return Q.apply(n, t.getElementsByClassName(o)), n
									}
								if (C.qsa && !G[e + " "] && (!P || !P.test(e)) && (1 !== h ||
										"object" !== t.nodeName.toLowerCase())) {
									if (u = e, f = t, 1 === h && (le.test(e) || ce.test(e))) {
										for ((f = ye.test(e) && d(t.parentNode) || t) === t && C.scope ||
											((s = t.getAttribute("id")) ? s = s.replace(we, Ce) : t.setAttribute(
												"id", s = z)), i = (l = S(e)).length; i--;) l[i] = (s ? "#" + s :
											":scope") + " " + p(l[i]);
										u = l.join(",")
									}
									try {
										return Q.apply(n, f.querySelectorAll(u)), n
									} catch (t) {
										G(e, !0)
									} finally {
										s === z && t.removeAttribute("id")
									}
								}
							}
							return $(e.replace(ae, "$1"), t, n, r)
						}

						function n() {
							var e = [];
							return function t(n, r) {
								return e.push(n + " ") > T.cacheLength && delete t[e.shift()], t[n +
									" "] = r
							}
						}

						function r(e) {
							return e[z] = !0, e
						}

						function o(e) {
							var t = L.createElement("fieldset");
							try {
								return !!e(t)
							} catch (t) {
								return !1
							} finally {
								t.parentNode && t.parentNode.removeChild(t), t = null
							}
						}

						function i(e, t) {
							for (var n = e.split("|"), r = n.length; r--;) T.attrHandle[n[r]] =
								t
						}

						function a(e, t) {
							var n = t && e,
								r = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
							if (r) return r;
							if (n)
								for (; n = n.nextSibling;)
									if (n === t) return -1;
							return e ? 1 : -1
						}

						function s(e) {
							return function(t) {
								return "input" === t.nodeName.toLowerCase() && t.type === e
							}
						}

						function c(e) {
							return function(t) {
								var n = t.nodeName.toLowerCase();
								return ("input" === n || "button" === n) && t.type === e
							}
						}

						function l(e) {
							return function(t) {
								return "form" in t ? t.parentNode && !1 === t.disabled ? "label" in
									t ? "label" in t.parentNode ? t.parentNode.disabled === e : t.disabled ===
									e : t.isDisabled === e || t.isDisabled !== !e && ke(t) === e : t.disabled ===
									e : !!("label" in t) && t.disabled === e
							}
						}

						function u(e) {
							return r((function(t) {
								return t = +t, r((function(n, r) {
									for (var o, i = e([], n.length, t), a = i.length; a--;) n[o =
										i[a]] && (n[o] = !(r[o] = n[o]))
								}))
							}))
						}

						function d(e) {
							return e && void 0 !== e.getElementsByTagName && e
						}

						function f() {}

						function p(e) {
							for (var t = 0, n = e.length, r = ""; t < n; t++) r += e[t].value;
							return r
						}

						function h(e, t, n) {
							var r = t.dir,
								o = t.next,
								i = o || r,
								a = n && "parentNode" === i,
								s = R++;
							return t.first ? function(t, n, o) {
								for (; t = t[r];)
									if (1 === t.nodeType || a) return e(t, n, o);
								return !1
							} : function(t, n, c) {
								var l, u, d, f = [F, s];
								if (c) {
									for (; t = t[r];)
										if ((1 === t.nodeType || a) && e(t, n, c)) return !0
								} else
									for (; t = t[r];)
										if (1 === t.nodeType || a)
											if (u = (d = t[z] || (t[z] = {}))[t.uniqueID] || (d[t.uniqueID] = {}),
												o && o === t.nodeName.toLowerCase()) t = t[r] || t;
											else {
												if ((l = u[i]) && l[0] === F && l[1] === s) return f[2] = l[2];
												if (u[i] = f, f[2] = e(t, n, c)) return !0
											} return !1
							}
						}

						function m(e) {
							return 1 < e.length ? function(t, n, r) {
								for (var o = e.length; o--;)
									if (!e[o](t, n, r)) return !1;
								return !0
							} : e[0]
						}

						function g(e, n, r) {
							for (var o = 0, i = n.length; o < i; o++) t(e, n[o], r);
							return r
						}

						function v(e, t, n, r, o) {
							for (var i, a = [], s = 0, c = e.length; s < c; s++)(i = e[s]) && (!
								n || n(i, r, o)) && (a.push(i), null != t && t.push(s));
							return a
						}

						function y(e, t, n, o, i, a) {
							return o && !o[z] && (o = y(o)), i && !i[z] && (i = y(i, a)), r((
								function(r, a, s, c) {
									var l, u, d, f = [],
										p = [],
										h = a.length,
										m = r || g(t || "*", s.nodeType ? [s] : s, []),
										y = !e || !r && t ? m : v(m, f, e, s, c),
										b = n ? i || (r ? e : h || o) ? [] : a : y;
									if (n && n(y, b, s, c), o)
										for (l = v(b, p), o(l, [], s, c), u = l.length; u--;)(d = l[u]) &&
											(b[p[u]] = !(y[p[u]] = d));
									if (r) {
										if (i || e) {
											if (i) {
												for (l = [], u = b.length; u--;)(d = b[u]) && l.push(y[u] = d);
												i(null, b = [], l, c)
											}
											for (u = b.length; u--;)(d = b[u]) && -1 < (l = i ? te(r, d) :
												f[u]) && (r[l] = !(a[l] = d))
										}
									} else b = v(b === a ? b.splice(h, b.length) : b), i ? i(null, a,
										b, c) : Q.apply(a, b)
								}))
						}

						function b(e) {
							for (var t, n, r, o = e.length, i = T.relative[e[0].type], a = i ||
									T.relative[" "], s = i ? 1 : 0, c = h((function(e) {
										return e === t
									}), a, !0), l = h((function(e) {
										return -1 < te(t, e)
									}), a, !0), u = [function(e, n, r) {
										var o = !i && (r || n !== E) || ((t = n).nodeType ? c(e, n, r) :
											l(e, n, r));
										return t = null, o
									}]; s < o; s++)
								if (n = T.relative[e[s].type]) u = [h(m(u), n)];
								else {
									if ((n = T.filter[e[s].type].apply(null, e[s].matches))[z]) {
										for (r = ++s; r < o && !T.relative[e[r].type]; r++);
										return y(1 < s && m(u), 1 < s && p(e.slice(0, s - 1).concat({
											value: " " === e[s - 2].type ? "*" : ""
										})).replace(ae, "$1"), n, s < r && b(e.slice(s, r)), r < o && b(
											e = e.slice(r)), r < o && p(e))
									}
									u.push(n)
								}
							return m(u)
						}

						function x(e, n) {
							var o = 0 < n.length,
								i = 0 < e.length,
								a = function(r, a, s, c, l) {
									var u, d, f, p = 0,
										h = "0",
										m = r && [],
										g = [],
										y = E,
										b = r || i && T.find.TAG("*", l),
										x = F += null == y ? 1 : Math.random() || .1,
										w = b.length;
									for (l && (E = a == L || a || l); h !== w && null != (u = b[h]); h++) {
										if (i && u) {
											for (d = 0, a || u.ownerDocument == L || (N(u), s = !O); f = e[d++];)
												if (f(u, a || L, s)) {
													c.push(u);
													break
												}
											l && (F = x)
										}
										o && ((u = !f && u) && p--, r && m.push(u))
									}
									if (p += h, o && h !== p) {
										for (d = 0; f = n[d++];) f(m, g, a, s);
										if (r) {
											if (0 < p)
												for (; h--;) m[h] || g[h] || (g[h] = J.call(c));
											g = v(g)
										}
										Q.apply(c, g), l && !r && 0 < g.length && 1 < p + n.length && t.uniqueSort(
											c)
									}
									return l && (F = x, E = y), m
								};
							return o ? r(a) : a
						}
						var w, C, T, k, _, S, j, $, E, A, D, N, L, I, O, P, q, H, M, z =
							"sizzle" + 1 * new Date,
							B = e.document,
							F = 0,
							R = 0,
							W = n(),
							U = n(),
							X = n(),
							G = n(),
							V = function(e, t) {
								return e === t && (D = !0), 0
							},
							Y = {}.hasOwnProperty,
							K = [],
							J = K.pop,
							Z = K.push,
							Q = K.push,
							ee = K.slice,
							te = function(e, t) {
								for (var n = 0, r = e.length; n < r; n++)
									if (e[n] === t) return n;
								return -1
							},
							ne =
							"checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
							re = "[\\x20\\t\\r\\n\\f]",
							oe = "(?:\\\\[\\da-fA-F]{1,6}" + re +
							"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
							ie = /[\x20\t\r\n\f]+/g,
							ae = /^[\x20\t\r\n\f]+|((?:^|[^\\])(?:\\.)*)[\x20\t\r\n\f]+$/g,
							se = /^[\x20\t\r\n\f]*,[\x20\t\r\n\f]*/,
							ce = /^[\x20\t\r\n\f]*([>+~]|[\x20\t\r\n\f])[\x20\t\r\n\f]*/,
							le = /[\x20\t\r\n\f]|>/,
							ue =
							/:((?:\\[\da-fA-F]{1,6}[\x20\t\r\n\f]?|\\[^\r\n\f]|[\w-]|[^\0-\x7f])+)(?:\((('((?:\\.|[^\\'])*)'|"((?:\\.|[^\\"])*)")|((?:\\.|[^\\()[\]]|\[[\x20\t\r\n\f]*((?:\\[\da-fA-F]{1,6}[\x20\t\r\n\f]?|\\[^\r\n\f]|[\w-]|[^\0-\x7f])+)(?:[\x20\t\r\n\f]*([*^$|!~]?=)[\x20\t\r\n\f]*(?:'((?:\\.|[^\\'])*)'|"((?:\\.|[^\\"])*)"|((?:\\[\da-fA-F]{1,6}[\x20\t\r\n\f]?|\\[^\r\n\f]|[\w-]|[^\0-\x7f])+))|)[\x20\t\r\n\f]*\])*)|.*)\)|)/,
							de =
							/^(?:\\[\da-fA-F]{1,6}[\x20\t\r\n\f]?|\\[^\r\n\f]|[\w-]|[^\0-\x7f])+$/,
							fe = {
								ID: /^#((?:\\[\da-fA-F]{1,6}[\x20\t\r\n\f]?|\\[^\r\n\f]|[\w-]|[^\0-\x7f])+)/,
								CLASS: /^\.((?:\\[\da-fA-F]{1,6}[\x20\t\r\n\f]?|\\[^\r\n\f]|[\w-]|[^\0-\x7f])+)/,
								TAG: /^((?:\\[\da-fA-F]{1,6}[\x20\t\r\n\f]?|\\[^\r\n\f]|[\w-]|[^\0-\x7f])+|[*])/,
								ATTR: /^\[[\x20\t\r\n\f]*((?:\\[\da-fA-F]{1,6}[\x20\t\r\n\f]?|\\[^\r\n\f]|[\w-]|[^\0-\x7f])+)(?:[\x20\t\r\n\f]*([*^$|!~]?=)[\x20\t\r\n\f]*(?:'((?:\\.|[^\\'])*)'|"((?:\\.|[^\\"])*)"|((?:\\[\da-fA-F]{1,6}[\x20\t\r\n\f]?|\\[^\r\n\f]|[\w-]|[^\0-\x7f])+))|)[\x20\t\r\n\f]*\]/,
								PSEUDO: /^:((?:\\[\da-fA-F]{1,6}[\x20\t\r\n\f]?|\\[^\r\n\f]|[\w-]|[^\0-\x7f])+)(?:\((('((?:\\.|[^\\'])*)'|"((?:\\.|[^\\"])*)")|((?:\\.|[^\\()[\]]|\[[\x20\t\r\n\f]*((?:\\[\da-fA-F]{1,6}[\x20\t\r\n\f]?|\\[^\r\n\f]|[\w-]|[^\0-\x7f])+)(?:[\x20\t\r\n\f]*([*^$|!~]?=)[\x20\t\r\n\f]*(?:'((?:\\.|[^\\'])*)'|"((?:\\.|[^\\"])*)"|((?:\\[\da-fA-F]{1,6}[\x20\t\r\n\f]?|\\[^\r\n\f]|[\w-]|[^\0-\x7f])+))|)[\x20\t\r\n\f]*\])*)|.*)\)|)/,
								CHILD: /^:(only|first|last|nth|nth-last)-(child|of-type)(?:\([\x20\t\r\n\f]*(even|odd|(([+-]|)(\d*)n|)[\x20\t\r\n\f]*(?:([+-]|)[\x20\t\r\n\f]*(\d+)|))[\x20\t\r\n\f]*\)|)/i,
								bool: /^(?:checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped)$/i,
								needsContext: /^[\x20\t\r\n\f]*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\([\x20\t\r\n\f]*((?:-\d)?\d*)[\x20\t\r\n\f]*\)|)(?=[^-]|$)/i
							},
							pe = /HTML$/i,
							he = /^(?:input|select|textarea|button)$/i,
							me = /^h\d$/i,
							ge = /^[^{]+\{\s*\[native \w/,
							ve = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
							ye = /[+~]/,
							be = /\\[\da-fA-F]{1,6}[\x20\t\r\n\f]?|\\([^\r\n\f])/g,
							xe = function(e, t) {
								var n = String.fromCharCode,
									r = "0x" + e.slice(1) - 65536;
								return t || (0 > r ? n(r + 65536) : n(55296 | r >> 10, 56320 | 1023 &
									r))
							},
							we = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
							Ce = function(e, t) {
								return t ? "\0" === e ? "�" : e.slice(0, -1) + "\\" + e.charCodeAt(
									e.length - 1).toString(16) + " " : "\\" + e
							},
							Te = function() {
								N()
							},
							ke = h((function(e) {
								return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase()
							}), {
								dir: "parentNode",
								next: "legend"
							});
						try {
							Q.apply(K = ee.call(B.childNodes), B.childNodes), K[B.childNodes.length]
								.nodeType
						} catch (t) {
							Q = {
								apply: K.length ? function(e, t) {
									Z.apply(e, ee.call(t))
								} : function(e, t) {
									for (var n = e.length, r = 0; e[n++] = t[r++];);
									e.length = n - 1
								}
							}
						}
						for (w in C = t.support = {}, _ = t.isXML = function(e) {
								var t = e.namespaceURI,
									n = (e.ownerDocument || e).documentElement;
								return !pe.test(t || n && n.nodeName || "HTML")
							}, N = t.setDocument = function(e) {
								var t, n, r = e ? e.ownerDocument || e : B;
								return r != L && 9 === r.nodeType && r.documentElement ? (I = (L =
										r).documentElement, O = !_(L), B != L && (n = L.defaultView) &&
									n.top !== n && (n.addEventListener ? n.addEventListener("unload",
										Te, !1) : n.attachEvent && n.attachEvent("onunload", Te)), C.scope =
									o((function(e) {
										return I.appendChild(e).appendChild(L.createElement("div")),
											void 0 !== e.querySelectorAll && !e.querySelectorAll(
												":scope fieldset div").length
									})), C.attributes = o((function(e) {
										return e.className = "i", !e.getAttribute("className")
									})), C.getElementsByTagName = o((function(e) {
										return e.appendChild(L.createComment("")), !e.getElementsByTagName(
											"*").length
									})), C.getElementsByClassName = ge.test(L.getElementsByClassName),
									C.getById = o((function(e) {
										return I.appendChild(e).id = z, !L.getElementsByName || !L.getElementsByName(
											z).length
									})), C.getById ? (T.filter.ID = function(e) {
										var t = e.replace(be, xe);
										return function(e) {
											return e.getAttribute("id") === t
										}
									}, T.find.ID = function(e, t) {
										if (void 0 !== t.getElementById && O) {
											var n = t.getElementById(e);
											return n ? [n] : []
										}
									}) : (T.filter.ID = function(e) {
										var t = e.replace(be, xe);
										return function(e) {
											var n = void 0 !== e.getAttributeNode && e.getAttributeNode(
												"id");
											return n && n.value === t
										}
									}, T.find.ID = function(e, t) {
										if (void 0 !== t.getElementById && O) {
											var n, r, o, i = t.getElementById(e);
											if (i) {
												if ((n = i.getAttributeNode("id")) && n.value === e) return [
													i
												];
												for (o = t.getElementsByName(e), r = 0; i = o[r++];)
													if ((n = i.getAttributeNode("id")) && n.value === e) return [
														i
													]
											}
											return []
										}
									}), T.find.TAG = C.getElementsByTagName ? function(e, t) {
										return void 0 === t.getElementsByTagName ? C.qsa ? t.querySelectorAll(
											e) : void 0 : t.getElementsByTagName(e)
									} : function(e, t) {
										var n, r = [],
											o = 0,
											i = t.getElementsByTagName(e);
										if ("*" === e) {
											for (; n = i[o++];) 1 === n.nodeType && r.push(n);
											return r
										}
										return i
									}, T.find.CLASS = C.getElementsByClassName && function(e, t) {
										if (void 0 !== t.getElementsByClassName && O) return t.getElementsByClassName(
											e)
									}, q = [], P = [], (C.qsa = ge.test(L.querySelectorAll)) && (o((
										function(e) {
											var t;
											I.appendChild(e).innerHTML = "<a id='" + z +
												"'></a><select id='" + z +
												"-\r\\' msallowcapture=''><option selected=''></option></select>",
												e.querySelectorAll("[msallowcapture^='']").length && P.push(
													"[*^$]=" + re + "*(?:''|\"\")"), e.querySelectorAll(
													"[selected]").length || P.push("\\[" + re + "*(?:value|" +
													ne + ")"), e.querySelectorAll("[id~=" + z + "-]").length ||
												P.push("~="), (t = L.createElement("input")).setAttribute(
													"name", ""), e.appendChild(t), e.querySelectorAll(
													"[name='']").length || P.push("\\[" + re + "*name" + re +
													"*=" + re + "*(?:''|\"\")"), e.querySelectorAll(":checked")
												.length || P.push(":checked"), e.querySelectorAll("a#" + z +
													"+*").length || P.push(".#.+[+~]"), e.querySelectorAll(
													"\\\f"), P.push("[\\r\\n\\f]")
										})), o((function(e) {
										e.innerHTML =
											"<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
										var t = L.createElement("input");
										t.setAttribute("type", "hidden"), e.appendChild(t).setAttribute(
												"name", "D"), e.querySelectorAll("[name=d]").length && P.push(
												"name" + re + "*[*^$|!~]?="), 2 !== e.querySelectorAll(
												":enabled").length && P.push(":enabled", ":disabled"), I.appendChild(
												e).disabled = !0, 2 !== e.querySelectorAll(":disabled").length &&
											P.push(":enabled", ":disabled"), e.querySelectorAll("*,:x"),
											P.push(",.*:")
									}))), (C.matchesSelector = ge.test(H = I.matches || I.webkitMatchesSelector ||
										I.mozMatchesSelector || I.oMatchesSelector || I.msMatchesSelector
									)) && o((function(e) {
										C.disconnectedMatch = H.call(e, "*"), H.call(e, "[s!='']:x"),
											q.push("!=", ":(" + oe +
												")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|\\[" +
												re + "*(" + oe + ")(?:" + re + "*([*^$|!~]?=)" + re +
												"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
												oe + "))|)" + re + "*\\])*)|.*)\\)|)")
									})), P = P.length && new RegExp(P.join("|")), q = q.length && new RegExp(
										q.join("|")), t = ge.test(I.compareDocumentPosition), M = t ||
									ge.test(I.contains) ? function(e, t) {
										var n = 9 === e.nodeType ? e.documentElement : e,
											r = t && t.parentNode;
										return e === r || !(!r || 1 !== r.nodeType || !(n.contains ? n.contains(
											r) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(
											r)))
									} : function(e, t) {
										if (t)
											for (; t = t.parentNode;)
												if (t === e) return !0;
										return !1
									}, V = t ? function(e, t) {
										if (e === t) return D = !0, 0;
										var n = !e.compareDocumentPosition - !t.compareDocumentPosition;
										return n || (1 & (n = (e.ownerDocument || e) == (t.ownerDocument ||
												t) ? e.compareDocumentPosition(t) : 1) || !C.sortDetached &&
											t.compareDocumentPosition(e) === n ? e == L || e.ownerDocument ==
											B && M(B, e) ? -1 : t == L || t.ownerDocument == B && M(B, t) ?
											1 : A ? te(A, e) - te(A, t) : 0 : 4 & n ? -1 : 1)
									} : function(e, t) {
										if (e === t) return D = !0, 0;
										var n, r = 0,
											o = e.parentNode,
											i = t.parentNode,
											s = [e],
											c = [t];
										if (!o || !i) return e == L ? -1 : t == L ? 1 : o ? -1 : i ? 1 :
											A ? te(A, e) - te(A, t) : 0;
										if (o === i) return a(e, t);
										for (n = e; n = n.parentNode;) s.unshift(n);
										for (n = t; n = n.parentNode;) c.unshift(n);
										for (; s[r] === c[r];) r++;
										return r ? a(s[r], c[r]) : s[r] == B ? -1 : c[r] == B ? 1 : 0
									}, L) : L
							}, t.matches = function(e, n) {
								return t(e, null, null, n)
							}, t.matchesSelector = function(e, n) {
								if (N(e), C.matchesSelector && O && !G[n + " "] && (!q || !q.test(n)) &&
									(!P || !P.test(n))) try {
									var r = H.call(e, n);
									if (r || C.disconnectedMatch || e.document && 11 !== e.document.nodeType)
										return r
								} catch (e) {
									G(n, !0)
								}
								return 0 < t(n, L, null, [e]).length
							}, t.contains = function(e, t) {
								return (e.ownerDocument || e) != L && N(e), M(e, t)
							}, t.attr = function(e, t) {
								(e.ownerDocument || e) != L && N(e);
								var n = T.attrHandle[t.toLowerCase()],
									r = n && Y.call(T.attrHandle, t.toLowerCase()) ? n(e, t, !O) :
									void 0;
								return void 0 === r ? C.attributes || !O ? e.getAttribute(t) : (r =
									e.getAttributeNode(t)) && r.specified ? r.value : null : r
							}, t.escape = function(e) {
								return (e + "").replace(we, Ce)
							}, t.error = function(e) {
								throw new Error("Syntax error, unrecognized expression: " + e)
							}, t.uniqueSort = function(e) {
								var t, n = [],
									r = 0,
									o = 0;
								if (D = !C.detectDuplicates, A = !C.sortStable && e.slice(0), e.sort(
										V), D) {
									for (; t = e[o++];) t === e[o] && (r = n.push(o));
									for (; r--;) e.splice(n[r], 1)
								}
								return A = null, e
							}, k = t.getText = function(e) {
								var t, n = "",
									r = 0,
									o = e.nodeType;
								if (o) {
									if (1 === o || 9 === o || 11 === o) {
										if ("string" == typeof e.textContent) return e.textContent;
										for (e = e.firstChild; e; e = e.nextSibling) n += k(e)
									} else if (3 === o || 4 === o) return e.nodeValue
								} else
									for (; t = e[r++];) n += k(t);
								return n
							}, (T = t.selectors = {
								cacheLength: 50,
								createPseudo: r,
								match: fe,
								attrHandle: {},
								find: {},
								relative: {
									">": {
										dir: "parentNode",
										first: !0
									},
									" ": {
										dir: "parentNode"
									},
									"+": {
										dir: "previousSibling",
										first: !0
									},
									"~": {
										dir: "previousSibling"
									}
								},
								preFilter: {
									ATTR: function(e) {
										return e[1] = e[1].replace(be, xe), e[3] = (e[3] || e[4] || e[5] ||
											"").replace(be, xe), "~=" === e[2] && (e[3] = " " + e[3] +
											" "), e.slice(0, 4)
									},
									CHILD: function(e) {
										return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ?
											(!e[3] && t.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) :
												2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[
												8] || "odd" === e[3])) : e[3] && t.error(e[0]), e
									},
									PSEUDO: function(e) {
										var t, n = !e[6] && e[2];
										return fe.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] ||
											"" : n && ue.test(n) && (t = S(n, !0)) && (t = n.indexOf(")",
												n.length - t) - n.length) && (e[0] = e[0].slice(0, t), e[2] =
												n.slice(0, t)), e.slice(0, 3))
									}
								},
								filter: {
									TAG: function(e) {
										var t = e.replace(be, xe).toLowerCase();
										return "*" === e ? function() {
											return !0
										} : function(e) {
											return e.nodeName && e.nodeName.toLowerCase() === t
										}
									},
									CLASS: function(e) {
										var t = W[e + " "];
										return t || (t = new RegExp("(^|" + re + ")" + e + "(" + re +
											"|$)")) && W(e, (function(e) {
											return t.test("string" == typeof e.className && e.className ||
												void 0 !== e.getAttribute && e.getAttribute("class") ||
												"")
										}))
									},
									ATTR: function(e, n, r) {
										return function(o) {
											var i = t.attr(o, e);
											return null == i ? "!=" === n : !n || (i += "", "=" === n ? i ===
												r : "!=" === n ? i !== r : "^=" === n ? r && 0 === i.indexOf(
													r) : "*=" === n ? r && -1 < i.indexOf(r) : "$=" === n ? r &&
												i.slice(-r.length) === r : "~=" === n ? -1 < (" " + i.replace(
													ie, " ") + " ").indexOf(r) : "|=" == n && (i === r || i.slice(
													0, r.length + 1) === r + "-"))
										}
									},
									CHILD: function(e, t, n, r, o) {
										var i = "nth" !== e.slice(0, 3),
											a = "last" !== e.slice(-4),
											s = "of-type" === t;
										return 1 === r && 0 === o ? function(e) {
											return !!e.parentNode
										} : function(t, n, c) {
											var l, u, d, f, p, h, m = i == a ? "previousSibling" :
												"nextSibling",
												g = t.parentNode,
												v = s && t.nodeName.toLowerCase(),
												y = !c && !s,
												b = !1;
											if (g) {
												if (i) {
													for (; m;) {
														for (f = t; f = f[m];)
															if (s ? f.nodeName.toLowerCase() === v : 1 === f.nodeType)
																return !1;
														h = m = "only" === e && !h && "nextSibling"
													}
													return !0
												}
												if (h = [a ? g.firstChild : g.lastChild], a && y) {
													for (b = (p = (l = (u = (d = (f = g)[z] || (f[z] = {}))[f.uniqueID] ||
															(d[f.uniqueID] = {}))[e] || [])[0] === F && l[1]) && l[2],
														f = p && g.childNodes[p]; f = ++p && f && f[m] || (b = p =
															0) || h.pop();)
														if (1 === f.nodeType && ++b && f === t) {
															u[e] = [F, p, b];
															break
														}
												} else if (y && (b = p = (l = (u = (d = (f = t)[z] || (f[z] = {}))[
															f.uniqueID] || (d[f.uniqueID] = {}))[e] || [])[0] === F &&
														l[1]), !1 === b)
													for (;
														(f = ++p && f && f[m] || (b = p = 0) || h.pop()) && ((s ?
																f.nodeName.toLowerCase() !== v : 1 !== f.nodeType) || !
															++b || (y && ((u = (d = f[z] || (f[z] = {}))[f.uniqueID] ||
																(d[f.uniqueID] = {}))[e] = [F, b]), f !== t)););
												return (b -= o) === r || 0 == b % r && 0 <= b / r
											}
										}
									},
									PSEUDO: function(e, n) {
										var o, i = T.pseudos[e] || T.setFilters[e.toLowerCase()] || t.error(
											"unsupported pseudo: " + e);
										return i[z] ? i(n) : 1 < i.length ? (o = [e, e, "", n], T.setFilters
											.hasOwnProperty(e.toLowerCase()) ? r((function(e, t) {
												for (var r, o = i(e, n), a = o.length; a--;) e[r = te(e, o[
													a])] = !(t[r] = o[a])
											})) : function(e) {
												return i(e, 0, o)
											}) : i
									}
								},
								pseudos: {
									not: r((function(e) {
										var t = [],
											n = [],
											o = j(e.replace(ae, "$1"));
										return o[z] ? r((function(e, t, n, r) {
											for (var i, a = o(e, null, r, []), s = e.length; s--;)(i =
												a[s]) && (e[s] = !(t[s] = i))
										})) : function(e, r, i) {
											return t[0] = e, o(t, null, i, n), t[0] = null, !n.pop()
										}
									})),
									has: r((function(e) {
										return function(n) {
											return 0 < t(e, n).length
										}
									})),
									contains: r((function(e) {
										return e = e.replace(be, xe),
											function(t) {
												return -1 < (t.textContent || k(t)).indexOf(e)
											}
									})),
									lang: r((function(e) {
										return de.test(e || "") || t.error("unsupported lang: " + e),
											e = e.replace(be, xe).toLowerCase(),
											function(t) {
												var n;
												do {
													if (n = O ? t.lang : t.getAttribute("xml:lang") || t.getAttribute(
															"lang")) return (n = n.toLowerCase()) === e || 0 === n.indexOf(
														e + "-")
												} while ((t = t.parentNode) && 1 === t.nodeType);
												return !1
											}
									})),
									target: function(t) {
										var n = e.location && e.location.hash;
										return n && n.slice(1) === t.id
									},
									root: function(e) {
										return e === I
									},
									focus: function(e) {
										return e === L.activeElement && (!L.hasFocus || L.hasFocus()) &&
											!!(e.type || e.href || ~e.tabIndex)
									},
									enabled: l(!1),
									disabled: l(!0),
									checked: function(e) {
										var t = e.nodeName.toLowerCase();
										return "input" === t && !!e.checked || "option" === t && !!e.selected
									},
									selected: function(e) {
										return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected
									},
									empty: function(e) {
										for (e = e.firstChild; e; e = e.nextSibling)
											if (6 > e.nodeType) return !1;
										return !0
									},
									parent: function(e) {
										return !T.pseudos.empty(e)
									},
									header: function(e) {
										return me.test(e.nodeName)
									},
									input: function(e) {
										return he.test(e.nodeName)
									},
									button: function(e) {
										var t = e.nodeName.toLowerCase();
										return "input" === t && "button" === e.type || "button" === t
									},
									text: function(e) {
										var t;
										return "input" === e.nodeName.toLowerCase() && "text" === e.type &&
											(null == (t = e.getAttribute("type")) || "text" === t.toLowerCase())
									},
									first: u((function() {
										return [0]
									})),
									last: u((function(e, t) {
										return [t - 1]
									})),
									eq: u((function(e, t, n) {
										return [0 > n ? n + t : n]
									})),
									even: u((function(e, t) {
										for (var n = 0; n < t; n += 2) e.push(n);
										return e
									})),
									odd: u((function(e, t) {
										for (var n = 1; n < t; n += 2) e.push(n);
										return e
									})),
									lt: u((function(e, t, n) {
										for (var r = 0 > n ? n + t : n > t ? t : n; 0 <= --r;) e.push(
											r);
										return e
									})),
									gt: u((function(e, t, n) {
										for (var r = 0 > n ? n + t : n; ++r < t;) e.push(r);
										return e
									}))
								}
							}).pseudos.nth = T.pseudos.eq, {
								radio: !0,
								checkbox: !0,
								file: !0,
								password: !0,
								image: !0
							}) T.pseudos[w] = s(w);
						for (w in {
								submit: !0,
								reset: !0
							}) T.pseudos[w] = c(w);
						return f.prototype = T.filters = T.pseudos, T.setFilters = new f, S =
							t.tokenize = function(e, n) {
								var r, o, i, a, s, c, l, u = U[e + " "];
								if (u) return n ? 0 : u.slice(0);
								for (s = e, c = [], l = T.preFilter; s;) {
									for (a in (!r || (o = se.exec(s))) && (o && (s = s.slice(o[0].length) ||
											s), c.push(i = [])), r = !1, (o = ce.exec(s)) && (r = o.shift(),
											i.push({
												value: r,
												type: o[0].replace(ae, " ")
											}), s = s.slice(r.length)), T.filter)(o = fe[a].exec(s)) && (!l[
										a] || (o = l[a](o))) && (r = o.shift(), i.push({
										value: r,
										type: a,
										matches: o
									}), s = s.slice(r.length));
									if (!r) break
								}
								return n ? s.length : s ? t.error(e) : U(e, c).slice(0)
							}, j = t.compile = function(e, t) {
								var n, r = [],
									o = [],
									i = X[e + " "];
								if (!i) {
									for (t || (t = S(e)), n = t.length; n--;)(i = b(t[n]))[z] ? r.push(
										i) : o.push(i);
									(i = X(e, x(o, r))).selector = e
								}
								return i
							}, $ = t.select = function(e, t, n, r) {
								var o, i, a, s, c, l = "function" == typeof e && e,
									u = !r && S(e = l.selector || e);
								if (n = n || [], 1 === u.length) {
									if (2 < (i = u[0] = u[0].slice(0)).length && "ID" === (a = i[0]).type &&
										9 === t.nodeType && O && T.relative[i[1].type]) {
										if (!(t = (T.find.ID(a.matches[0].replace(be, xe), t) || [])[0]))
											return n;
										l && (t = t.parentNode), e = e.slice(i.shift().value.length)
									}
									for (o = fe.needsContext.test(e) ? 0 : i.length; o-- && (a = i[o], !
											T.relative[s = a.type]);)
										if ((c = T.find[s]) && (r = c(a.matches[0].replace(be, xe), ye.test(
												i[0].type) && d(t.parentNode) || t))) {
											if (i.splice(o, 1), !(e = r.length && p(i))) return Q.apply(n, r),
												n;
											break
										}
								}
								return (l || j(e, u))(r, t, !O, n, !t || ye.test(e) && d(t.parentNode) ||
									t), n
							}, C.sortStable = z.split("").sort(V).join("") === z, C.detectDuplicates = !
							!D, N(), C.sortDetached = o((function(e) {
								return 1 & e.compareDocumentPosition(L.createElement("fieldset"))
							})), o((function(e) {
								return e.innerHTML = "<a href='#'></a>", "#" === e.firstChild.getAttribute(
									"href")
							})) || i("type|href|height|width", (function(e, t, n) {
								if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 :
									2)
							})), C.attributes && o((function(e) {
								return e.innerHTML = "<input/>", e.firstChild.setAttribute(
									"value", ""), "" === e.firstChild.getAttribute("value")
							})) || i("value", (function(e, t, n) {
								if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue
							})), o((function(e) {
								return null == e.getAttribute("disabled")
							})) || i(ne, (function(e, t, n) {
								var r;
								if (!n) return !0 === e[t] ? t.toLowerCase() : (r = e.getAttributeNode(
									t)) && r.specified ? r.value : null
							})), t
					}(o);
				we.find = Ce, we.expr = Ce.selectors, we.expr[":"] = we.expr.pseudos,
					we.uniqueSort = we.unique = Ce.uniqueSort, we.text = Ce.getText, we.isXMLDoc =
					Ce.isXML, we.contains = Ce.contains, we.escapeSelector = Ce.escape;
				var Te = function(e, t, n) {
						for (var r = [];
							(e = e[t]) && 9 !== e.nodeType;)
							if (1 === e.nodeType) {
								if (void 0 !== n && we(e).is(n)) break;
								r.push(e)
							}
						return r
					},
					ke = function(e, t) {
						for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t &&
							n.push(e);
						return n
					},
					_e = we.expr.match.needsContext,
					Se = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
				we.filter = function(e, t, n) {
					var r = t[0];
					return n && (e = ":not(" + e + ")"), 1 === t.length && 1 === r.nodeType ?
						we.find.matchesSelector(r, e) ? [r] : [] : we.find.matches(e, we.grep(
							t, (function(e) {
								return 1 === e.nodeType
							})))
				}, we.fn.extend({
					find: function(e) {
						var t, n, r = this.length,
							o = this;
						if ("string" != typeof e) return this.pushStack(we(e).filter((
							function() {
								for (t = 0; t < r; t++)
									if (we.contains(o[t], this)) return !0
							})));
						for (n = this.pushStack([]), t = 0; t < r; t++) we.find(e, o[t], n);
						return 1 < r ? we.uniqueSort(n) : n
					},
					filter: function(e) {
						return this.pushStack(u(this, e || [], !1))
					},
					not: function(e) {
						return this.pushStack(u(this, e || [], !0))
					},
					is: function(e) {
						return !!u(this, "string" == typeof e && _e.test(e) ? we(e) : e || [], !
							1).length
					}
				});
				var je, $e = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
				(we.fn.init = function(e, t, n) {
					var r, o;
					if (!e) return this;
					if (n = n || je, "string" == typeof e) {
						if ((r = "<" === e[0] && ">" === e[e.length - 1] && 3 <= e.length ? [
								null, e, null
							] : $e.exec(e)) && (r[1] || !t)) {
							if (r[1]) {
								if (t = t instanceof we ? t[0] : t, we.merge(this, we.parseHTML(r[
										1], t && t.nodeType ? t.ownerDocument || t : be, !0)), Se.test(r[
										1]) && we.isPlainObject(t))
									for (r in t) ve(this[r]) ? this[r](t[r]) : this.attr(r, t[r]);
								return this
							}
							return (o = be.getElementById(r[2])) && (this[0] = o, this.length =
								1), this
						}
						return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(
							e)
					}
					return e.nodeType ? (this[0] = e, this.length = 1, this) : ve(e) ?
						void 0 === n.ready ? e(we) : n.ready(e) : we.makeArray(e, this)
				}).prototype = we.fn, je = we(be);
				var Ee = /^(?:parents|prev(?:Until|All))/,
					Ae = {
						children: !0,
						contents: !0,
						next: !0,
						prev: !0
					};
				we.fn.extend({
					has: function(e) {
						var t = we(e, this),
							n = t.length;
						return this.filter((function() {
							for (var e = 0; e < n; e++)
								if (we.contains(this, t[e])) return !0
						}))
					},
					closest: function(e, t) {
						var n, r = 0,
							o = this.length,
							i = [],
							a = "string" != typeof e && we(e);
						if (!_e.test(e))
							for (; r < o; r++)
								for (n = this[r]; n && n !== t; n = n.parentNode)
									if (11 > n.nodeType && (a ? -1 < a.index(n) : 1 === n.nodeType &&
											we.find.matchesSelector(n, e))) {
										i.push(n);
										break
									}
						return this.pushStack(1 < i.length ? we.uniqueSort(i) : i)
					},
					index: function(e) {
						return e ? "string" == typeof e ? ue.call(we(e), this[0]) : ue.call(
								this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ?
							this.first().prevAll().length : -1
					},
					add: function(e, t) {
						return this.pushStack(we.uniqueSort(we.merge(this.get(), we(e, t))))
					},
					addBack: function(e) {
						return this.add(null == e ? this.prevObject : this.prevObject.filter(
							e))
					}
				}), we.each({
					parent: function(e) {
						var t = e.parentNode;
						return t && 11 !== t.nodeType ? t : null
					},
					parents: function(e) {
						return Te(e, "parentNode")
					},
					parentsUntil: function(e, t, n) {
						return Te(e, "parentNode", n)
					},
					next: function(e) {
						return d(e, "nextSibling")
					},
					prev: function(e) {
						return d(e, "previousSibling")
					},
					nextAll: function(e) {
						return Te(e, "nextSibling")
					},
					prevAll: function(e) {
						return Te(e, "previousSibling")
					},
					nextUntil: function(e, t, n) {
						return Te(e, "nextSibling", n)
					},
					prevUntil: function(e, t, n) {
						return Te(e, "previousSibling", n)
					},
					siblings: function(e) {
						return ke((e.parentNode || {}).firstChild, e)
					},
					children: function(e) {
						return ke(e.firstChild)
					},
					contents: function(e) {
						return null != e.contentDocument && ae(e.contentDocument) ? e.contentDocument :
							(l(e, "template") && (e = e.content || e), we.merge([], e.childNodes))
					}
				}, (function(e, t) {
					we.fn[e] = function(n, r) {
						var o = we.map(this, t, n);
						return "Until" !== e.slice(-5) && (r = n), r && "string" ==
							typeof r && (o = we.filter(r, o)), 1 < this.length && (!Ae[e] &&
								we.uniqueSort(o), Ee.test(e) && o.reverse()), this.pushStack(o)
					}
				}));
				var De = /[^\x20\t\r\n\f]+/g;
				we.Callbacks = function(e) {
					e = "string" == typeof e ? function(e) {
						var t = {};
						return we.each(e.match(De) || [], (function(e, n) {
							t[n] = !0
						})), t
					}(e) : we.extend({}, e);
					var t, n, r, o, i = [],
						a = [],
						c = -1,
						l = function() {
							for (o = o || e.once, r = t = !0; a.length; c = -1)
								for (n = a.shift(); ++c < i.length;) !1 === i[c].apply(n[0], n[1]) &&
									e.stopOnFalse && (c = i.length, n = !1);
							e.memory || (n = !1), t = !1, o && (i = n ? [] : "")
						},
						u = {
							add: function() {
								return i && (n && !t && (c = i.length - 1, a.push(n)), function t(
									n) {
									we.each(n, (function(n, r) {
										ve(r) ? (!e.unique || !u.has(r)) && i.push(r) : r && r.length &&
											"string" !== s(r) && t(r)
									}))
								}(arguments), n && !t && l()), this
							},
							remove: function() {
								return we.each(arguments, (function(e, t) {
									for (var n; - 1 < (n = we.inArray(t, i, n));) i.splice(n, 1),
										n <= c && c--
								})), this
							},
							has: function(e) {
								return e ? -1 < we.inArray(e, i) : 0 < i.length
							},
							empty: function() {
								return i && (i = []), this
							},
							disable: function() {
								return o = a = [], i = n = "", this
							},
							disabled: function() {
								return !i
							},
							lock: function() {
								return o = a = [], n || t || (i = n = ""), this
							},
							locked: function() {
								return !!o
							},
							fireWith: function(e, n) {
								return o || (n = [e, (n = n || []).slice ? n.slice() : n], a.push(
									n), !t && l()), this
							},
							fire: function() {
								return u.fireWith(this, arguments), this
							},
							fired: function() {
								return !!r
							}
						};
					return u
				}, we.extend({
					Deferred: function(e) {
						var t = [
								["notify", "progress", we.Callbacks("memory"), we.Callbacks(
									"memory"), 2],
								["resolve", "done", we.Callbacks("once memory"), we.Callbacks(
									"once memory"), 0, "resolved"],
								["reject", "fail", we.Callbacks("once memory"), we.Callbacks(
									"once memory"), 1, "rejected"]
							],
							r = "pending",
							i = {
								state: function() {
									return r
								},
								always: function() {
									return a.done(arguments).fail(arguments), this
								},
								catch: function(e) {
									return i.then(null, e)
								},
								pipe: function() {
									var e = arguments;
									return we.Deferred((function(n) {
										we.each(t, (function(t, r) {
											var o = ve(e[r[4]]) && e[r[4]];
											a[r[1]]((function() {
												var e = o && o.apply(this, arguments);
												e && ve(e.promise) ? e.promise().progress(n.notify)
													.done(n.resolve).fail(n.reject) : n[r[0] + "With"]
													(this, o ? [e] : arguments)
											}))
										})), e = null
									})).promise()
								},
								then: function(e, r, i) {
									function a(e, t, r, i) {
										return function() {
											var c = this,
												l = arguments,
												u = function() {
													var o, u;
													if (!(e < s)) {
														if ((o = r.apply(c, l)) === t.promise()) throw new TypeError(
															"Thenable self-resolution");
														u = o && ("object" === n(o) || "function" == typeof o) &&
															o.then, ve(u) ? i ? u.call(o, a(s, t, f, i), a(s, t, p,
																i)) : (s++, u.call(o, a(s, t, f, i), a(s, t, p, i), a(
																s, t, f, t.notifyWith))) : (r !== f && (c = void 0, l = [
																o
															]), (i || t.resolveWith)(c, l))
													}
												},
												d = i ? u : function() {
													try {
														u()
													} catch (n) {
														we.Deferred.exceptionHook && we.Deferred.exceptionHook(n,
															d.stackTrace), e + 1 >= s && (r !== p && (c = void 0,
															l = [n]), t.rejectWith(c, l))
													}
												};
											e ? d() : (we.Deferred.getStackHook && (d.stackTrace = we.Deferred
												.getStackHook()), o.setTimeout(d))
										}
									}
									var s = 0;
									return we.Deferred((function(n) {
										t[0][3].add(a(0, n, ve(i) ? i : f, n.notifyWith)), t[1][3]
											.add(a(0, n, ve(e) ? e : f)), t[2][3].add(a(0, n, ve(r) ?
												r : p))
									})).promise()
								},
								promise: function(e) {
									return null == e ? i : we.extend(e, i)
								}
							},
							a = {};
						return we.each(t, (function(e, n) {
							var o = n[2],
								s = n[5];
							i[n[1]] = o.add, s && o.add((function() {
									r = s
								}), t[3 - e][2].disable, t[3 - e][3].disable, t[0][2].lock,
								t[0][3].lock), o.add(n[3].fire), a[n[0]] = function() {
								return a[n[0] + "With"](this === a ? void 0 : this,
									arguments), this
							}, a[n[0] + "With"] = o.fireWith
						})), i.promise(a), e && e.call(a, a), a
					},
					when: function(e) {
						var t = arguments.length,
							n = t,
							r = Array(n),
							o = se.call(arguments),
							i = we.Deferred(),
							a = function(e) {
								return function(n) {
									r[e] = this, o[e] = 1 < arguments.length ? se.call(arguments) :
										n, --t || i.resolveWith(r, o)
								}
							};
						if (1 >= t && (h(e, i.done(a(n)).resolve, i.reject, !t), "pending" ===
								i.state() || ve(o[n] && o[n].then))) return i.then();
						for (; n--;) h(o[n], a(n), i.reject);
						return i.promise()
					}
				});
				var Ne = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
				we.Deferred.exceptionHook = function(e, t) {
					o.console && o.console.warn && e && Ne.test(e.name) && o.console.warn(
						"jQuery.Deferred exception: " + e.message, e.stack, t)
				}, we.readyException = function(e) {
					o.setTimeout((function() {
						throw e
					}))
				};
				var Le = we.Deferred();
				we.fn.ready = function(e) {
						return Le.then(e).catch((function(e) {
							we.readyException(e)
						})), this
					}, we.extend({
						isReady: !1,
						readyWait: 1,
						ready: function(e) {
							(!0 === e ? !--we.readyWait : !we.isReady) && (we.isReady = !0, !0 !==
								e && 0 < --we.readyWait || Le.resolveWith(be, [we]))
						}
					}), we.ready.then = Le.then, "complete" === be.readyState || "loading" !==
					be.readyState && !be.documentElement.doScroll ? o.setTimeout(we.ready) :
					(be.addEventListener("DOMContentLoaded", m), o.addEventListener("load",
						m));
				var Ie = function e(t, n, r, o, i, a, c) {
						var l = 0,
							u = t.length,
							d = null == r;
						if ("object" === s(r))
							for (l in i = !0, r) e(t, n, l, r[l], !0, a, c);
						else if (void 0 !== o && (i = !0, ve(o) || (c = !0), d && (c ? (n.call(
								t, o), n = null) : (d = n, n = function(e, t, n) {
								return d.call(we(e), n)
							})), n))
							for (; l < u; l++) n(t[l], r, c ? o : o.call(t[l], l, n(t[l], r)));
						return i ? t : d ? n.call(t) : u ? n(t[0], r) : a
					},
					Oe = /^-ms-/,
					Pe = /-([a-z])/g,
					qe = function(e) {
						return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType
					};
				y.uid = 1, y.prototype = {
					cache: function(e) {
						var t = e[this.expando];
						return t || (t = {}, qe(e) && (e.nodeType ? e[this.expando] = t :
							Object.defineProperty(e, this.expando, {
								value: t,
								configurable: !0
							}))), t
					},
					set: function(e, t, n) {
						var r, o = this.cache(e);
						if ("string" == typeof t) o[v(t)] = n;
						else
							for (r in t) o[v(r)] = t[r];
						return o
					},
					get: function(e, t) {
						return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando]
							[v(t)]
					},
					access: function(e, t, n) {
						return void 0 === t || t && "string" == typeof t && void 0 === n ?
							this.get(e, t) : (this.set(e, t, n), void 0 === n ? t : n)
					},
					remove: function(e, t) {
						var n, r = e[this.expando];
						if (void 0 !== r) {
							if (void 0 !== t)
								for ((Array.isArray(t) ? t = t.map(v) : t = (t = v(t)) in r ? [t] :
										t.match(De) || [], n = t.length); n--;) delete r[t[n]];
							(void 0 === t || we.isEmptyObject(r)) && (e.nodeType ? e[this.expando] =
								void 0 : delete e[this.expando])
						}
					},
					hasData: function(e) {
						var t = e[this.expando];
						return void 0 !== t && !we.isEmptyObject(t)
					}
				};
				var He = new y,
					Me = new y,
					ze = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
					Be = /[A-Z]/g;
				we.extend({
					hasData: function(e) {
						return Me.hasData(e) || He.hasData(e)
					},
					data: function(e, t, n) {
						return Me.access(e, t, n)
					},
					removeData: function(e, t) {
						Me.remove(e, t)
					},
					_data: function(e, t, n) {
						return He.access(e, t, n)
					},
					_removeData: function(e, t) {
						He.remove(e, t)
					}
				}), we.fn.extend({
					data: function(e, t) {
						var r, o, i, a = this[0],
							s = a && a.attributes;
						if (void 0 === e) {
							if (this.length && (i = Me.get(a), 1 === a.nodeType && !He.get(a,
									"hasDataAttrs"))) {
								for (r = s.length; r--;) s[r] && (0 === (o = s[r].name).indexOf(
									"data-") && (o = v(o.slice(5)), b(a, o, i[o])));
								He.set(a, "hasDataAttrs", !0)
							}
							return i
						}
						return "object" === n(e) ? this.each((function() {
							Me.set(this, e)
						})) : Ie(this, (function(t) {
							var n;
							return a && void 0 === t ? void 0 !== (n = Me.get(a, e)) ? n :
								void 0 === (n = b(a, e)) ? void 0 : n : void this.each((
									function() {
										Me.set(this, e, t)
									}))
						}), null, t, 1 < arguments.length, null, !0)
					},
					removeData: function(e) {
						return this.each((function() {
							Me.remove(this, e)
						}))
					}
				}), we.extend({
					queue: function(e, t, n) {
						var r;
						if (e) return t = (t || "fx") + "queue", r = He.get(e, t), n && (!
							r || Array.isArray(n) ? r = He.access(e, t, we.makeArray(n)) :
							r.push(n)), r || []
					},
					dequeue: function(e, t) {
						t = t || "fx";
						var n = we.queue(e, t),
							r = n.length,
							o = n.shift(),
							i = we._queueHooks(e, t);
						"inprogress" === o && (o = n.shift(), r--), o && ("fx" === t && n.unshift(
							"inprogress"), delete i.stop, o.call(e, (function() {
							we.dequeue(e, t)
						}), i)), !r && i && i.empty.fire()
					},
					_queueHooks: function(e, t) {
						var n = t + "queueHooks";
						return He.get(e, n) || He.access(e, n, {
							empty: we.Callbacks("once memory").add((function() {
								He.remove(e, [t + "queue", n])
							}))
						})
					}
				}), we.fn.extend({
					queue: function(e, t) {
						var n = 2;
						return "string" != typeof e && (t = e, e = "fx", n--), arguments.length <
							n ? we.queue(this[0], e) : void 0 === t ? this : this.each((
								function() {
									var n = we.queue(this, e, t);
									we._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] &&
										we.dequeue(this, e)
								}))
					},
					dequeue: function(e) {
						return this.each((function() {
							we.dequeue(this, e)
						}))
					},
					clearQueue: function(e) {
						return this.queue(e || "fx", [])
					},
					promise: function(e, t) {
						var n, r = 1,
							o = we.Deferred(),
							i = this,
							a = this.length,
							s = function() {
								--r || o.resolveWith(i, [i])
							};
						for ("string" != typeof e && (t = e, e = void 0), e = e || "fx"; a--;)
							(n = He.get(i[a], e + "queueHooks")) && n.empty && (r++, n.empty.add(
								s));
						return s(), o.promise(t)
					}
				});
				var Fe = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
					Re = new RegExp("^(?:([+-])=|)(" + Fe + ")([a-z%]*)$", "i"),
					We = ["Top", "Right", "Bottom", "Left"],
					Ue = be.documentElement,
					Xe = function(e) {
						return we.contains(e.ownerDocument, e)
					},
					Ge = {
						composed: !0
					};
				Ue.getRootNode && (Xe = function(e) {
					return we.contains(e.ownerDocument, e) || e.getRootNode(Ge) === e.ownerDocument
				});
				var Ve = function(e, t) {
						return "none" === (e = t || e).style.display || "" === e.style.display &&
							Xe(e) && "none" === we.css(e, "display")
					},
					Ye = {};
				we.fn.extend({
					show: function() {
						return C(this, !0)
					},
					hide: function() {
						return C(this)
					},
					toggle: function(e) {
						return "boolean" == typeof e ? e ? this.show() : this.hide() :
							this.each((function() {
								Ve(this) ? we(this).show() : we(this).hide()
							}))
					}
				});
				var Ke = /^(?:checkbox|radio)$/i,
					Je = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
					Ze = /^$|^module$|\/(?:java|ecma)script/i;
				! function() {
					var e = be.createDocumentFragment().appendChild(be.createElement("div")),
						t = be.createElement("input");
					t.setAttribute("type", "radio"), t.setAttribute("checked", "checked"),
						t.setAttribute("name", "t"), e.appendChild(t), ge.checkClone = e.cloneNode(!
							0).cloneNode(!0).lastChild.checked, e.innerHTML =
						"<textarea>x</textarea>", ge.noCloneChecked = !!e.cloneNode(!0).lastChild
						.defaultValue, e.innerHTML = "<option></option>", ge.option = !!e.lastChild
				}();
				var Qe = {
					thead: [1, "<table>", "</table>"],
					col: [2, "<table><colgroup>", "</colgroup></table>"],
					tr: [2, "<table><tbody>", "</tbody></table>"],
					td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
					_default: [0, "", ""]
				};
				Qe.tbody = Qe.tfoot = Qe.colgroup = Qe.caption = Qe.thead, Qe.th = Qe.td,
					ge.option || (Qe.optgroup = Qe.option = [1,
						"<select multiple='multiple'>", "</select>"
					]);
				var et = /<|&#?\w+;/,
					tt = /^key/,
					nt = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
					rt = /^([^.]*)(?:\.(.+)|)/;
				we.event = {
					global: {},
					add: function(e, t, n, r, o) {
						var i, a, s, c, l, u, d, f, p, h, m, g = He.get(e);
						if (qe(e))
							for (n.handler && (n = (i = n).handler, o = i.selector), o && we.find
								.matchesSelector(Ue, o), n.guid || (n.guid = we.guid++), (c = g.events) ||
								(c = g.events = Object.create(null)), (a = g.handle) || (a = g.handle =
									function(t) {
										return void 0 !== we && we.event.triggered !== t.type ? we.event
											.dispatch.apply(e, arguments) : void 0
									}), l = (t = (t || "").match(De) || [""]).length; l--;) p = m =
								(s = rt.exec(t[l]) || [])[1], h = (s[2] || "").split(".").sort(),
								p && (d = we.event.special[p] || {}, p = (o ? d.delegateType : d.bindType) ||
									p, d = we.event.special[p] || {}, u = we.extend({
										type: p,
										origType: m,
										data: r,
										handler: n,
										guid: n.guid,
										selector: o,
										needsContext: o && we.expr.match.needsContext.test(o),
										namespace: h.join(".")
									}, i), (f = c[p]) || ((f = c[p] = []).delegateCount = 0, (!d.setup ||
										!1 === d.setup.call(e, r, h, a)) && e.addEventListener && e.addEventListener(
										p, a)), d.add && (d.add.call(e, u), !u.handler.guid && (u.handler
										.guid = n.guid)), o ? f.splice(f.delegateCount++, 0, u) : f.push(
										u), we.event.global[p] = !0)
					},
					remove: function(e, t, n, r, o) {
						var i, a, s, c, l, u, d, f, p, h, m, g = He.hasData(e) && He.get(e);
						if (g && (c = g.events)) {
							for (l = (t = (t || "").match(De) || [""]).length; l--;)
								if (p = m = (s = rt.exec(t[l]) || [])[1], h = (s[2] || "").split(
										".").sort(), p) {
									for (d = we.event.special[p] || {}, f = c[p = (r ? d.delegateType :
											d.bindType) || p] || [], s = s[2] && new RegExp("(^|\\.)" + h.join(
											"\\.(?:.*\\.|)") + "(\\.|$)"), a = i = f.length; i--;) u = f[i], (
										o || m === u.origType) && (!n || n.guid === u.guid) && (!s ||
										s.test(u.namespace)) && (!r || r === u.selector || "**" === r &&
										u.selector) && (f.splice(i, 1), u.selector && f.delegateCount--,
										d.remove && d.remove.call(e, u));
									a && !f.length && ((!d.teardown || !1 === d.teardown.call(e, h,
										g.handle)) && we.removeEvent(e, p, g.handle), delete c[p])
								} else
									for (p in c) we.event.remove(e, p + t[l], n, r, !0);
							we.isEmptyObject(c) && He.remove(e, "handle events")
						}
					},
					dispatch: function(e) {
						var t, n, r, o, i, a, s = Array(arguments.length),
							c = we.event.fix(e),
							l = (He.get(this, "events") || Object.create(null))[c.type] || [],
							u = we.event.special[c.type] || {};
						for (s[0] = c, t = 1; t < arguments.length; t++) s[t] = arguments[t];
						if (c.delegateTarget = this, !u.preDispatch || !1 !== u.preDispatch
							.call(this, c)) {
							for (a = we.event.handlers.call(this, c, l), t = 0;
								(o = a[t++]) && !c.isPropagationStopped();)
								for (c.currentTarget = o.elem, n = 0;
									(i = o.handlers[n++]) && !c.isImmediatePropagationStopped();)(!c
									.rnamespace || !1 === i.namespace || c.rnamespace.test(i.namespace)
								) && (c.handleObj = i, c.data = i.data, void 0 !== (r = ((we.event
									.special[i.origType] || {}).handle || i.handler).apply(o.elem,
									s)) && !1 === (c.result = r) && (c.preventDefault(), c.stopPropagation()));
							return u.postDispatch && u.postDispatch.call(this, c), c.result
						}
					},
					handlers: function(e, t) {
						var n, r, o, i, a, s = [],
							c = t.delegateCount,
							l = e.target;
						if (c && l.nodeType && !("click" === e.type && 1 <= e.button))
							for (; l !== this; l = l.parentNode || this)
								if (1 === l.nodeType && ("click" !== e.type || !0 !== l.disabled)) {
									for (i = [], a = {}, n = 0; n < c; n++) void 0 === a[o = (r = t[
											n]).selector + " "] && (a[o] = r.needsContext ? -1 < we(o,
											this).index(l) : we.find(o, this, null, [l]).length), a[o] &&
										i.push(r);
									i.length && s.push({
										elem: l,
										handlers: i
									})
								}
						return l = this, c < t.length && s.push({
							elem: l,
							handlers: t.slice(c)
						}), s
					},
					addProp: function(e, t) {
						Object.defineProperty(we.Event.prototype, e, {
							enumerable: !0,
							configurable: !0,
							get: ve(t) ? function() {
								if (this.originalEvent) return t(this.originalEvent)
							} : function() {
								if (this.originalEvent) return this.originalEvent[e]
							},
							set: function(t) {
								Object.defineProperty(this, e, {
									enumerable: !0,
									configurable: !0,
									writable: !0,
									value: t
								})
							}
						})
					},
					fix: function(e) {
						return e[we.expando] ? e : new we.Event(e)
					},
					special: {
						load: {
							noBubble: !0
						},
						click: {
							setup: function(e) {
								var t = this || e;
								return Ke.test(t.type) && t.click && l(t, "input") && A(t,
									"click", S), !1
							},
							trigger: function(e) {
								var t = this || e;
								return Ke.test(t.type) && t.click && l(t, "input") && A(t,
									"click"), !0
							},
							_default: function(e) {
								var t = e.target;
								return Ke.test(t.type) && t.click && l(t, "input") && He.get(t,
									"click") || l(t, "a")
							}
						},
						beforeunload: {
							postDispatch: function(e) {
								void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue =
									e.result)
							}
						}
					}
				}, we.removeEvent = function(e, t, n) {
					e.removeEventListener && e.removeEventListener(t, n)
				}, we.Event = function(e, t) {
					return this instanceof we.Event ? (e && e.type ? (this.originalEvent =
								e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented ||
								void 0 === e.defaultPrevented && !1 === e.returnValue ? S : j,
								this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode :
								e.target, this.currentTarget = e.currentTarget, this.relatedTarget =
								e.relatedTarget) : this.type = e, t && we.extend(this, t), this.timeStamp =
							e && e.timeStamp || Date.now(), void(this[we.expando] = !0)) : new we
						.Event(e, t)
				}, we.Event.prototype = {
					constructor: we.Event,
					isDefaultPrevented: j,
					isPropagationStopped: j,
					isImmediatePropagationStopped: j,
					isSimulated: !1,
					preventDefault: function() {
						var e = this.originalEvent;
						this.isDefaultPrevented = S, e && !this.isSimulated && e.preventDefault()
					},
					stopPropagation: function() {
						var e = this.originalEvent;
						this.isPropagationStopped = S, e && !this.isSimulated && e.stopPropagation()
					},
					stopImmediatePropagation: function() {
						var e = this.originalEvent;
						this.isImmediatePropagationStopped = S, e && !this.isSimulated && e
							.stopImmediatePropagation(), this.stopPropagation()
					}
				}, we.each({
					altKey: !0,
					bubbles: !0,
					cancelable: !0,
					changedTouches: !0,
					ctrlKey: !0,
					detail: !0,
					eventPhase: !0,
					metaKey: !0,
					pageX: !0,
					pageY: !0,
					shiftKey: !0,
					view: !0,
					char: !0,
					code: !0,
					charCode: !0,
					key: !0,
					keyCode: !0,
					button: !0,
					buttons: !0,
					clientX: !0,
					clientY: !0,
					offsetX: !0,
					offsetY: !0,
					pointerId: !0,
					pointerType: !0,
					screenX: !0,
					screenY: !0,
					targetTouches: !0,
					toElement: !0,
					touches: !0,
					which: function(e) {
						var t = e.button;
						return null == e.which && tt.test(e.type) ? null == e.charCode ? e
							.keyCode : e.charCode : !e.which && void 0 !== t && nt.test(e.type) ?
							1 & t ? 1 : 2 & t ? 3 : 4 & t ? 2 : 0 : e.which
					}
				}, we.event.addProp), we.each({
					focus: "focusin",
					blur: "focusout"
				}, (function(e, t) {
					we.event.special[e] = {
						setup: function() {
							return A(this, e, $), !1
						},
						trigger: function() {
							return A(this, e), !0
						},
						delegateType: t
					}
				})), we.each({
					mouseenter: "mouseover",
					mouseleave: "mouseout",
					pointerenter: "pointerover",
					pointerleave: "pointerout"
				}, (function(e, t) {
					we.event.special[e] = {
						delegateType: t,
						bindType: t,
						handle: function(e) {
							var n, r = this,
								o = e.relatedTarget,
								i = e.handleObj;
							return o && (o === r || we.contains(r, o)) || (e.type = i.origType,
								n = i.handler.apply(this, arguments), e.type = t), n
						}
					}
				})), we.fn.extend({
					on: function(e, t, n, r) {
						return E(this, e, t, n, r)
					},
					one: function(e, t, n, r) {
						return E(this, e, t, n, r, 1)
					},
					off: function(e, t, r) {
						var o, i;
						if (e && e.preventDefault && e.handleObj) return o = e.handleObj,
							we(e.delegateTarget).off(o.namespace ? o.origType + "." + o.namespace :
								o.origType, o.selector, o.handler), this;
						if ("object" === n(e)) {
							for (i in e) this.off(i, t, e[i]);
							return this
						}
						return (!1 === t || "function" == typeof t) && (r = t, t = void 0), !
							1 === r && (r = j), this.each((function() {
								we.event.remove(this, e, r, t)
							}))
					}
				});
				var ot = /<script|<style|<link/i,
					it = /checked\s*(?:[^=]|=\s*.checked.)/i,
					at = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
				we.extend({
					htmlPrefilter: function(e) {
						return e
					},
					clone: function(e, t, n) {
						var r, o, i, a, s = e.cloneNode(!0),
							c = Xe(e);
						if (!(ge.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType ||
								we.isXMLDoc(e)))
							for (a = T(s), r = 0, o = (i = T(e)).length; r < o; r++) O(i[r],
								a[r]);
						if (t)
							if (n)
								for (i = i || T(e), a = a || T(s), r = 0, o = i.length; r < o; r++)
									I(i[r], a[r]);
							else I(e, s);
						return 0 < (a = T(s, "script")).length && k(a, !c && T(e, "script")),
							s
					},
					cleanData: function(e) {
						for (var t, n, r, o = we.event.special, i = 0; void 0 !== (n = e[i]); i++)
							if (qe(n)) {
								if (t = n[He.expando]) {
									if (t.events)
										for (r in t.events) o[r] ? we.event.remove(n, r) : we.removeEvent(
											n, r, t.handle);
									n[He.expando] = void 0
								}
								n[Me.expando] && (n[Me.expando] = void 0)
							}
					}
				}), we.fn.extend({
					detach: function(e) {
						return q(this, e, !0)
					},
					remove: function(e) {
						return q(this, e)
					},
					text: function(e) {
						return Ie(this, (function(e) {
							return void 0 === e ? we.text(this) : this.empty().each((
								function() {
									(1 === this.nodeType || 11 === this.nodeType || 9 === this
										.nodeType) && (this.textContent = e)
								}))
						}), null, e, arguments.length)
					},
					append: function() {
						return P(this, arguments, (function(e) {
							1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType ||
								D(this, e).appendChild(e)
						}))
					},
					prepend: function() {
						return P(this, arguments, (function(e) {
							if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
								var t = D(this, e);
								t.insertBefore(e, t.firstChild)
							}
						}))
					},
					before: function() {
						return P(this, arguments, (function(e) {
							this.parentNode && this.parentNode.insertBefore(e, this)
						}))
					},
					after: function() {
						return P(this, arguments, (function(e) {
							this.parentNode && this.parentNode.insertBefore(e, this.nextSibling)
						}))
					},
					empty: function() {
						for (var e, t = 0; null != (e = this[t]); t++) 1 === e.nodeType &&
							(we.cleanData(T(e, !1)), e.textContent = "");
						return this
					},
					clone: function(e, t) {
						return e = null != e && e, t = null == t ? e : t, this.map((
							function() {
								return we.clone(this, e, t)
							}))
					},
					html: function(e) {
						return Ie(this, (function(e) {
							var t = this[0] || {},
								n = 0,
								r = this.length;
							if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
							if ("string" == typeof e && !ot.test(e) && !Qe[(Je.exec(e) || [
									"", ""
								])[1].toLowerCase()]) {
								e = we.htmlPrefilter(e);
								try {
									for (; n < r; n++) 1 === (t = this[n] || {}).nodeType && (we
										.cleanData(T(t, !1)), t.innerHTML = e);
									t = 0
								} catch (t) {}
							}
							t && this.empty().append(e)
						}), null, e, arguments.length)
					},
					replaceWith: function() {
						var e = [];
						return P(this, arguments, (function(t) {
							var n = this.parentNode;
							0 > we.inArray(this, e) && (we.cleanData(T(this)), n && n.replaceChild(
								t, this))
						}), e)
					}
				}), we.each({
					appendTo: "append",
					prependTo: "prepend",
					insertBefore: "before",
					insertAfter: "after",
					replaceAll: "replaceWith"
				}, (function(e, t) {
					we.fn[e] = function(e) {
						for (var n, r = [], o = we(e), i = o.length - 1, a = 0; a <= i; a++)
							n = a === i ? this : this.clone(!0), we(o[a])[t](n), le.apply(r,
								n.get());
						return this.pushStack(r)
					}
				}));
				var st = new RegExp("^(" + Fe + ")(?!px)[a-z%]+$", "i"),
					ct = function(e) {
						var t = e.ownerDocument.defaultView;
						return t && t.opener || (t = o), t.getComputedStyle(e)
					},
					lt = function(e, t, n) {
						var r, o, i = {};
						for (o in t) i[o] = e.style[o], e.style[o] = t[o];
						for (o in r = n.call(e), t) e.style[o] = i[o];
						return r
					},
					ut = new RegExp(We.join("|"), "i");
				! function() {
					function e() {
						if (u) {
							l.style.cssText =
								"position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",
								u.style.cssText =
								"position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",
								Ue.appendChild(l).appendChild(u);
							var e = o.getComputedStyle(u);
							n = "1%" !== e.top, c = 12 === t(e.marginLeft), u.style.right =
								"60%", a = 36 === t(e.right), r = 36 === t(e.width), u.style.position =
								"absolute", i = 12 === t(u.offsetWidth / 3), Ue.removeChild(l), u =
								null
						}
					}

					function t(e) {
						return Math.round(parseFloat(e))
					}
					var n, r, i, a, s, c, l = be.createElement("div"),
						u = be.createElement("div");
					u.style && (u.style.backgroundClip = "content-box", u.cloneNode(!0).style
						.backgroundClip = "", ge.clearCloneStyle = "content-box" === u.style
						.backgroundClip, we.extend(ge, {
							boxSizingReliable: function() {
								return e(), r
							},
							pixelBoxStyles: function() {
								return e(), a
							},
							pixelPosition: function() {
								return e(), n
							},
							reliableMarginLeft: function() {
								return e(), c
							},
							scrollboxSize: function() {
								return e(), i
							},
							reliableTrDimensions: function() {
								var e, t, n, r;
								return null == s && (e = be.createElement("table"), t = be.createElement(
										"tr"), n = be.createElement("div"), e.style.cssText =
									"position:absolute;left:-11111px", t.style.height = "1px", n.style
									.height = "9px", Ue.appendChild(e).appendChild(t).appendChild(
										n), r = o.getComputedStyle(t), s = 3 < parseInt(r.height), Ue
									.removeChild(e)), s
							}
						}))
				}();
				var dt = ["Webkit", "Moz", "ms"],
					ft = be.createElement("div").style,
					pt = {},
					ht = /^(none|table(?!-c[ea]).+)/,
					mt = /^--/,
					gt = {
						position: "absolute",
						visibility: "hidden",
						display: "block"
					},
					vt = {
						letterSpacing: "0",
						fontWeight: "400"
					};
				we.extend({
					cssHooks: {
						opacity: {
							get: function(e, t) {
								if (t) {
									var n = H(e, "opacity");
									return "" === n ? "1" : n
								}
							}
						}
					},
					cssNumber: {
						animationIterationCount: !0,
						columnCount: !0,
						fillOpacity: !0,
						flexGrow: !0,
						flexShrink: !0,
						fontWeight: !0,
						gridArea: !0,
						gridColumn: !0,
						gridColumnEnd: !0,
						gridColumnStart: !0,
						gridRow: !0,
						gridRowEnd: !0,
						gridRowStart: !0,
						lineHeight: !0,
						opacity: !0,
						order: !0,
						orphans: !0,
						widows: !0,
						zIndex: !0,
						zoom: !0
					},
					cssProps: {},
					style: function(e, t, r, o) {
						if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
							var i, a, s, c = v(t),
								l = mt.test(t),
								u = e.style;
							if (l || (t = z(c)), s = we.cssHooks[t] || we.cssHooks[c], void 0 ===
								r) return s && "get" in s && void 0 !== (i = s.get(e, !1, o)) ?
								i : u[t];
							if ("string" === (a = n(r)) && (i = Re.exec(r)) && i[1] && (r = x(
									e, t, i), a = "number"), null == r || r != r) return;
							"number" !== a || l || (r += i && i[3] || (we.cssNumber[c] ? "" :
									"px")), ge.clearCloneStyle || "" !== r || 0 !== t.indexOf(
									"background") || (u[t] = "inherit"), s && "set" in s && void 0 ===
								(r = s.set(e, r, o)) || (l ? u.setProperty(t, r) : u[t] = r)
						}
					},
					css: function(e, t, n, r) {
						var o, i, a, s = v(t);
						return mt.test(t) || (t = z(s)), (a = we.cssHooks[t] || we.cssHooks[
								s]) && "get" in a && (o = a.get(e, !0, n)), void 0 === o && (o =
								H(e, t, r)), "normal" === o && t in vt && (o = vt[t]), "" === n ||
							n ? (i = parseFloat(o), !0 === n || isFinite(i) ? i || 0 : o) : o
					}
				}), we.each(["height", "width"], (function(e, t) {
					we.cssHooks[t] = {
						get: function(e, n, r) {
							if (n) return !ht.test(we.css(e, "display")) || e.getClientRects()
								.length && e.getBoundingClientRect().width ? R(e, t, r) : lt(
									e, gt, (function() {
										return R(e, t, r)
									}))
						},
						set: function(e, n, r) {
							var o, i = ct(e),
								a = !ge.scrollboxSize() && "absolute" === i.position,
								s = (a || r) && "border-box" === we.css(e, "boxSizing", !1, i),
								c = r ? F(e, t, r, s, i) : 0;
							return s && a && (c -= re(e["offset" + t[0].toUpperCase() + t.slice(
									1)] - parseFloat(i[t]) - F(e, t, "border", !1, i) - .5)), c &&
								(o = Re.exec(n)) && "px" !== (o[3] || "px") && (e.style[t] = n,
									n = we.css(e, t)), B(0, n, c)
						}
					}
				})), we.cssHooks.marginLeft = M(ge.reliableMarginLeft, (function(e, t) {
					if (t) return (parseFloat(H(e, "marginLeft")) || e.getBoundingClientRect()
						.left - lt(e, {
							marginLeft: 0
						}, (function() {
							return e.getBoundingClientRect().left
						}))) + "px"
				})), we.each({
					margin: "",
					padding: "",
					border: "Width"
				}, (function(e, t) {
					we.cssHooks[e + t] = {
						expand: function(n) {
							for (var r = 0, o = {}, i = "string" == typeof n ? n.split(" ") : [
									n
								]; 4 > r; r++) o[e + We[r] + t] = i[r] || i[r - 2] || i[0];
							return o
						}
					}, "margin" !== e && (we.cssHooks[e + t].set = B)
				})), we.fn.extend({
					css: function(e, t) {
						return Ie(this, (function(e, t, n) {
							var r, o, i = {},
								a = 0;
							if (Array.isArray(t)) {
								for (r = ct(e), o = t.length; a < o; a++) i[t[a]] = we.css(e,
									t[a], !1, r);
								return i
							}
							return void 0 === n ? we.css(e, t) : we.style(e, t, n)
						}), e, t, 1 < arguments.length)
					}
				}), we.Tween = W, W.prototype = {
					constructor: W,
					init: function(e, t, n, r, o, i) {
						this.elem = e, this.prop = n, this.easing = o || we.easing._default,
							this.options = t, this.start = this.now = this.cur(), this.end = r,
							this.unit = i || (we.cssNumber[n] ? "" : "px")
					},
					cur: function() {
						var e = W.propHooks[this.prop];
						return e && e.get ? e.get(this) : W.propHooks._default.get(this)
					},
					run: function(e) {
						var t, n = W.propHooks[this.prop];
						return this.pos = t = this.options.duration ? we.easing[this.easing]
							(e, this.options.duration * e, 0, 1, this.options.duration) : e,
							this.now = (this.end - this.start) * t + this.start, this.options.step &&
							this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(
								this) : W.propHooks._default.set(this), this
					}
				}, W.prototype.init.prototype = W.prototype, W.propHooks = {
					_default: {
						get: function(e) {
							var t;
							return 1 !== e.elem.nodeType || null != e.elem[e.prop] && null ==
								e.elem.style[e.prop] ? e.elem[e.prop] : (t = we.css(e.elem, e.prop,
									"")) && "auto" !== t ? t : 0
						},
						set: function(e) {
							we.fx.step[e.prop] ? we.fx.step[e.prop](e) : 1 !== e.elem.nodeType ||
								!we.cssHooks[e.prop] && null == e.elem.style[z(e.prop)] ? e.elem[
									e.prop] = e.now : we.style(e.elem, e.prop, e.now + e.unit)
						}
					}
				}, W.propHooks.scrollTop = W.propHooks.scrollLeft = {
					set: function(e) {
						e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now)
					}
				}, we.easing = {
					linear: function(e) {
						return e
					},
					swing: function(e) {
						return .5 - Math.cos(e * Math.PI) / 2
					},
					_default: "swing"
				}, we.fx = W.prototype.init, we.fx.step = {};
				var yt, bt, xt = /^(?:toggle|show|hide)$/,
					wt = /queueHooks$/;
				we.Animation = we.extend(Y, {
						tweeners: {
							"*": [function(e, t) {
								var n = this.createTween(e, t);
								return x(n.elem, e, Re.exec(t), n), n
							}]
						},
						tweener: function(e, t) {
							ve(e) ? (t = e, e = ["*"]) : e = e.match(De);
							for (var n, r = 0, o = e.length; r < o; r++) n = e[r], Y.tweeners[
								n] = Y.tweeners[n] || [], Y.tweeners[n].unshift(t)
						},
						prefilters: [function(e, t, n) {
							var r, o, i, a, s, c, l, u, d = "width" in t || "height" in t,
								f = this,
								p = {},
								h = e.style,
								m = e.nodeType && Ve(e),
								g = He.get(e, "fxshow");
							for (r in n.queue || (null == (a = we._queueHooks(e, "fx")).unqueued &&
									(a.unqueued = 0, s = a.empty.fire, a.empty.fire = function() {
										a.unqueued || s()
									}), a.unqueued++, f.always((function() {
										f.always((function() {
											a.unqueued--, we.queue(e, "fx").length || a.empty.fire()
										}))
									}))), t)
								if (o = t[r], xt.test(o)) {
									if (delete t[r], i = i || "toggle" === o, o === (m ? "hide" :
											"show")) {
										if ("show" !== o || !g || void 0 === g[r]) continue;
										m = !0
									}
									p[r] = g && g[r] || we.style(e, r)
								}
							if ((c = !we.isEmptyObject(t)) || !we.isEmptyObject(p))
								for (r in d && 1 === e.nodeType && (n.overflow = [h.overflow, h.overflowX,
											h.overflowY
										], null == (l = g && g.display) && (l = He.get(e, "display")),
										"none" === (u = we.css(e, "display")) && (l ? u = l : (C([e], !
											0), l = e.style.display || l, u = we.css(e, "display"), C([
											e
										]))), ("inline" === u || "inline-block" === u && null != l) &&
										"none" === we.css(e, "float") && (!c && (f.done((function() {
												h.display = l
											})), null == l && (u = h.display, l = "none" === u ? "" : u)),
											h.display = "inline-block")), n.overflow && (h.overflow =
										"hidden", f.always((function() {
											h.overflow = n.overflow[0], h.overflowX = n.overflow[1], h.overflowY =
												n.overflow[2]
										}))), c = !1, p) c || (g ? "hidden" in g && (m = g.hidden) : g =
									He.access(e, "fxshow", {
										display: l
									}), i && (g.hidden = !m), m && C([e], !0), f.done((function() {
										for (r in m || C([e]), He.remove(e, "fxshow"), p) we.style(
											e, r, p[r])
									}))), c = V(m ? g[r] : 0, r, f), r in g || (g[r] = c.start, m &&
									(c.end = c.start, c.start = 0))
						}],
						prefilter: function(e, t) {
							t ? Y.prefilters.unshift(e) : Y.prefilters.push(e)
						}
					}), we.speed = function(e, t, r) {
						var o = e && "object" === n(e) ? we.extend({}, e) : {
							complete: r || !r && t || ve(e) && e,
							duration: e,
							easing: r && t || t && !ve(t) && t
						};
						return we.fx.off ? o.duration = 0 : "number" != typeof o.duration &&
							(o.duration in we.fx.speeds ? o.duration = we.fx.speeds[o.duration] :
								o.duration = we.fx.speeds._default), (null == o.queue || !0 === o.queue) &&
							(o.queue = "fx"), o.old = o.complete, o.complete = function() {
								ve(o.old) && o.old.call(this), o.queue && we.dequeue(this, o.queue)
							}, o
					}, we.fn.extend({
						fadeTo: function(e, t, n, r) {
							return this.filter(Ve).css("opacity", 0).show().end().animate({
								opacity: t
							}, e, n, r)
						},
						animate: function(e, t, n, r) {
							var o = we.isEmptyObject(e),
								i = we.speed(t, n, r),
								a = function() {
									var t = Y(this, we.extend({}, e), i);
									(o || He.get(this, "finish")) && t.stop(!0)
								};
							return a.finish = a, o || !1 === i.queue ? this.each(a) : this.queue(
								i.queue, a)
						},
						stop: function(e, t, n) {
							var r = function(e) {
								var t = e.stop;
								delete e.stop, t(n)
							};
							return "string" != typeof e && (n = t, t = e, e = void 0), t &&
								this.queue(e || "fx", []), this.each((function() {
									var t = !0,
										o = null != e && e + "queueHooks",
										i = we.timers,
										a = He.get(this);
									if (o) a[o] && a[o].stop && r(a[o]);
									else
										for (o in a) a[o] && a[o].stop && wt.test(o) && r(a[o]);
									for (o = i.length; o--;) i[o].elem === this && (null == e || i[
										o].queue === e) && (i[o].anim.stop(n), t = !1, i.splice(o, 1));
									(t || !n) && we.dequeue(this, e)
								}))
						},
						finish: function(e) {
							return !1 !== e && (e = e || "fx"), this.each((function() {
								var t, n = He.get(this),
									r = n[e + "queue"],
									o = n[e + "queueHooks"],
									i = we.timers,
									a = r ? r.length : 0;
								for (n.finish = !0, we.queue(this, e, []), o && o.stop && o.stop
									.call(this, !0), t = i.length; t--;) i[t].elem === this && i[
									t].queue === e && (i[t].anim.stop(!0), i.splice(t, 1));
								for (t = 0; t < a; t++) r[t] && r[t].finish && r[t].finish.call(
									this);
								delete n.finish
							}))
						}
					}), we.each(["toggle", "show", "hide"], (function(e, t) {
						var n = we.fn[t];
						we.fn[t] = function(e, r, o) {
							return null == e || "boolean" == typeof e ? n.apply(this,
								arguments) : this.animate(G(t, !0), e, r, o)
						}
					})), we.each({
						slideDown: G("show"),
						slideUp: G("hide"),
						slideToggle: G("toggle"),
						fadeIn: {
							opacity: "show"
						},
						fadeOut: {
							opacity: "hide"
						},
						fadeToggle: {
							opacity: "toggle"
						}
					}, (function(e, t) {
						we.fn[e] = function(e, n, r) {
							return this.animate(t, e, n, r)
						}
					})), we.timers = [], we.fx.tick = function() {
						var e, t = 0,
							n = we.timers;
						for (yt = Date.now(); t < n.length; t++)(e = n[t])() || n[t] !== e ||
							n.splice(t--, 1);
						n.length || we.fx.stop(), yt = void 0
					}, we.fx.timer = function(e) {
						we.timers.push(e), we.fx.start()
					}, we.fx.interval = 13, we.fx.start = function() {
						bt || (bt = !0, U())
					}, we.fx.stop = function() {
						bt = null
					}, we.fx.speeds = {
						slow: 600,
						fast: 200,
						_default: 400
					}, we.fn.delay = function(e, t) {
						return e = we.fx && we.fx.speeds[e] || e, t = t || "fx", this.queue(t, (
							function(t, n) {
								var r = o.setTimeout(t, e);
								n.stop = function() {
									o.clearTimeout(r)
								}
							}))
					},
					function() {
						var e = be.createElement("input"),
							t = be.createElement("select").appendChild(be.createElement("option"));
						e.type = "checkbox", ge.checkOn = "" !== e.value, ge.optSelected = t.selected, (
								e = be.createElement("input")).value = "t", e.type = "radio", ge.radioValue =
							"t" === e.value
					}();
				var Ct, Tt = we.expr.attrHandle;
				we.fn.extend({
					attr: function(e, t) {
						return Ie(this, we.attr, e, t, 1 < arguments.length)
					},
					removeAttr: function(e) {
						return this.each((function() {
							we.removeAttr(this, e)
						}))
					}
				}), we.extend({
					attr: function(e, t, n) {
						var r, o, i = e.nodeType;
						if (3 !== i && 8 !== i && 2 !== i) return void 0 === e.getAttribute ?
							we.prop(e, t, n) : (1 === i && we.isXMLDoc(e) || (o = we.attrHooks[
									t.toLowerCase()] || (we.expr.match.bool.test(t) ? Ct : void 0)),
								void 0 !== n ? null === n ? void we.removeAttr(e, t) : o &&
								"set" in o && void 0 !== (r = o.set(e, n, t)) ? r : (e.setAttribute(
									t, n + ""), n) : o && "get" in o && null !== (r = o.get(e, t)) ?
								r : null == (r = we.find.attr(e, t)) ? void 0 : r)
					},
					attrHooks: {
						type: {
							set: function(e, t) {
								if (!ge.radioValue && "radio" === t && l(e, "input")) {
									var n = e.value;
									return e.setAttribute("type", t), n && (e.value = n), t
								}
							}
						}
					},
					removeAttr: function(e, t) {
						var n, r = 0,
							o = t && t.match(De);
						if (o && 1 === e.nodeType)
							for (; n = o[r++];) e.removeAttribute(n)
					}
				}), Ct = {
					set: function(e, t, n) {
						return !1 === t ? we.removeAttr(e, n) : e.setAttribute(n, n), n
					}
				}, we.each(we.expr.match.bool.source.match(/\w+/g), (function(e, t) {
					var n = Tt[t] || we.find.attr;
					Tt[t] = function(e, t, r) {
						var o, i, a = t.toLowerCase();
						return r || (i = Tt[a], Tt[a] = o, o = null == n(e, t, r) ? null :
							a, Tt[a] = i), o
					}
				}));
				var kt = /^(?:input|select|textarea|button)$/i,
					_t = /^(?:a|area)$/i;
				we.fn.extend({
					prop: function(e, t) {
						return Ie(this, we.prop, e, t, 1 < arguments.length)
					},
					removeProp: function(e) {
						return this.each((function() {
							delete this[we.propFix[e] || e]
						}))
					}
				}), we.extend({
					prop: function(e, t, n) {
						var r, o, i = e.nodeType;
						if (3 !== i && 8 !== i && 2 !== i) return 1 === i && we.isXMLDoc(e) ||
							(t = we.propFix[t] || t, o = we.propHooks[t]), void 0 === n ? o &&
							"get" in o && null !== (r = o.get(e, t)) ? r : e[t] : o && "set" in
							o && void 0 !== (r = o.set(e, n, t)) ? r : e[t] = n
					},
					propHooks: {
						tabIndex: {
							get: function(e) {
								var t = we.find.attr(e, "tabindex");
								return t ? parseInt(t, 10) : kt.test(e.nodeName) || _t.test(e.nodeName) &&
									e.href ? 0 : -1
							}
						}
					},
					propFix: {
						for: "htmlFor",
						class: "className"
					}
				}), ge.optSelected || (we.propHooks.selected = {
					get: function(e) {
						var t = e.parentNode;
						return t && t.parentNode && t.parentNode.selectedIndex, null
					},
					set: function(e) {
						var t = e.parentNode;
						t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex)
					}
				}), we.each(["tabIndex", "readOnly", "maxLength", "cellSpacing",
					"cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder",
					"contentEditable"
				], (function() {
					we.propFix[this.toLowerCase()] = this
				})), we.fn.extend({
					addClass: function(e) {
						var t, n, r, o, i, a, s, c = 0;
						if (ve(e)) return this.each((function(t) {
							we(this).addClass(e.call(this, t, J(this)))
						}));
						if ((t = Z(e)).length)
							for (; n = this[c++];)
								if (o = J(n), r = 1 === n.nodeType && " " + K(o) + " ") {
									for (a = 0; i = t[a++];) 0 > r.indexOf(" " + i + " ") && (r +=
										i + " ");
									o !== (s = K(r)) && n.setAttribute("class", s)
								}
						return this
					},
					removeClass: function(e) {
						var t, n, r, o, i, a, s, c = 0;
						if (ve(e)) return this.each((function(t) {
							we(this).removeClass(e.call(this, t, J(this)))
						}));
						if (!arguments.length) return this.attr("class", "");
						if ((t = Z(e)).length)
							for (; n = this[c++];)
								if (o = J(n), r = 1 === n.nodeType && " " + K(o) + " ") {
									for (a = 0; i = t[a++];)
										for (; - 1 < r.indexOf(" " + i + " ");) r = r.replace(" " + i +
											" ", " ");
									o !== (s = K(r)) && n.setAttribute("class", s)
								}
						return this
					},
					toggleClass: function(e, t) {
						var r = n(e),
							o = "string" === r || Array.isArray(e);
						return "boolean" == typeof t && o ? t ? this.addClass(e) : this.removeClass(
							e) : ve(e) ? this.each((function(n) {
							we(this).toggleClass(e.call(this, n, J(this), t), t)
						})) : this.each((function() {
							var t, n, i, a;
							if (o)
								for (n = 0, i = we(this), a = Z(e); t = a[n++];) i.hasClass(t) ?
									i.removeClass(t) : i.addClass(t);
							else(void 0 === e || "boolean" === r) && ((t = J(this)) && He.set(
								this, "__className__", t), this.setAttribute && this.setAttribute(
								"class", t || !1 === e ? "" : He.get(this, "__className__") ||
								""))
						}))
					},
					hasClass: function(e) {
						var t, n, r = 0;
						for (t = " " + e + " "; n = this[r++];)
							if (1 === n.nodeType && -1 < (" " + K(J(n)) + " ").indexOf(t))
								return !0;
						return !1
					}
				});
				var St = /\r/g;
				we.fn.extend({
					val: function(e) {
						var t, n, r, o = this[0];
						return arguments.length ? (r = ve(e), this.each((function(n) {
								var o;
								1 !== this.nodeType || (null == (o = r ? e.call(this, n, we(
										this).val()) : e) ? o = "" : "number" == typeof o ? o +=
									"" : Array.isArray(o) && (o = we.map(o, (function(e) {
										return null == e ? "" : e + ""
									}))), (!(t = we.valHooks[this.type] || we.valHooks[this.nodeName
										.toLowerCase()]) || !("set" in t) || void 0 === t.set(
										this, o, "value")) && (this.value = o))
							}))) : o ? (t = we.valHooks[o.type] || we.valHooks[o.nodeName.toLowerCase()]) &&
							"get" in t && void 0 !== (n = t.get(o, "value")) ? n : "string" ==
							typeof(n = o.value) ? n.replace(St, "") : null == n ? "" : n :
							void 0
					}
				}), we.extend({
					valHooks: {
						option: {
							get: function(e) {
								var t = we.find.attr(e, "value");
								return null == t ? K(we.text(e)) : t
							}
						},
						select: {
							get: function(e) {
								var t, n, r, o = e.options,
									i = e.selectedIndex,
									a = "select-one" === e.type,
									s = a ? null : [],
									c = a ? i + 1 : o.length;
								for (r = 0 > i ? c : a ? i : 0; r < c; r++)
									if (((n = o[r]).selected || r === i) && !n.disabled && (!n.parentNode
											.disabled || !l(n.parentNode, "optgroup"))) {
										if (t = we(n).val(), a) return t;
										s.push(t)
									}
								return s
							},
							set: function(e, t) {
								for (var n, r, o = e.options, i = we.makeArray(t), a = o.length; a--;)
									((r = o[a]).selected = -1 < we.inArray(we.valHooks.option.get(r),
										i)) && (n = !0);
								return n || (e.selectedIndex = -1), i
							}
						}
					}
				}), we.each(["radio", "checkbox"], (function() {
					we.valHooks[this] = {
						set: function(e, t) {
							if (Array.isArray(t)) return e.checked = -1 < we.inArray(we(e).val(),
								t)
						}
					}, ge.checkOn || (we.valHooks[this].get = function(e) {
						return null === e.getAttribute("value") ? "on" : e.value
					})
				})), ge.focusin = "onfocusin" in o;
				var jt = /^(?:focusinfocus|focusoutblur)$/,
					$t = function(e) {
						e.stopPropagation()
					};
				we.extend(we.event, {
					trigger: function(e, t, r, i) {
						var a, s, c, l, u, d, f, p, h = [r || be],
							m = pe.call(e, "type") ? e.type : e,
							g = pe.call(e, "namespace") ? e.namespace.split(".") : [];
						if (s = p = c = r = r || be, 3 !== r.nodeType && 8 !== r.nodeType &&
							!jt.test(m + we.event.triggered) && (-1 < m.indexOf(".") && (g =
									m.split("."), m = g.shift(), g.sort()), u = 0 > m.indexOf(":") &&
								"on" + m, (e = e[we.expando] ? e : new we.Event(m, "object" ===
									n(e) && e)).isTrigger = i ? 2 : 3, e.namespace = g.join("."), e
								.rnamespace = e.namespace ? new RegExp("(^|\\.)" + g.join(
									"\\.(?:.*\\.|)") + "(\\.|$)") : null, e.result = void 0, e.target ||
								(e.target = r), t = null == t ? [e] : we.makeArray(t, [e]), f =
								we.event.special[m] || {}, i || !f.trigger || !1 !== f.trigger.apply(
									r, t))) {
							if (!i && !f.noBubble && !ye(r)) {
								for (l = f.delegateType || m, jt.test(l + m) || (s = s.parentNode); s; s =
									s.parentNode) h.push(s), c = s;
								c === (r.ownerDocument || be) && h.push(c.defaultView || c.parentWindow ||
									o)
							}
							for (a = 0;
								(s = h[a++]) && !e.isPropagationStopped();) p = s, e.type = 1 <
								a ? l : f.bindType || m, (d = (He.get(s, "events") || Object.create(
									null))[e.type] && He.get(s, "handle")) && d.apply(s, t), (d = u &&
									s[u]) && d.apply && qe(s) && (e.result = d.apply(s, t), !1 ===
									e.result && e.preventDefault());
							return e.type = m, i || e.isDefaultPrevented() || f._default && !
								1 !== f._default.apply(h.pop(), t) || !qe(r) || !u || !ve(r[m]) ||
								ye(r) || ((c = r[u]) && (r[u] = null), we.event.triggered = m, e
									.isPropagationStopped() && p.addEventListener(m, $t), r[m](), e
									.isPropagationStopped() && p.removeEventListener(m, $t), we.event
									.triggered = void 0, c && (r[u] = c)), e.result
						}
					},
					simulate: function(e, t, n) {
						var r = we.extend(new we.Event, n, {
							type: e,
							isSimulated: !0
						});
						we.event.trigger(r, null, t)
					}
				}), we.fn.extend({
					trigger: function(e, t) {
						return this.each((function() {
							we.event.trigger(e, t, this)
						}))
					},
					triggerHandler: function(e, t) {
						var n = this[0];
						if (n) return we.event.trigger(e, t, n, !0)
					}
				}), ge.focusin || we.each({
					focus: "focusin",
					blur: "focusout"
				}, (function(e, t) {
					var n = function(e) {
						we.event.simulate(t, e.target, we.event.fix(e))
					};
					we.event.special[t] = {
						setup: function() {
							var r = this.ownerDocument || this.document || this,
								o = He.access(r, t);
							o || r.addEventListener(e, n, !0), He.access(r, t, (o || 0) + 1)
						},
						teardown: function() {
							var r = this.ownerDocument || this.document || this,
								o = He.access(r, t) - 1;
							o ? He.access(r, t, o) : (r.removeEventListener(e, n, !0), He.remove(
								r, t))
						}
					}
				}));
				var Et = o.location,
					At = {
						guid: Date.now()
					},
					Dt = /\?/;
				we.parseXML = function(e) {
					var t;
					if (!e || "string" != typeof e) return null;
					try {
						t = (new o.DOMParser).parseFromString(e, "text/xml")
					} catch (e) {
						t = void 0
					}
					return (!t || t.getElementsByTagName("parsererror").length) && we.error(
						"Invalid XML: " + e), t
				};
				var Nt = /\[\]$/,
					Lt = /\r?\n/g,
					It = /^(?:submit|button|image|reset|file)$/i,
					Ot = /^(?:input|select|textarea|keygen)/i;
				we.param = function(e, t) {
					var n, r = [],
						o = function(e, t) {
							var n = ve(t) ? t() : t;
							r[r.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null ==
								n ? "" : n)
						};
					if (null == e) return "";
					if (Array.isArray(e) || e.jquery && !we.isPlainObject(e)) we.each(e, (
						function() {
							o(this.name, this.value)
						}));
					else
						for (n in e) Q(n, e[n], t, o);
					return r.join("&")
				}, we.fn.extend({
					serialize: function() {
						return we.param(this.serializeArray())
					},
					serializeArray: function() {
						return this.map((function() {
							var e = we.prop(this, "elements");
							return e ? we.makeArray(e) : this
						})).filter((function() {
							var e = this.type;
							return this.name && !we(this).is(":disabled") && Ot.test(this.nodeName) &&
								!It.test(e) && (this.checked || !Ke.test(e))
						})).map((function(e, t) {
							var n = we(this).val();
							return null == n ? null : Array.isArray(n) ? we.map(n, (
								function(e) {
									return {
										name: t.name,
										value: e.replace(Lt, "\r\n")
									}
								})) : {
								name: t.name,
								value: n.replace(Lt, "\r\n")
							}
						})).get()
					}
				});
				var Pt = /%20/g,
					qt = /#.*$/,
					Ht = /([?&])_=[^&]*/,
					Mt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
					zt = /^(?:GET|HEAD)$/,
					Bt = /^\/\//,
					Ft = {},
					Rt = {},
					Wt = "*/".concat("*"),
					Ut = be.createElement("a");
				Ut.href = Et.href, we.extend({
					active: 0,
					lastModified: {},
					etag: {},
					ajaxSettings: {
						url: Et.href,
						type: "GET",
						isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/
							.test(Et.protocol),
						global: !0,
						processData: !0,
						async: !0,
						contentType: "application/x-www-form-urlencoded; charset=UTF-8",
						accepts: {
							"*": Wt,
							text: "text/plain",
							html: "text/html",
							xml: "application/xml, text/xml",
							json: "application/json, text/javascript"
						},
						contents: {
							xml: /\bxml\b/,
							html: /\bhtml/,
							json: /\bjson\b/
						},
						responseFields: {
							xml: "responseXML",
							text: "responseText",
							json: "responseJSON"
						},
						converters: {
							"* text": String,
							"text html": !0,
							"text json": JSON.parse,
							"text xml": we.parseXML
						},
						flatOptions: {
							url: !0,
							context: !0
						}
					},
					ajaxSetup: function(e, t) {
						return t ? ne(ne(e, we.ajaxSettings), t) : ne(we.ajaxSettings, e)
					},
					ajaxPrefilter: ee(Ft),
					ajaxTransport: ee(Rt),
					ajax: function(e, t) {
						function r(e, t, n, r) {
							var c, u, p, h, w, C = t;
							d || (d = !0, l && o.clearTimeout(l), i = void 0, s = r || "", k.readyState =
								0 < e ? 4 : 0, c = 200 <= e && 300 > e || 304 === e, n && (h =
									function(e, t, n) {
										for (var r, o, i, a, s = e.contents, c = e.dataTypes;
											"*" === c[0];) c.shift(), void 0 === r && (r = e.mimeType ||
											t.getResponseHeader("Content-Type"));
										if (r)
											for (o in s)
												if (s[o] && s[o].test(r)) {
													c.unshift(o);
													break
												}
										if (c[0] in n) i = c[0];
										else {
											for (o in n) {
												if (!c[0] || e.converters[o + " " + c[0]]) {
													i = o;
													break
												}
												a || (a = o)
											}
											i = i || a
										}
										return i ? (i !== c[0] && c.unshift(i), n[i]) : void 0
									}(m, k, n)), !c && -1 < we.inArray("script", m.dataTypes) && (
									m.converters["text script"] = function() {}), h = function(e,
									t, n, r) {
									var o, i, a, s, c, l = {},
										u = e.dataTypes.slice();
									if (u[1])
										for (a in e.converters) l[a.toLowerCase()] = e.converters[a];
									for (i = u.shift(); i;)
										if (e.responseFields[i] && (n[e.responseFields[i]] = t), !c &&
											r && e.dataFilter && (t = e.dataFilter(t, e.dataType)), c =
											i, i = u.shift())
											if ("*" === i) i = c;
											else if ("*" !== c && c != i) {
										if (!(a = l[c + " " + i] || l["* " + i]))
											for (o in l)
												if ((s = o.split(" "))[1] === i && (a = l[c + " " + s[0]] ||
														l["* " + s[0]])) {
													!0 === a ? a = l[o] : !0 !== l[o] && (i = s[0], u.unshift(
														s[1]));
													break
												}
										if (!0 !== a)
											if (a && e.throws) t = a(t);
											else try {
												t = a(t)
											} catch (t) {
												return {
													state: "parsererror",
													error: a ? t : "No conversion from " + c + " to " + i
												}
											}
									}
									return {
										state: "success",
										data: t
									}
								}(m, h, k, c), c ? (m.ifModified && ((w = k.getResponseHeader(
										"Last-Modified")) && (we.lastModified[a] = w), (w = k.getResponseHeader(
										"etag")) && (we.etag[a] = w)), 204 === e || "HEAD" === m.type ?
									C = "nocontent" : 304 === e ? C = "notmodified" : (C = h.state,
										u = h.data, c = !(p = h.error))) : (p = C, (e || !C) && (C =
									"error", 0 > e && (e = 0))), k.status = e, k.statusText = (t ||
									C) + "", c ? y.resolveWith(g, [u, C, k]) : y.rejectWith(g, [k,
									C, p
								]), k.statusCode(x), x = void 0, f && v.trigger(c ?
									"ajaxSuccess" : "ajaxError", [k, m, c ? u : p]), b.fireWith(g, [
									k, C
								]), f && (v.trigger("ajaxComplete", [k, m]), !--we.active && we
									.event.trigger("ajaxStop")))
						}
						"object" === n(e) && (t = e, e = void 0), t = t || {};
						var i, a, s, c, l, u, d, f, p, h, m = we.ajaxSetup({}, t),
							g = m.context || m,
							v = m.context && (g.nodeType || g.jquery) ? we(g) : we.event,
							y = we.Deferred(),
							b = we.Callbacks("once memory"),
							x = m.statusCode || {},
							w = {},
							C = {},
							T = "canceled",
							k = {
								readyState: 0,
								getResponseHeader: function(e) {
									var t;
									if (d) {
										if (!c)
											for (c = {}; t = Mt.exec(s);) c[t[1].toLowerCase() + " "] =
												(c[t[1].toLowerCase() + " "] || []).concat(t[2]);
										t = c[e.toLowerCase() + " "]
									}
									return null == t ? null : t.join(", ")
								},
								getAllResponseHeaders: function() {
									return d ? s : null
								},
								setRequestHeader: function(e, t) {
									return null == d && (e = C[e.toLowerCase()] = C[e.toLowerCase()] ||
										e, w[e] = t), this
								},
								overrideMimeType: function(e) {
									return null == d && (m.mimeType = e), this
								},
								statusCode: function(e) {
									if (e)
										if (d) k.always(e[k.status]);
										else
											for (var t in e) x[t] = [x[t], e[t]];
									return this
								},
								abort: function(e) {
									var t = e || T;
									return i && i.abort(t), r(0, t), this
								}
							};
						if (y.promise(k), m.url = ((e || m.url || Et.href) + "").replace(
								Bt, Et.protocol + "//"), m.type = t.method || t.type || m.method ||
							m.type, m.dataTypes = (m.dataType || "*").toLowerCase().match(De) || [
								""
							], null == m.crossDomain) {
							u = be.createElement("a");
							try {
								u.href = m.url, u.href = u.href, m.crossDomain = Ut.protocol +
									"//" + Ut.host != u.protocol + "//" + u.host
							} catch (t) {
								m.crossDomain = !0
							}
						}
						if (m.data && m.processData && "string" != typeof m.data && (m.data =
								we.param(m.data, m.traditional)), te(Ft, m, t, k), d) return k;
						for (p in (f = we.event && m.global) && 0 == we.active++ && we.event
							.trigger("ajaxStart"), m.type = m.type.toUpperCase(), m.hasContent = !
							zt.test(m.type), a = m.url.replace(qt, ""), m.hasContent ? m.data &&
							m.processData && 0 === (m.contentType || "").indexOf(
								"application/x-www-form-urlencoded") && (m.data = m.data.replace(
								Pt, "+")) : (h = m.url.slice(a.length), m.data && (m.processData ||
									"string" == typeof m.data) && (a += (Dt.test(a) ? "&" : "?") +
									m.data, delete m.data), !1 === m.cache && (a = a.replace(Ht,
									"$1"), h = (Dt.test(a) ? "&" : "?") + "_=" + At.guid++ + h), m.url =
								a + h), m.ifModified && (we.lastModified[a] && k.setRequestHeader(
								"If-Modified-Since", we.lastModified[a]), we.etag[a] && k.setRequestHeader(
								"If-None-Match", we.etag[a])), (m.data && m.hasContent && !1 !==
								m.contentType || t.contentType) && k.setRequestHeader(
								"Content-Type", m.contentType), k.setRequestHeader("Accept", m.dataTypes[
								0] && m.accepts[m.dataTypes[0]] ? m.accepts[m.dataTypes[0]] + (
								"*" === m.dataTypes[0] ? "" : ", " + Wt + "; q=0.01") : m.accepts[
								"*"]), m.headers) k.setRequestHeader(p, m.headers[p]);
						if (m.beforeSend && (!1 === m.beforeSend.call(g, k, m) || d))
							return k.abort();
						if (T = "abort", b.add(m.complete), k.done(m.success), k.fail(m.error),
							i = te(Rt, m, t, k)) {
							if (k.readyState = 1, f && v.trigger("ajaxSend", [k, m]), d)
								return k;
							m.async && 0 < m.timeout && (l = o.setTimeout((function() {
								k.abort("timeout")
							}), m.timeout));
							try {
								d = !1, i.send(w, r)
							} catch (t) {
								if (d) throw t;
								r(-1, t)
							}
						} else r(-1, "No Transport");
						return k
					},
					getJSON: function(e, t, n) {
						return we.get(e, t, n, "json")
					},
					getScript: function(e, t) {
						return we.get(e, void 0, t, "script")
					}
				}), we.each(["get", "post"], (function(e, t) {
					we[t] = function(e, n, r, o) {
						return ve(n) && (o = o || r, r = n, n = void 0), we.ajax(we.extend({
							url: e,
							type: t,
							dataType: o,
							data: n,
							success: r
						}, we.isPlainObject(e) && e))
					}
				})), we.ajaxPrefilter((function(e) {
					for (var t in e.headers) "content-type" === t.toLowerCase() && (e.contentType =
						e.headers[t] || "")
				})), we._evalUrl = function(e, t, n) {
					return we.ajax({
						url: e,
						type: "GET",
						dataType: "script",
						cache: !0,
						async: !1,
						global: !1,
						converters: {
							"text script": function() {}
						},
						dataFilter: function(e) {
							we.globalEval(e, t, n)
						}
					})
				}, we.fn.extend({
					wrapAll: function(e) {
						var t;
						return this[0] && (ve(e) && (e = e.call(this[0])), t = we(e, this[
							0].ownerDocument).eq(0).clone(!0), this[0].parentNode && t.insertBefore(
							this[0]), t.map((function() {
							for (var e = this; e.firstElementChild;) e = e.firstElementChild;
							return e
						})).append(this)), this
					},
					wrapInner: function(e) {
						return ve(e) ? this.each((function(t) {
							we(this).wrapInner(e.call(this, t))
						})) : this.each((function() {
							var t = we(this),
								n = t.contents();
							n.length ? n.wrapAll(e) : t.append(e)
						}))
					},
					wrap: function(e) {
						var t = ve(e);
						return this.each((function(n) {
							we(this).wrapAll(t ? e.call(this, n) : e)
						}))
					},
					unwrap: function(e) {
						return this.parent(e).not("body").each((function() {
							we(this).replaceWith(this.childNodes)
						})), this
					}
				}), we.expr.pseudos.hidden = function(e) {
					return !we.expr.pseudos.visible(e)
				}, we.expr.pseudos.visible = function(e) {
					return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length)
				}, we.ajaxSettings.xhr = function() {
					try {
						return new o.XMLHttpRequest
					} catch (e) {}
				};
				var Xt = {
						0: 200,
						1223: 204
					},
					Gt = we.ajaxSettings.xhr();
				ge.cors = !!Gt && "withCredentials" in Gt, ge.ajax = Gt = !!Gt, we.ajaxTransport(
					(function(e) {
						var t, n;
						if (ge.cors || Gt && !e.crossDomain) return {
							send: function(r, i) {
								var a, s = e.xhr();
								if (s.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields)
									for (a in e.xhrFields) s[a] = e.xhrFields[a];
								for (a in e.mimeType && s.overrideMimeType && s.overrideMimeType(
										e.mimeType), e.crossDomain || r["X-Requested-With"] || (r[
										"X-Requested-With"] = "XMLHttpRequest"), r) s.setRequestHeader(
									a, r[a]);
								t = function(e) {
										return function() {
											t && (t = n = s.onload = s.onerror = s.onabort = s.ontimeout =
												s.onreadystatechange = null, "abort" === e ? s.abort() :
												"error" === e ? "number" == typeof s.status ? i(s.status,
													s.statusText) : i(0, "error") : i(Xt[s.status] || s.status,
													s.statusText, "text" !== (s.responseType || "text") ||
													"string" != typeof s.responseText ? {
														binary: s.response
													} : {
														text: s.responseText
													}, s.getAllResponseHeaders()))
										}
									}, s.onload = t(), n = s.onerror = s.ontimeout = t("error"),
									void 0 === s.onabort ? s.onreadystatechange = function() {
										4 === s.readyState && o.setTimeout((function() {
											t && n()
										}))
									} : s.onabort = n, t = t("abort");
								try {
									s.send(e.hasContent && e.data || null)
								} catch (e) {
									if (t) throw e
								}
							},
							abort: function() {
								t && t()
							}
						}
					})), we.ajaxPrefilter((function(e) {
					e.crossDomain && (e.contents.script = !1)
				})), we.ajaxSetup({
					accepts: {
						script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
					},
					contents: {
						script: /\b(?:java|ecma)script\b/
					},
					converters: {
						"text script": function(e) {
							return we.globalEval(e), e
						}
					}
				}), we.ajaxPrefilter("script", (function(e) {
					void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type =
						"GET")
				})), we.ajaxTransport("script", (function(e) {
					var t, n;
					if (e.crossDomain || e.scriptAttrs) return {
						send: function(r, o) {
							t = we("<script>").attr(e.scriptAttrs || {}).prop({
								charset: e.scriptCharset,
								src: e.url
							}).on("load error", n = function(e) {
								t.remove(), n = null, e && o("error" === e.type ? 404 : 200,
									e.type)
							}), be.head.appendChild(t[0])
						},
						abort: function() {
							n && n()
						}
					}
				}));
				var Vt = [],
					Yt = /(=)\?(?=&|$)|\?\?/;
				we.ajaxSetup({
					jsonp: "callback",
					jsonpCallback: function() {
						var e = Vt.pop() || we.expando + "_" + At.guid++;
						return this[e] = !0, e
					}
				}), we.ajaxPrefilter("json jsonp", (function(e, t, n) {
					var r, i, a, s = !1 !== e.jsonp && (Yt.test(e.url) ? "url" :
						"string" == typeof e.data && 0 === (e.contentType || "").indexOf(
							"application/x-www-form-urlencoded") && Yt.test(e.data) &&
						"data");
					if (s || "jsonp" === e.dataTypes[0]) return r = e.jsonpCallback =
						ve(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback, s ? e[
							s] = e[s].replace(Yt, "$1" + r) : !1 !== e.jsonp && (e.url += (
							Dt.test(e.url) ? "&" : "?") + e.jsonp + "=" + r), e.converters[
							"script json"] = function() {
							return a || we.error(r + " was not called"), a[0]
						}, e.dataTypes[0] = "json", i = o[r], o[r] = function() {
							a = arguments
						}, n.always((function() {
							void 0 === i ? we(o).removeProp(r) : o[r] = i, e[r] && (e.jsonpCallback =
									t.jsonpCallback, Vt.push(r)), a && ve(i) && i(a[0]), a = i =
								void 0
						})), "script"
				})), ge.createHTMLDocument = function() {
					var e = be.implementation.createHTMLDocument("").body;
					return e.innerHTML = "<form></form><form></form>", 2 === e.childNodes
						.length
				}(), we.parseHTML = function(e, t, n) {
					return "string" != typeof e ? [] : ("boolean" == typeof t && (n = t,
						t = !1), t || (ge.createHTMLDocument ? ((r = (t = be.implementation
							.createHTMLDocument("")).createElement("base")).href = be.location
						.href, t.head.appendChild(r)) : t = be), i = !n && [], (o = Se.exec(
						e)) ? [t.createElement(o[1])] : (o = _([e], t, i), i && i.length &&
						we(i).remove(), we.merge([], o.childNodes)));
					var r, o, i
				}, we.fn.load = function(e, t, r) {
					var o, i, a, s = this,
						c = e.indexOf(" ");
					return -1 < c && (o = K(e.slice(c)), e = e.slice(0, c)), ve(t) ? (r =
							t, t = void 0) : t && "object" === n(t) && (i = "POST"), 0 < s.length &&
						we.ajax({
							url: e,
							type: i || "GET",
							dataType: "html",
							data: t
						}).done((function(e) {
							a = arguments, s.html(o ? we("<div>").append(we.parseHTML(e)).find(
								o) : e)
						})).always(r && function(e, t) {
							s.each((function() {
								r.apply(this, a || [e.responseText, t, e])
							}))
						}), this
				}, we.expr.pseudos.animated = function(e) {
					return we.grep(we.timers, (function(t) {
						return e === t.elem
					})).length
				}, we.offset = {
					setOffset: function(e, t, n) {
						var r, o, i, a, s, c, l = we.css(e, "position"),
							u = we(e),
							d = {};
						"static" === l && (e.style.position = "relative"), s = u.offset(),
							i = we.css(e, "top"), c = we.css(e, "left"), ("absolute" === l ||
								"fixed" === l) && -1 < (i + c).indexOf("auto") ? (a = (r = u.position())
								.top, o = r.left) : (a = parseFloat(i) || 0, o = parseFloat(c) ||
								0), ve(t) && (t = t.call(e, n, we.extend({}, s))), null != t.top &&
							(d.top = t.top - s.top + a), null != t.left && (d.left = t.left -
								s.left + o), "using" in t ? t.using.call(e, d) : ("number" ==
								typeof d.top && (d.top += "px"), "number" == typeof d.left && (d.left +=
									"px"), u.css(d))
					}
				}, we.fn.extend({
					offset: function(e) {
						if (arguments.length) return void 0 === e ? this : this.each((
							function(t) {
								we.offset.setOffset(this, e, t)
							}));
						var t, n, r = this[0];
						return r ? r.getClientRects().length ? (t = r.getBoundingClientRect(),
							n = r.ownerDocument.defaultView, {
								top: t.top + n.pageYOffset,
								left: t.left + n.pageXOffset
							}) : {
							top: 0,
							left: 0
						} : void 0
					},
					position: function() {
						if (this[0]) {
							var e, t, n, r = this[0],
								o = {
									top: 0,
									left: 0
								};
							if ("fixed" === we.css(r, "position")) t = r.getBoundingClientRect();
							else {
								for (t = this.offset(), n = r.ownerDocument, e = r.offsetParent ||
									n.documentElement; e && (e === n.body || e === n.documentElement) &&
									"static" === we.css(e, "position");) e = e.parentNode;
								e && e !== r && 1 === e.nodeType && ((o = we(e).offset()).top +=
									we.css(e, "borderTopWidth", !0), o.left += we.css(e,
										"borderLeftWidth", !0))
							}
							return {
								top: t.top - o.top - we.css(r, "marginTop", !0),
								left: t.left - o.left - we.css(r, "marginLeft", !0)
							}
						}
					},
					offsetParent: function() {
						return this.map((function() {
							for (var e = this.offsetParent; e && "static" === we.css(e,
									"position");) e = e.offsetParent;
							return e || Ue
						}))
					}
				}), we.each({
					scrollLeft: "pageXOffset",
					scrollTop: "pageYOffset"
				}, (function(e, t) {
					var n = "pageYOffset" === t;
					we.fn[e] = function(r) {
						return Ie(this, (function(e, r, o) {
							var i;
							return ye(e) ? i = e : 9 === e.nodeType && (i = e.defaultView),
								void 0 === o ? i ? i[t] : e[r] : void(i ? i.scrollTo(n ? i.pageXOffset :
									o, n ? o : i.pageYOffset) : e[r] = o)
						}), e, r, arguments.length)
					}
				})), we.each(["top", "left"], (function(e, t) {
					we.cssHooks[t] = M(ge.pixelPosition, (function(e, n) {
						if (n) return n = H(e, t), st.test(n) ? we(e).position()[t] +
							"px" : n
					}))
				})), we.each({
					Height: "height",
					Width: "width"
				}, (function(e, t) {
					we.each({
						padding: "inner" + e,
						content: t,
						"": "outer" + e
					}, (function(n, r) {
						we.fn[r] = function(o, i) {
							var a = arguments.length && (n || "boolean" != typeof o),
								s = n || (!0 === o || !0 === i ? "margin" : "border");
							return Ie(this, (function(t, n, o) {
								var i;
								return ye(t) ? 0 === r.indexOf("outer") ? t["inner" + e] :
									t.document.documentElement["client" + e] : 9 === t.nodeType ?
									(i = t.documentElement, oe(t.body["scroll" + e], i[
											"scroll" + e], t.body["offset" + e], i["offset" + e],
										i["client" + e])) : void 0 === o ? we.css(t, n, s) : we
									.style(t, n, o, s)
							}), t, a ? o : void 0, a)
						}
					}))
				})), we.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError",
					"ajaxSuccess", "ajaxSend"
				], (function(e, t) {
					we.fn[t] = function(e) {
						return this.on(t, e)
					}
				})), we.fn.extend({
					bind: function(e, t, n) {
						return this.on(e, null, t, n)
					},
					unbind: function(e, t) {
						return this.off(e, null, t)
					},
					delegate: function(e, t, n, r) {
						return this.on(t, e, n, r)
					},
					undelegate: function(e, t, n) {
						return 1 === arguments.length ? this.off(e, "**") : this.off(t, e ||
							"**", n)
					},
					hover: function(e, t) {
						return this.mouseenter(e).mouseleave(t || e)
					}
				}), we.each(["blur", "focus", "focusin", "focusout", "resize",
					"scroll", "click", "dblclick", "mousedown", "mouseup", "mousemove",
					"mouseover", "mouseout", "mouseenter", "mouseleave", "change",
					"select", "submit", "keydown", "keypress", "keyup", "contextmenu"
				], (function(e, t) {
					we.fn[t] = function(e, n) {
						return 0 < arguments.length ? this.on(t, null, e, n) : this.trigger(
							t)
					}
				}));
				var Kt = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
				we.proxy = function(e, t) {
						var n, r, o;
						if ("string" == typeof t && (n = e[t], t = e, e = n), ve(e)) return r =
							se.call(arguments, 2), (o = function() {
								return e.apply(t || this, r.concat(se.call(arguments)))
							}).guid = e.guid = e.guid || we.guid++, o
					}, we.holdReady = function(e) {
						e ? we.readyWait++ : we.ready(!0)
					}, we.isArray = Array.isArray, we.parseJSON = JSON.parse, we.nodeName =
					l, we.isFunction = ve, we.isWindow = ye, we.camelCase = v, we.type = s,
					we.now = Date.now, we.isNumeric = function(e) {
						var t = we.type(e);
						return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e))
					}, we.trim = function(e) {
						return null == e ? "" : (e + "").replace(Kt, "")
					}, void 0 === (r = function() {
						return we
					}.apply(t, [])) || (e.exports = r);
				var Jt = o.jQuery,
					Zt = o.$;
				return we.noConflict = function(e) {
					return o.$ === we && (o.$ = Zt), e && o.jQuery === we && (o.jQuery =
						Jt), we
				}, void 0 === i && (o.jQuery = o.$ = we), we
			}))
		}).call(this, n(8)(e))
	}, function(e) {
		e.exports = function(e) {
			return e.webpackPolyfill || (e.deprecate = function() {}, e.paths = [], !e
				.children && (e.children = []), Object.defineProperty(e, "loaded", {
					enumerable: !0,
					get: function() {
						return e.l
					}
				}), Object.defineProperty(e, "id", {
					enumerable: !0,
					get: function() {
						return e.i
					}
				}), e.webpackPolyfill = 1), e
		}
	}, function(e) {
		function t() {
			var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : "";
			return e.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(
				/^-+|-+$/g, "")
		}
		e.exports = {
			filterOptions: function(e, n, r, o) {
				return new Promise((function(i) {
					var a = e.val(),
						s = r.filter((function(e) {
							return t(e["option".concat(n)]) === a
						})),
						c = [];
					o.map((function(e) {
						if (e.position !== n) {
							var r = {};
							r.name = e.name, r.index = e.position, r.values = [], e.values.map(
								(function(n) {
									s.filter((function(r) {
										return t(r["option".concat(e.position)]) === n && r.available
									})).length && r.values.push(n)
								})), c.push(r)
						}
					})), i(c)
				}))
			}
		}
	}, function() {
		$(document).on("change", ".popup-newsletter .checkbox input", (function() {
			var e = $(this),
				t = e.closest(".popup__body");
			e.is(":checked") ? t.addClass("checked") : t.removeClass("checked")
		}))
	}, function() {
		$(document).ready((function() {
			$(".custom-select, .js-select-custom select").selectric({
				nativeOnMobile: !1
			})
		}))
	}, function() {
		var e = $(document),
			t = $(window);
		e.on("click", ".js-btn-filter", (function(e) {
			e.preventDefault(), $(this).toggleClass("expanded"), $(".js-filter").slideToggle(),
				0 !== t.scrollTop() && $("body,html").animate({
					scrollTop: 0
				}, 700)
		})), e.on("click", ".js-btn-filter-clear", (function(e) {
			e.preventDefault();
			var t = $(".bc-sf-filter-clear-all");
			t.length && t.trigger("click")
		})), e.on("click", ".js-selected-items li", (function() {
			var e = $(".bc-sf-filter-selected-items .selected-item"),
				t = $(this).index();
			e.length && e.eq(t).find(".bc-sf-filter-clear").trigger("click")
		}))
	}, function() {
		function e(e, n) {
			$.ajax({
				url: "https://a.klaviyo.com/ajax/subscriptions/subscribe",
				method: "POST",
				data: "g=".concat(n, "&$email=").concat(e)
			}).done((function() {
				r = !1, t.trigger("submit")
			}))
		}
		$(document);
		var t = $(".js-form-register"),
			n = $(".js-subscribe-form").data("subscribe-id"),
			r = !0;
		t.on("submit", (function(t) {
			var o = $(this),
				i = o.find('input[type="checkbox"]'),
				a = o.find(".js-pass-confirm"),
				s = o.find(".js-pass");
			if (a.length && s.length) {
				if (a.val() !== s.val()) return a.closest(".form__row").addClass(
					"error"), t.preventDefault(), !1;
				a.closest(".form__row").removeClass("error")
			}
			i.is(":checked") && r && (t.preventDefault(), e($(this).find(
				'input[type="email"]').val(), n))
		}))
	}, function() {
		var e = $(document);
		$(window);
		e.on("click", ".js-btn-toggle", (function(e) {
			e.preventDefault();
			var t = $(this),
				n = $(t.data("target")),
				r = t.data("class");
			if (n.toggleClass(r), t.hasClass("js-btn-toggle-address")) {
				var o = $(t.data("address-target")),
					i = t.data("address-class");
				o.toggleClass(i)
			}
		}))
	}, function() {
		var e = $(window);
		e.on("shopify:section:select", (function() {
			$("body").addClass("customize-editor"), $(".lazyload").length && new LazyLoad({
				elements_selector: ".lazyload"
			})
		})), e.on("load", (function() {
			$("body").addClass("loaded")
		}))
	}, function() {
		$(document).ready((function() {
			new LazyLoad({
				elements_selector: ".lazyload"
			})
		}))
	}, function() {
		if ($(".template-product").length) {
			var e = function() {
				var e = document.querySelector(".product-recommendations");
				if (null !== e) {
					var t = e.dataset.productId,
						n = e.dataset.limit,
						r = new XMLHttpRequest;
					r.open("GET",
						"/recommendations/products?section_id=product-recommendations&limit=" +
						n + "&product_id=" + t), r.onload = function() {
						if (200 <= r.status && 300 > r.status) {
							var t = document.createElement("div");
							t.innerHTML = r.response, e.parentElement.innerHTML = t.querySelector(
								".product-recommendations").innerHTML, new LazyLoad({
								elements_selector: ".lazyload"
							})
						}
					}, r.send()
				}
			};
			document.addEventListener("shopify:section:load", (function(t) {
				"product-recommendations" === t.detail.sectionId && e()
			})), e()
		}
	}, function() {
		var e = !1;
		$(document).on("submit", ".js-ajax-form", (function(t) {
			var n = $(this),
				r = "#".concat(n.attr("id")),
				o = n.find('[name="go_to_page"]').val();
			e || (t.preventDefault(), $.ajax({
				url: n.attr("action"),
				type: n.attr("method"),
				data: n.serialize(),
				beforeSend: function() {
					n.addClass("form--sending")
				}
			}).done((function(e) {
				t.preventDefault();
				var i = $(e).find(r),
					a = 0 < i.find(".js-form-errors").length;
				void 0 === o || a || i.length || (window.location = o), i.length &&
					n.parent().empty().append(i)
			})).fail((function(t) {
				console.log(t), e = !0, n.removeClass("form--sending").trigger(
					"submit")
			})))
		}))
	},
	function() {
		var e = $(window),
			t = ($(document), $(".wrapper"));
		$('.js-search input[type="text"]').on("input", (function() {
			if (768 > e.width()) {
				var n = $(
						".bc-sf-search-suggestion-mobile-top-panel form #bc-sf-search-box-mobile"
					),
					r = $(this),
					o = r.val();
				"" === o ? t.removeClass("wrapper--search-mobile") : t.addClass(
					"wrapper--search-mobile"), n.val(o), $(
					".bc-sf-search-suggestion-mobile-top-panel form #bc-sf-search-box-mobile"
				).trigger("click"), r.trigger("focus")
			}
		})), e.on("scroll", (function() {
			var e = $(".bc-sf-search-suggestion");
			e.length && "block" === e.css("display") && $("body").trigger("click")
		}))
	}, ,
	function(e, t, n) {
		"use strict";

		function r(e, t, n) {
			e.text(t).prop("disabled", n)
		}
		n.r(t);
		n(5), n(6);
		$(document).ready((function() {
			$(".slider-collection").each((function() {
				var e = $(this),
					t = e.find(".slider__slides"),
					n = e.closest(".js-slider-parent").find(
						".slider-arrows .arrow-prev"),
					r = e.closest(".js-slider-parent").find(
						".slider-arrows .arrow-next");
				t.slick({
					slidesToShow: 4,
					slidesToScroll: 4,
					dots: !0,
					prevArrow: n,
					nextArrow: r,
					infinite: !1,
					swipe: !1,
					responsive: [{
						breakpoint: 768,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
							variableWidth: !0,
							swipe: !0
						}
					}]
				}), t.on("afterChange", (function() {
					i($(this))
				}))
			})), $(".js-slider-orders .slider__slides").slick({
				infinite: !1,
				slidesToShow: 3,
				slidesToScroll: 1,
				dots: !1,
				arrows: !0,
				responsive: [{
					breakpoint: 768,
					settings: {
						slidesToShow: 2
					}
				}]
			}), $(".slider-stores").each((function() {
				var e = $(this),
					t = e.find(".slider__slides"),
					n = e.closest(".js-slider-parent").find(
						".slider-arrows .arrow-prev"),
					r = e.closest(".js-slider-parent").find(
						".slider-arrows .arrow-next");
				t.slick({
					slidesToShow: 2,
					slidesToScroll: 2,
					dots: !0,
					prevArrow: n,
					nextArrow: r,
					infinite: !1,
					swipe: !1,
					variableWidth: !0,
					responsive: [{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							swipe: !0
						}
					}]
				}), t.on("afterChange", (function() {
					i($(this))
				}))
			}))
		}));
		var o = function(e, t) {
				var n = e.parent().find(".slider-arrows__pages .current"),
					r = t.find(".slick-dots");
				n.text(r.find(".slick-active").index() + 1)
			},
			i = function(e) {
				var t = e.closest(".js-slider-parent").find(
						".slider-arrows__pages .current"),
					n = e.closest(".js-slider-parent").find(".slick-dots");
				t.text(n.find(".slick-active").index() + 1)
			},
			a = (n(3), $(document)),
			s = $(".mobile-menu"),
			c = $(".mobile-menu .sub-menu");
		$(".section-collection-slider .slider-arrows .arrow").on("click", (function() {
			var e = $(this);
			o(e, e.closest(".section-collection-slider"))
		})), $(".section-stores .slider-arrows .arrow").on("click", (function() {
			var e = $(this);
			o(e, e.closest(".section-stores"))
		})), $(".header__search .link-close").on("click", (function(e) {
			e.preventDefault(), $(this), $(".header").removeClass("search-visible"),
				$(".wrapper").removeClass("wrapper--search-visible"), $(
					".bc-sf-search-suggestion-mobile-open").length && $(
					".bc-sf-search-suggestion-mobile-open").removeClass(
					"bc-sf-search-suggestion-mobile-open")
		})), $(".nav .link-search, .mobile-menu .link-search").on("click", (
			function(e) {
				e.preventDefault(), s.removeClass("visible"), c.removeClass("visible"),
					$(".header").addClass("search-visible"), $(".wrapper").addClass(
						"wrapper--search-visible");
				$('.header__content').removeClass('menu-open');
			})), $(".nav-trigger").on("click", (function(e) {
			e.preventDefault();
			if ($('.header__bar').css('margin-top') === '0px') {
				s.css('top', $('.header__bar').outerHeight());
				c.css('top', $('.header__bar').outerHeight() + 61);
			} else {
				s.css('top', 0);
				c.css('top', 61);
			}

			$('.header__content').addClass('menu-open');
			s.addClass("visible");
		})), $(".mobile-menu .link-close").on("click", (function(e) {
			e.preventDefault();
			$('.header__content').removeClass('menu-open');
			s.removeClass("visible");
			c.removeClass("visible");
		})), $(".sub-menu .link-back").on("click", (function(e) {
			e.preventDefault(), $(this).closest(".sub-menu").removeClass("visible")
		})), $(".mobile-menu .has-dropdown > a").on("click", (function(e) {
			e.preventDefault(), $(this).next(".sub-menu").addClass("visible")
		})), a.mouseup((function(e) {
			var t = $(".mobile-menu");
			t.is(e.target) || 0 !== t.has(e.target).length || (s.removeClass(
				"visible"), c.removeClass("visible"))
		})), a.on("change", ".checkbox.error input", (function() {
			$(this).closest(".checkbox").removeClass("error")
		})), $(
			".section-product .section__images .zoom-trigger, .section-product .section__images .link-zoom"
		).on("click", (function(e) {
			e.preventDefault();
			var t = $(this).closest(".section-product");
			t.hasClass("zoomed") ? (t.toggleClass("zoomed"), setTimeout((function() {
				t.toggleClass("zoom-started")
			}), 300)) : (t.toggleClass("zoom-started"), setTimeout((function() {
				t.toggleClass("zoomed")
			}), 300))
		})), $(".accordion .accordion__head a").on("click", (function(e) {
			e.preventDefault(), $(this).closest(".accordion__section").toggleClass(
				"active").find(".accordion__body").slideToggle()
		})), $(".product .product__swatches a").on("click", (function(e) {
			e.preventDefault();
			var t = $(this),
				n = t.closest(".product").find(".product__images .".concat(t.attr(
					"class")));
			t.addClass("active").parent().siblings().find("a").removeClass("active"),
				n.addClass("visible").siblings().removeClass("visible")
		}));
		var l = n(0),
			u = (n(9), n(2)),
			d = function(e) {
				$(".product-single .product__color-name").text(e)
			},
			f = ($(window), $(document)),
			p = $("#product-select");
		($(document).ready((function() {
			var e = [];
			$(".swiper-container").each((function(t, n) {
				var r = $(n);
				r.addClass("instance-" + t);
				var o = r.find(".swiper-button-next").get(0),
					i = r.find(".swiper-button-prev").get(0),
					a = r.find(".swiper-pagination").get(0);
				e[t] = new Swiper(".instance-" + t, {
					direction: "horizontal",
					loop: !0,
					observer: !0,
					observeParents: !0,
					navigation: {
						nextEl: o,
						prevEl: i
					},
					pagination: {
						el: a,
						type: "fraction"
					}
				})

				//variant.metafields カラー名表示
				// 初期表示
				// var color_name = $('[data-option="カラー"] ul > li:first label').data("color-name");
				var color_name = $('input[name="カラー"]:checked').next("label").data(
					"color-name");
				$(".product__color-name ").append(color_name);

				// カラーチップ変更時
				$('input[name="カラー"]').change(function() {
					if ($(this).is(":checked")) {
						var color_name = $(this).next("label").data("color-name");
						var option_index = $(this).parent('li').index();
						var variant_size_index = $(
							'[data-option="サイズ"] .list-variants > li').length;
						var option_no = option_index * variant_size_index;
						$(".product__color-name").empty();
						$(".product__color-name").append($(this).next("label").data(
							"color-name"));
						// スライダーを1枚目に戻す
						e[t].slideTo(1);
						$('[data-swiper-slide-index="0"]').find('img').attr('src',
							Shopify.product.variants[option_no].featured_image.src);
					}
				})
				////weblife2022-09-09
				// SPサイズ変更時
				$('#custom-select').change(function() {
					const custom_select_obj = $("option:selected", this);
					const input_radio_id = custom_select_obj.attr('class');
					const checked_input = $('input:radio[name="サイズ"]:checked');
					if (checked_input != undefined && checked_input.val() != undefined) checked_input.prop('checked', false);
					if (input_radio_id != undefined) $("#" + input_radio_id).prop('checked', true);
					//if (checked_input != undefined && checked_input.val() != undefined) console.log(checked_input.val());
					//if (input_radio_id != undefined) console.log(input_radio_id);
				})
				//
			})), f.on("change",
				'.product-single .product__variant input[type="radio"], .product-single .product__variant select', (
					function() {
						var colorText = __GLOBAL__.country === 'AUS' ? 'colour' : 'color'
						var e = $("#product-select option[value=".concat($("#product-select")
								.val(), "]")).attr("data-サイズ"),//weblife2022-09-15
							t = $(this),
							n = t.closest(".product__variants"),
							o = n.find("option:selected"),
							i = n.find("input:checked"),
							a = "",
							s = (t.data("option") || t.find("option:selected").data("option"),
								$("[data-image-color]")),
							c = !0;
							//console.log("E===");
							//console.log(e);
						if ("color" === t.closest(".product__variant").data("option")) {
							var l = $(
								'.product-single .product__variant[data-option="color"] input:checked'
							).data("value");
							d(l)
						}
						//weblife2022-09-15
						/*
						if ("color" === t.closest(".product__variant").data("option")) {
							$(".custom-select").val("selectasize"),
								r(t.closest("form").find(".product__submit .btn"), __GLOBAL__.locale
									.products.product.sold_out, !1);
							var u = t.val(),
								f = p.find("option[data-color=".concat(u, "]"));
							$("input[name=size]").prop("disabled", !0), f.each((function() {
								var n = $(this);
								n.attr("data-size") === e && ($("#product-select").val(n.val()),
									$(this).closest("form"), $(this).closest(
										"form select[name=size]").val(e)), n.prop("disabled") ? t.closest(
									".product__variants").find(
									'.product__variant[data-option="size"]').find('input[value="'
									.concat(n.data("size"), '"]')).prop("disabled", !0) : t.closest(
									".product__variants").find(
									'.product__variant[data-option="size"]').find('input[value="'
									.concat(n.data("size"), '"]')).prop("disabled", !1)
							}))
						}
						*/
						if ("カラー" === t.closest(".product__variant").data("option")) {
							//console.log(111);
							$(".custom-select").val("selectasize"),
								r(t.closest("form").find(".product__submit .btn"), __GLOBAL__.locale
									.products.product.sold_out, !1);
							//console.log(222);
							var u = t.val(),
								f = p.find("option[data-カラー=".concat(u, "]"));
							//console.log(u);
							//console.log(f.val());
							$("input[name=サイズ]").prop("disabled", !0),
							f.each((function() {
								var n = $(this);
								n.attr("data-サイズ") === e && ($("#product-select").val(n.val())
									,$(this).closest("form")
									,$(this).closest("form select[name=size]").val(e))
									,n.prop("disabled") 
										? t.closest(".product__variants").find('.product__variant[data-option="サイズ"]').find('input[value="'.concat(n.data("サイズ"), '"]')).prop("disabled", !0) 
										: t.closest(".product__variants").find('.product__variant[data-option="サイズ"]').find('input[value="'.concat(n.data("サイズ"), '"]')).prop("disabled", !1)
									,n.prop("disabled") 
									? $('select#custom-select option[value="' + n.data("サイズ") +'"]').prop("disabled", !0) 
									: $('select#custom-select option[value="' + n.data("サイズ") +'"]').prop("disabled", !1)
							}))
						}
						if (
							"color" === t.attr("name") && (s.addClass("hidden")
								, s.each((
									function() {
										if ($(this).data("image-color") === t.data("value")) {
											($(this).removeClass("hidden"), c = !1);
										}
										else {
											$(this).addClass("hidden");
										}
									})
								)
								, c && s.removeClass("hidden"))
								, t.is("input") || (i = t.closest(".product__variants").find('.product__variant[data-option="カラー"] input:checked'), o.each((//weblife2022-09-09
								function() {
									var e = $(this),
										t = e.closest(".product__variant").data("option");
									a += "[data-".concat(t, '="').concat(e.val(), '"]')
								})))
								, i.each((
									function() {
										var e = $(this),
											t = e.closest(".product__variant").data("option");
										a += "[data-".concat(t, '="').concat(e.val(), '"]')
										//console.log("次の次のA===");
										//console.log(a);
									})
								)
								, i.length === n.find(".product__variant[data-option]").length || !t.is("input")
						)
						if (0 < p.find("option" + a).length){
							//console.log("最終的なA===");
							//console.log(a);
							p.find("option" + a).prop("selected", !0).trigger("change");
						}
						else {
							r(t.closest("form").find(".product__submit .btn"), __GLOBAL__.locale.products.product.sold_out, !0);
						}
						t.closest(".product__variant").siblings(), setTimeout((function() {
							n.find(".selectric-wrapper").length && n.find(
								".selectric-wrapper select").selectric("refresh")
						}), 10), document.querySelectorAll("li.product-image").forEach((
							function(e) {
								e.classList.remove("hidden-xs")
							}));
						var h = document.querySelector("li.product-image:not(.hidden) img");
						h && (document.querySelector(".product__image img").src = h.getAttribute(
							"data-src"), document.querySelector(
							"li.product-image:not(.hidden)").classList.add("hidden-xs"))
					}))
					,$(".product__variant li input:enabled").first().trigger("change")
		})), p.on("change", (function() {
			var e = $(this),
				t = e.closest(".js-product"),
				n = e.find("option:selected"),
				o = $(".product__submit .btn"),
				i = $(".product__price .product__price-total"),
				a = $(".product__price .product__price-compared"),
				s = $(".product__sale"),
				c = $(".accordion-products"),
				l = n.data("final_sale"),
				u = n.data("price"),
				d = n.data("compared_price") || "",
				f = n.data("inventory");
			//weblife2022-09-09
			var variant_price = n.data("variant_price");
			var price_num = Number(u.replace(/[^0-9]/g, ""));
			var compared_price_num = (d != "" ) ? Number(d.replace(/[^0-9]/g, "")):0;
			/*
			if (c.find('.accordion__section[data-variant_id="'.concat(n.val(), '"]'))
				.show().siblings(':not(.accordion__section[data-variant_id="'.concat(n.val(),
					'"])')).hide(), l ? s.show() : s.hide(), n.prop("disabled") ? r(o,
					__GLOBAL__.locale.products.product.sold_out, !0) : r(o, __GLOBAL__.locale
					.products.product.add_to_cart, !1), i.text(u), a.text(d), "" === d ? i
				.removeClass("compared") : i.addClass("compared"), void 0 !== f && 0 <
				f && 3 > f) {
			*/
			//console.log('Step1');
			//console.log(n.val());
			if (c.find('.accordion__section[data-variant_id="'.concat(n.val(), '"]')).show().siblings(':not(.accordion__section[data-variant_id="'.concat(n.val(),'"])')).hide()
				, l ? s.show() : s.hide()
				, n.prop("disabled") ? r(o,__GLOBAL__.locale.products.product.sold_out, !0) : r(o, __GLOBAL__.locale.products.product.add_to_cart, !1)
				, a.text(d)
				, i.text(variant_price) //weblife2022-09-09
				, compared_price_num <= price_num ? a.addClass("hide") : a.removeClass("hide") //weblife2022-09-09
				, compared_price_num <= price_num ? i.removeClass("compared") : i.addClass("compared") //weblife2022-09-09
				, void 0 !== f && 0 < f && 3 > f) {
				var p = !1;
				768 > $(window).width() && t.find(
					".custom-select-wrapper select.custom-select").each((function(e, t) {
					"selectasize" === $(t).val() && (p = !0)
				})), p ? ($(".js-low-inventory").removeClass("active"), setTimeout((
					function() {
						$(".js-low-inventory-stock").html(0)
					}), 300)) : ($(".js-low-inventory").addClass("active"), $(
					".js-low-inventory-stock").html(f))
			} else $(".js-low-inventory").removeClass("active"), setTimeout((
				function() {
					$(".js-low-inventory-stock").html(0)
				}), 300)
		})), p.length) && p.find("option").each((function() {
			$(this).prop("disabled")
		}));
		p.length && function() {
			for (var e = !0, t = p.closest("form"), n = p.find("option"), r = function(r) {
					var o = p.find("option:selected").data("option-".concat(r));
					if (void 0 !== o) {
						var i = t.find('input[data-option="'.concat(r, '"][data-value="').concat(o, '"]'));
						n.each((function() {
							var e = $(this),
								n = e.data("option-".concat(r)),
								o = t.find('input[data-option="'.concat(r, '"][data-value="').concat(
									n, '"]'));
							e.prop("disabled") || o.prop("disabled", !1)
						}));
						i.length && (i.prop("checked", !0).trigger("change"), e = !1);
					}
				}, o = 1; 3 >= o; o++) r(o);
			e && t.find("[data-option][data-value]").attr("disabled", "disabled")
		}(), f.on("click", ".js-form-product .js-btn-product", (function(e) {
			e.preventDefault();
			var t = $(this).closest("form");
			Object(l.addToCart)(t, !0)
		})), f.on("change", ".js-radio-color-item input", (function() {
			var e = $(this),
				t = e.data("index"),
				n = e.data("option"),
				r = e.data("value"),
				o = e.closest(".js-product-item");
			o.find(".product-item__image figure").eq(t).addClass("expanded").siblings()
				.removeClass("expanded"), o.find(
					".js-product-item-select option[data-option-".concat(n, '="').concat(r,
						'"]')).prop("selected", "selected");
			var i = o.find(".js-product-item-select option:selected").data("price");
			o.find(".js-product-item-price").length && o.find(
				".js-product-item-price").html(i)
		})), f.on("mouseenter", ".js-radio-color-item label", (function() {
			var e = $(this);
			Object(u.productItemHover)(e, !0)
		})).on("mouseleave", ".js-radio-color-item label", (function() {
			var e = $(this);
			Object(u.productItemHover)(e, !1)
		})), $(window).on("load", (function() {
			if ($(".section-collection-slider .slider-arrows__pages .last").text($(
					".section-collection-slider .slick-dots li").length), $(
					".section-stores .slider-arrows__pages .last").text($(
					".section-stores .slick-dots li").length), $(".section-product").length) {
				var e = $(".section-product .product__variants"),
					t = $(
						'.product-single .product__variant[data-option="color"] input:checked'
					).data("value");
				d(t);
				var n = $(
					'.product-single .product__variant[data-option="color"] input:checked'
				).val();
				$("#product-select").find("option[data-color=".concat(n, "]")).each((
					function() {
						var t = $(this);
						t.prop("disabled") ? e.find('.product__variant[data-option="size"]')
							.find('input[value="'.concat(t.data("size"), '"]')).prop(
								"disabled", !0) : e.find('.product__variant[data-option="size"]')
							.find('input[value="'.concat(t.data("size"), '"]')).prop(
								"disabled", !1)
					}))
			}
			$(".store-single").length && $(".store-single .store__body img").each((
				function() {
					var e = $(this);
					e.next("img").length && e.parent().addClass("flex")
				}))
		}));
		var h = n(1),
			m = $(document),
			g = $(window),
			v = !1;
		g.on("load", (function() {
			// if(window.innerWidth >= 1024) {
			// 	$("header").addClass('hover');
			// }
			!h.get("saturdaysnyc-newsletter") && 0 > window.location.toString().indexOf(
				"products") ? setTimeout((function() {
				$("#popup-newsletter").addClass("visible")
			}), 4e3) : $("#popup-newsletter").remove();
			var e = $("#popup-notice");
			!h.get("saturdaysnyc-notice") && 0 < e.length ? e.addClass("visible") :
				e.remove()
		})), m.on("submit", "#popup-newsletter .form-newsletter form", (function(e) {
			var t = $(this),
				n = t.closest("form").find(".form__actions input");
			v ? h.set("saturdaysnyc-newsletter", 1, {
				expires: 365
			}) : (e.preventDefault(), n.is(":checked") ? (v = !0, t.trigger(
				"submit")) : n.closest(".checkbox").addClass("error"))
		})), m.on("click",
			".popup-notice .popup__close, .popup-notice .popup__actions a", (function(
				e) {
				e.preventDefault();
				var t = $(this),
					n = $("#popup-notice");
				n.removeClass("visible"), t.hasClass("popup__close") ? h.set(
					"saturdaysnyc-notice", 1) : h.set("saturdaysnyc-notice", 1, {
					expires: 365
				}), setTimeout((function() {
					n.remove()
				}), 400)
			})), m.on("click", ".popup-newsletter .popup__close", (function(e) {
			e.preventDefault(), $("#popup-newsletter").removeClass("visible"), h.set(
				"saturdaysnyc-newsletter", 1)
		})), window.addEventListener("klaviyoForms", (function(e) {
			"submit" === e.detail.type && $(".js-popup-newsletter").addClass(
				"success")
		}));
		n(10), n(11), n(12);
		m.on("click", ".js-qty span", (function() {
			var e = $(this),
				t = e.parent(),
				n = t.find("input"),
				r = n.val();
			r = $.isNumeric(r) ? r : 0;
			var o = e.closest("form");
			e.hasClass("qty__btn--plus") ? r = 0 > ++r ? 1 : r : r = 0 > --r ? 0 : r,
				n.val(r), e.closest(".js-widget-cart").length && (t.addClass(
					"qty--prevent"), Object(l.updateCart)(o, !0, void 0)), e.closest(
					".js-section-cart").length && (t.addClass("qty--prevent"), Object(l.updateCart)
					(o, !1, void 0))
		}));
		var y = $(document),
			b = ($(window), $(".js-widget-cart"));
		y.on("click", ".js-btn-cart", (function(e) {
			e.preventDefault(), $(this), b.hasClass("expanded") || Object(l.ajaxCart)
				(!0)
		})), y.on("click", ".js-cart-remove", (function(e) {
			e.preventDefault();
			var t = $(this),
				n = t.closest("form"),
				r = parseInt(t.attr("href"));
			t.closest(".js-widget-cart").length ? Object(l.updateCart)(n, !0, r) :
				Object(l.updateCart)(n, !1, r)
		})), y.on("click", (function(e) {
			var t = $(e.target);
			t.hasClass("js-widget-cart") || t.closest(".js-widget-cart").length || $(
				".js-widget-cart").removeClass("expanded")
		}));
		n(13), n(14), n(15), n(16), n(17), n(18), n(19)
	},
	function() {}
]);
